import React, { PureComponent } from "react";
import Cookies from "universal-cookie";
import { withRouter, Link } from "react-router-dom";
import "./Navigation.scss";
import CityDashboard from "../../routes/cityDashboard/CityDashboard";
import DistrictDashboard from "../../routes/districtDashboard/DistrictDashboard";
import axios from "axios";
import ReconnectingWebSocket from "reconnecting-websocket";
import { CAMS_URL, FETCH_URL } from "../../constants/ServerLinks";
import Snackbar from "@material-ui/core/Snackbar";
import Button from "@material-ui/core/Button/Button";
import AccountBook from "../account-book/AccountBook";
import PolicyHistory from "../policy-history/PolicyHistory";
import policyJSON from "../../assets/data/policies27Feb2020_1420.json";
import zoneVarJSON from "../../assets/data/zoneVarMix.json";
import engagementJSON from "../../assets/data/engagement.json";
import Footer from "../footer/Footer";
import Messages from "../messages/Messages";

const City = 1;
// const District = 2;
const LINKS = 10;

class Navigation extends PureComponent {
  constructor(props) {
    super(props);
    this.fetchURL = FETCH_URL;
    this.camsURL = CAMS_URL;
    this.cookies = new Cookies();
    this.sName = this.cookies.get("s_name");
    this.sEmail = this.cookies.get("s_email");
    this.game_code = this.cookies.get("game_code");
    this.city_id = this.cookies.get("city_id");
    this.city_skey = this.cookies.get("city_skey");
    this.city_name = this.cookies.get("city_name");
    this.p_id = this.cookies.get("p_id");
    this.origin = this.cookies.get("origin");

    //--This city configuration to remain set until JSON is reconfigured for multiple configurations -- //
    this.city_config = 1;

    // --Below city config for future dynamic selection of JSON -- //
    // this.city_config = this.cookies.get("city_config");

    this.student_is_manager = this.cookies.get("student_is_manager");
    this.student_role = this.cookies.get("student_role");
    this.student_team_name = this.cookies.get("student_team_name");
    this.delay = (ms) => new Promise((res) => setTimeout(res, ms));
    this.worldEventSource = null;
    this.ws_scheme = window.location.protocol === "https:" ? "wss" : "ws";
    this.socket = null;

    this.state = {
      districtEngagementData: engagementJSON,
      cityPolicies: policyJSON
        .filter((item) => item.configuration === parseFloat(this.city_config))
        .filter((item) => item.sector === "City"),
      citySelections: policyJSON
        .filter((item) => item.configuration === parseFloat(this.city_config))
        .filter((item) => item.sector === "City")
        .map((item) => [item.polindex, item.defaultValue]),
      districtPolicies: policyJSON
        .filter((item) => item.configuration === parseFloat(this.city_config))
        .filter((item) => item.sector === this.districtName),
      distrtictSelections: policyJSON
        .filter((item) => item.configuration === parseFloat(this.city_config))
        .filter((item) => item.sector === this.districtName)
        .map((item) => [item.polindex, item.defaultValue]),
      districtPolicyData: policyJSON.filter(
        (item) => item.configuration === parseFloat(this.city_config)
      ),
      selected: "City",
      districtName: "City",
      CorbusvilleHover: false,
      DowntownHover: false,
      HowardHover: false,
      JacobsHover: false,
      MosesHover: false,
      totalEngagement: sessionStorage.getItem("totalEngagement"),
      currentEngagement: sessionStorage.getItem("currentEngagement"),
      engageObj: {},
      subPolicy: "",
      prevDiff: null,
      engagementCounter: sessionStorage.getItem("engagementCounter"),
      logoutConfirm: null,
      snackMsg: "Welcome!",
      snackOpen: false,
      snackType: "snack-success",
      snackAutoHideDuration: null,
      accountBook: false,
      policyHistory: false,
      allPolicyData: null,
      InformSubmitted: 0,
      metricsJSON: "",
      forecastJSON: "",
      metricsSelections: [],
      selectedMetric: "",
      selectedPlotData1: [],
      selectedPlotData2: [],
      selectedForecastPlotData1: [],
      selectedForecastPlotData2: [],
      combinedPlotData1: [],
      combinedPlotData2: [],
      combinedDistrictPlotData: [],
      selectedDistrictPlotData: [],
      selectedDistrictMetric: "",
      selectedForecastDistrictPlotData: [],
      plotType1: "",
      plotType2: "",
      OverviewPlotType: "",
      districtPlotType: "",
      disabledButton: false,
      currentYear: sessionStorage.getItem("current_year"),
      previousYear: sessionStorage.getItem("previous_year"),
      submitted: false,
      submittedValue: null,
      suspendButton: false,
      forecasting: false,
      costSelections: [],
      nowCosts: [],
      nowRevenue: [],
      revenueSelections: [],
      selectionAvailable: true,
      cityCurrent: [],
      districtCurrent: [],
      everythingTable: [],
      citySubPolicyDefaultValue: sessionStorage.getItem(
        `City/${this.citySubPolicy}`
      ),
      citySubPolicyPrevtValue: sessionStorage.getItem(
        `${sessionStorage.getItem("previous_year")}/City/${this.citySubPolicy}`
      ),
      districtSubPolicyDefaultValue: sessionStorage.getItem(
        `${this.districtName}/${this.districtSubPolicy}`
      ),
      districtSubPolicyPrevtValue: sessionStorage.getItem(
        `${sessionStorage.getItem("previous_year")}/${this.districtName}/${
          this.districtSubPolicy
        }`
      ),
      citySubPolicy: "",
      citySubmitted: false,
      districtSubmitted: false,
      remainingForecastAttempts: "...",
      districtSubPolicy: "",
      corbusville: sessionStorage.getItem("Corbusville")
        ? JSON.parse(sessionStorage.getItem("Corbusville")).pollist
        : policyJSON
            .filter(
              (item) => item.configuration === parseFloat(this.city_config)
            )
            .filter((item) => item.sector === "Corbusville")
            .map((item) => [item.polindex, item.defaultValue]),
      downtown: sessionStorage.getItem("Downtown")
        ? JSON.parse(sessionStorage.getItem("Downtown")).pollist
        : policyJSON
            .filter(
              (item) => item.configuration === parseFloat(this.city_config)
            )
            .filter((item) => item.sector === "Downtown")
            .map((item) => [item.polindex, item.defaultValue]),
      howard_gardens: sessionStorage.getItem("Howard Gardens")
        ? JSON.parse(sessionStorage.getItem("Howard Gardens")).pollist
        : policyJSON
            .filter(
              (item) => item.configuration === parseFloat(this.city_config)
            )
            .filter((item) => item.sector === "Howard Gardens")
            .map((item) => [item.polindex, item.defaultValue]),
      jacobs_hill: sessionStorage.getItem("Jacobs Hill")
        ? JSON.parse(sessionStorage.getItem("Jacobs Hill")).pollist
        : policyJSON
            .filter(
              (item) => item.configuration === parseFloat(this.city_config)
            )
            .filter((item) => item.sector === "Jacobs Hill")
            .map((item) => [item.polindex, item.defaultValue]),
      moses_gulch: sessionStorage.getItem("Moses Gulch")
        ? JSON.parse(sessionStorage.getItem("Moses Gulch")).pollist
        : policyJSON
            .filter(
              (item) => item.configuration === parseFloat(this.city_config)
            )
            .filter((item) => item.sector === "Moses Gulch")
            .map((item) => [item.polindex, item.defaultValue]),
      zoneSelections: zoneVarJSON.filter(
        (item) => item.sector === this.districtName
      ),
      zoneVarsOnly: null,
      start: 0,
      stop: 8,
      Commercial: parseInt(
        sessionStorage.getItem(`${this.districtName}/Commercial`)
      ),
      Green: parseInt(sessionStorage.getItem(`${this.districtName}/Green`)),
      Mixed: parseInt(sessionStorage.getItem(`${this.districtName}/Mixed`)),
      Residential: parseInt(
        sessionStorage.getItem(`${this.districtName}/Residential`)
      ),
      Parking: parseInt(sessionStorage.getItem(`${this.districtName}/Parking`)),
      Total: null,
      policyNavSelection: "Loading...",
      engagementData: "",
      parkingZone: "",
      submitting: false,
      engagementDefaultValue: sessionStorage.getItem(
        `${props.districtName}/${this.subPolicy}`
      ),
      Inform: 0,
      InformTarget: 0,
      InformLock: false,
      InformMax: 9,
      InformMaxReached: false,
      InformObj: {},
      Consult: 0,
      ConsultTarget: 0,
      ConsultLock: true,
      ConsultDisabled: true,
      ConsultMax: 30,
      ConsultMaxReached: false,
      ConsultObj: {},
      ConsultSubmitted: 0,
      Involve: 0,
      InvolveTarget: 0,
      InvolveLock: true,
      InvolveDisabled: true,
      InvolveMax: 30,
      InvolveMaxReached: false,
      InvolveObj: {},
      InvolveSubmitted: 0,
      Collaborate: 0,
      CollaborateTarget: 0,
      CollaborateLock: true,
      CollaborateDisabled: true,
      CollaborateMax: 60,
      CollaborateObj: {},
      CollaborateMaxReached: false,
      CollaborateSubmitted: 0,
      categoryTotal: 0,
      engagementSubPolicy: "",
      fact_sheets: false,
      website: false,
      newsletter: false,
      open_house: false,
      surveys: false,
      focus_groups: false,
      public_meetings: false,
      public_forums: false,
      utilizing_social_media: false,
      deliberative_polling: false,
      workshops: false,
      charrettes: false,
      consensus_building: false,
      citizens_juries: false,
      advisory_board: false,
      engagementSuspended: false,
      toolTipMessage: "",
      policySuspended: false,
      navWidth: -400,
      navLinks: [
        {
          name: "Frank Batten School",
          href: "https://batten.virginia.edu",
          icon: "iconBatten",
          text: "textBatten",
          target: "_blank",
        },
        {
          name: "CLSG",
          href: "https://www.clsgbatten.org",
          icon: "iconClsg",
          text: "textClsg",
          target: "_blank",
        },
      ],
      messageDivVisibility: "hidden",
      messageMessage: null,
      messageType: null,
      messageFunction: null,
    };
  }

  //FUNCTIONS FROM CITYDASHBOARD

  fetchCityMetrics = (city_skey) => {
    this.setState({ selectionAvailable: false });
    axios
      .get(this.fetchURL + "/api/v1/city_metrics/", {
        params: { city_skey: city_skey },
      })
      .then((response) => {
        // console.groupCollapsed("Navigation:fetchCityMetrics");
        if (response.data.success) {
          // console.log("success!!!");
          // console.log(
          //   "Fetching City Metrics from Back End...(metrics data)...:  ",
          //   JSON.parse(response.data.data.city.city_metrics)
          // );
          // console.log(typeof response.data.data.city.engagement);
          if (response.data.data.city.engagement === "{}") {
            // console.log("Yup.");
          }
          if (response.data.data.city.engagement !== "{}") {
            // console.log(
            //   " ...engagement... " +
            //   JSON.stringify(response.data.data.city.engagement) +
            //   " current engagement: " +
            //   JSON.parse(response.data.data.city.engagement)
            //     .currentEngagement +
            //   " engage Obj: " +
            //   JSON.parse(
            //     JSON.parse(response.data.data.city.engagement).engageObj
            //   )
            // );

            sessionStorage.setItem(
              `engagement`,
              JSON.stringify({
                city_id: parseFloat(this.city_id),
                engagement: JSON.parse(response.data.data.city.engagement),
              })
            );
            sessionStorage.setItem(
              "currentEngagement",
              JSON.parse(response.data.data.city.engagement).currentEngagement
            );

            sessionStorage.setItem(
              "totalEngagement",
              JSON.parse(response.data.data.city.engagement).totalEngagement
            );

            sessionStorage.setItem(
              "engagementCounter",
              JSON.parse(response.data.data.city.engagement).totalEngagement
            );

            if (JSON.parse(response.data.data.city.engagement).Inform) {
              sessionStorage.setItem(
                "Inform",
                JSON.parse(response.data.data.city.engagement).Inform
              );
              sessionStorage.setItem(
                "InformSubmitted",
                JSON.parse(response.data.data.city.engagement).Inform
              );
              sessionStorage.setItem(
                "InformTarget",
                JSON.parse(response.data.data.city.engagement).InformTarget
              );
              // sessionStorage.setItem("InformObj", JSON.parse(response.data.data[0].city.engagement).InformObj)
              sessionStorage.setItem(
                "InformLock",
                JSON.parse(response.data.data.city.engagement).InformLock
              );
              // sessionStorage.setItem("InformMaxReached", JSON.parse(response.data.data[0].city.engagement).InformMaxReached)
              this.setState({
                Inform: JSON.parse(response.data.data.city.engagement).Inform,
                InformTarget: JSON.parse(response.data.data.city.engagement)
                  .InformTarget,
                // InformObj: JSON.parse(JSON.parse(response.data.data[0].city.engagement).InformObj),
                InformLock: JSON.parse(response.data.data.city.engagement)
                  .InformLock,
                // InformMaxReached: JSON.parse(response.data.data[0].city.engagement).InformMaxReached,
              });
            }
            console.log(JSON.parse(response.data.data.city.engagement).Consult);
            if (JSON.parse(response.data.data.city.engagement).Consult) {
              sessionStorage.setItem(
                "Consult",
                JSON.parse(response.data.data.city.engagement).Consult
              );
              sessionStorage.setItem(
                "ConsultTarget",
                JSON.parse(response.data.data.city.engagement).ConsultTarget
              );
              sessionStorage.setItem(
                "ConsultLock",
                JSON.parse(response.data.data.city.engagement).ConsultLock
              );
              // sessionStorage.setItem("ConsultMaxReached", JSON.parse(response.data.data[0].city.engagement).ConsultMaxReached)
              // sessionStorage.setItem("ConsultObj", JSON.parse(response.data.data[0].city.engagement).ConsultObj)
              this.setState({
                Consult: JSON.parse(response.data.data.city.engagement).Consult,
                ConsultTarget: JSON.parse(response.data.data.city.engagement)
                  .ConsultTarget,
                ConsultLock: JSON.parse(response.data.data.city.engagement)
                  .ConsultLock,
                // ConsultMaxReached: JSON.parse(response.data.data[0].city.engagement).ConsultMaxReached,
                // ConsultObj: JSON.parse(JSON.parse(response.data.data[0].city.engagement).ConsultObj),
              });
            }
            if (JSON.parse(response.data.data.city.engagement).Involve) {
              sessionStorage.setItem(
                "Involve",
                JSON.parse(response.data.data.city.engagement).Involve
              );
              // sessionStorage.setItem("InvolveObj", JSON.parse(response.data.data[0].city.engagement).InvolveObj)
              sessionStorage.setItem(
                "InvolveTarget",
                JSON.parse(response.data.data.city.engagement).InvolveTarget
              );
              sessionStorage.setItem(
                "InvolveLock",
                JSON.parse(response.data.data.city.engagement).InvolveLock
              );
              // sessionStorage.setItem("InvolveMaxReached", JSON.parse(response.data.data[0].city.engagement).InvolveMaxReached)
              this.setState({
                Involve: JSON.parse(response.data.data.city.engagement).Involve,
                // InvolveObj: JSON.parse(JSON.parse(response.data.data[0].city.engagement).InvolveObj),
                InvolveTarget: JSON.parse(response.data.data.city.engagement)
                  .InvolveTarget,
                InvolveLock: JSON.parse(response.data.data.city.engagement)
                  .InvolveLock,
                // InvolveMaxReached: JSON.parse(response.data.data[0].city.engagement).InvolveMaxReached,
              });
            }
            if (JSON.parse(response.data.data.city.engagement).Collaborate) {
              sessionStorage.setItem(
                "Collaborate",
                JSON.parse(response.data.data.city.engagement).Collaborate
              );
              // sessionStorage.setItem("CollaborateObj", JSON.parse(response.data.data[0].city.engagement).CollaborateObj)
              sessionStorage.setItem(
                "CollaborateTarget",
                JSON.parse(response.data.data.city.engagement).CollaborateTarget
              );
              sessionStorage.setItem(
                "CollaborateLock",
                JSON.parse(response.data.data.city.engagement).CollaborateLock
              );
              // sessionStorage.setItem("CollaborateMaxReached", JSON.parse(response.data.data[0].city.engagement).CollaborateMaxReached)
              this.setState({
                Collaborate: JSON.parse(response.data.data.city.engagement)
                  .Collaborate,
                // CollaborateObj: JSON.parse(JSON.parse(response.data.data[0].city.engagement).CollaborateObj),
                CollaborateTarget: JSON.parse(
                  response.data.data.city.engagement
                ).CollaborateTarget,
                CollaborateLock: JSON.parse(response.data.data.city.engagement)
                  .CollaborateLock,
                // CollaborateMaxReached: JSON.parse(response.data.data[0].city.engagement).CollaborateMaxReached,
              });
            }

            this.setState({
              engagementData: JSON.parse(response.data.data.city.engagement),
              currentEngagement: JSON.parse(response.data.data.city.engagement)
                .currentEngagement,
              totalEngagement: JSON.parse(response.data.data.city.engagement)
                .totalEngagement,
              engagementCounter: JSON.parse(response.data.data.city.engagement)
                .totalEngagement,
              // engageObj: JSON.parse(JSON.parse(response.data.data.city.engagement).engageObj),
            });
          }

          if (
            JSON.parse(response.data.data.city.engagement).totalEngagement > 20
          ) {
            console.log("total Engagement greater than 20");
            this.setState({
              toolTipMessage: "",
              policySuspended: false,
            });
          } else if (
            JSON.parse(response.data.data.city.engagement).totalEngagement <=
              20 &&
            JSON.parse(response.data.data.city.engagement).totalEngagement >
              0 &&
            !this.state.engagementSuspended === true
          ) {
            this.setState({
              toolTipMessage:
                "Community Engagement getting low, please increase engagement by going to the engagement policy panel.",
              policySuspended: false,
            });
          } else if (
            JSON.parse(response.data.data.city.engagement).totalEngagement <= 0
          ) {
            this.setState({
              toolTipMessage:
                "Policy selection has been suspended due to nagative community engagement, please increase engagement by going to the engagement policy panel.",
              policySuspended: true,
            });
          }

          this.setState({
            metricsJSON: JSON.parse(response.data.data.city.city_metrics),
            currentYear: JSON.parse(response.data.data.city.current_year) + 1,
            previousYear: JSON.parse(response.data.data.city.current_year),
            remainingForecastAttempts: JSON.parse(
              response.data.data.city.forecast_attempts
            ),
          });
          let metricArr = [];
          let costArr = [];
          let revArr = [];
          for (let item in JSON.parse(response.data.data.city.city_metrics)) {
            //--Parking Value

            if ([item][0] === "District Road And Parking Portion Now") {
              // console.log(
              //   JSON.parse(response.data.data.city.city_metrics)[item][0]
              // );
              this.setState({
                parkingZone: JSON.parse(response.data.data.city.city_metrics)[
                  item
                ][0],
              });
            }
            //---Non Cost Metrics
            if (
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "districtcostcurrent" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "citycostscurrent" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "districtparkingcurrent" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "districtcost" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "citycost" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "cityrevenuecurrent" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "cityrevenue" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "districtrevenuecurrent" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "districtrevenue" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "districtcurrent" &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].type !==
                "citycurrent"
            ) {
              metricArr.push(item);
              // console.log(metricArr)
              metricArr.sort();

              this.setState({
                metricsSelections: metricArr,
              });
            }
            //--Cost Metrics
            if (
              (JSON.parse(response.data.data.city.city_metrics)[item][0]
                .type === "districtcost" ||
                JSON.parse(response.data.data.city.city_metrics)[item][0]
                  .type === "citycost") &&
              !JSON.parse(response.data.data.city.city_metrics)[item][0]
                .category
            ) {
              costArr.push(item);
              // console.log(costArr)
              costArr.sort();

              this.setState({
                costSelections: costArr,
              });
            }
            if (
              (JSON.parse(response.data.data.city.city_metrics)[item][0]
                .type === "districtrevenue" ||
                JSON.parse(response.data.data.city.city_metrics)[item][0]
                  .type === "cityrevenue") &&
              !JSON.parse(response.data.data.city.city_metrics)[item][0]
                .category
            ) {
              revArr.push(item);
              // console.log(revArr)
              revArr.sort();

              this.setState({
                revenueSelections: revArr,
              });
            }
            //--Current Revenue Metrics
            if (
              JSON.parse(response.data.data.city.city_metrics)[item][0].type ===
                "cityrevenuecurrent" ||
              JSON.parse(response.data.data.city.city_metrics)[item][0].type ===
                "districtrevenuecurrent"
            ) {
              this.setState({
                nowRevenue: this.state.nowRevenue.concat(item),
              });
            }
            //Current Cost Metrics
            if (
              JSON.parse(response.data.data.city.city_metrics)[item][0].type ===
                "districtcostcurrent" ||
              JSON.parse(response.data.data.city.city_metrics)[item][0].type ===
                "citycostscurrent" ||
              JSON.parse(response.data.data.city.city_metrics)[item][0].type ===
                "districtparkingcurrent"
            ) {
              this.setState({
                nowCosts: this.state.nowCosts.concat(item),
              });
            }
            let currentObj = {};
            if (
              JSON.parse(response.data.data.city.city_metrics)[item][0].type ===
              "citycurrent"
            ) {
              currentObj[item.replace(" Now", "")] = JSON.parse(
                response.data.data.city.city_metrics
              )[item];
              this.setState({
                cityCurrent: this.state.cityCurrent.concat(currentObj),
              });
            }
            let districtCurrentObj = {};
            if (
              JSON.parse(response.data.data.city.city_metrics)[item][0].type ===
              "districtcurrent"
            ) {
              // console.log(JSON.parse(response.data.data[0].city.city_metrics)[item][0])
              districtCurrentObj[item.replace(" Now", "")] = JSON.parse(
                response.data.data.city.city_metrics
              )[item];
              this.setState({
                districtCurrent: this.state.districtCurrent.concat(
                  districtCurrentObj
                ),
              });
            }
            let everythingObj = {};
            let costRevObj = {};
            let costRevArr = [];
            if (
              (JSON.parse(response.data.data.city.city_metrics)[item][0]
                .type === "cityrevenue" ||
                JSON.parse(response.data.data.city.city_metrics)[item][0]
                  .type === "districtrevenue" ||
                JSON.parse(response.data.data.city.city_metrics)[item][0]
                  .type === "districtcost" ||
                JSON.parse(response.data.data.city.city_metrics)[item][0]
                  .type === "citycost") &&
              JSON.parse(response.data.data.city.city_metrics)[item][0].category
            ) {
              everythingObj[item.replace(" Table", "")] = JSON.parse(
                response.data.data.city.city_metrics
              )[item];

              //--Attempting to rebuild array for easier sorting...
              // console.log(
              //   JSON.parse(response.data.data.city.city_metrics)[item]
              // );
              for (
                let i = 0;
                i <
                JSON.parse(response.data.data.city.city_metrics)[item].length;
                i++
              ) {
                // console.log(
                //   JSON.parse(response.data.data.city.city_metrics)[item][i]
                // );
                costRevObj["name"] = item.replace(" Table", "");
                costRevObj["year"] = JSON.parse(
                  response.data.data.city.city_metrics
                )[item][i].year;
                costRevObj["City"] = JSON.parse(
                  response.data.data.city.city_metrics
                )[item][i].City;
                costRevArr.push(costRevObj);
              }

              // console.log(costRevObj);
              // console.log(costRevArr);

              //----
            }
            if (Object.entries(everythingObj).length !== 0) {
              this.setState({
                everythingTable: this.state.everythingTable.concat(
                  everythingObj
                ),
              });
            }

            this.setState({ selectionAvailable: true });
          }
          sessionStorage.setItem(
            "current_year",
            JSON.parse(response.data.data.city.current_year) + 1
          );
          sessionStorage.setItem(
            "previous_year",
            JSON.parse(response.data.data.city.current_year)
          );
        }
        console.groupEnd();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  fetchPolicies = (city_id) => {
    axios
      .get(this.fetchURL + "/api/v1/policies/submissions/", {
        params: { city_id: city_id },
      })
      .then((response) => {
        if (response.data.success) {
          let testArr = response.data.data.map((item) => ({
            district_name: item.district_name,
            year: Object.keys(JSON.parse(item.policy_submissions)),
            policy_submittions: [
              {
                policies: Object.values(
                  JSON.parse(item.policy_submissions)
                ).map((group) => ({
                  policyName: group.map(
                    (number) =>
                      policyJSON.filter(
                        (item) => item.polindex === number[0]
                      )[0].name
                  ),
                  policyChoice: group.map(
                    (choice) =>
                      policyJSON.filter(
                        (item) => item.polindex === choice[0]
                      )[0].parameters[parseInt(choice[1])].name
                  ),
                })),
              },
            ],
            zone_variables: [JSON.parse(item.zone_variables)],
          }));
          console.log(testArr);
          let policies = response.data.data;
          this.setState({
            allPolicyData: testArr,
          });

          for (let i = 0; i < policies.length; i++) {
            for (let year in JSON.parse(response.data.data[i].zone_variables)) {
              // console.log(policies[i].district_name);
              for (let item in JSON.parse(response.data.data[i].zone_variables)[
                year
              ]) {
                // console.log(item);
                // console.log(
                //   JSON.parse(response.data.data[i].zone_variables)[year][item]
                // );
                // console.log("Inside the zone variables loop...");
                let polVarName = item;
                // console.log("polVarName: " + polVarName);
                let polVarVal = JSON.parse(
                  response.data.data[i].zone_variables
                )[year][item];
                if (polVarName.includes("CommPortion")) {
                  sessionStorage.setItem(
                    `${response.data.data[i].district_name}/Commercial`,
                    polVarVal
                  );
                  // console.log("CommPortion: ", polVarVal);
                } else if (polVarName.includes("OpenSpacePortion")) {
                  sessionStorage.setItem(
                    `${response.data.data[i].district_name}/Green`,
                    polVarVal
                  );
                } else if (polVarName.includes("MultiUsePortion")) {
                  sessionStorage.setItem(
                    `${response.data.data[i].district_name}/Mixed`,
                    polVarVal
                  );
                } else if (polVarName.includes("SingleUsePortion")) {
                  sessionStorage.setItem(
                    `${response.data.data[i].district_name}/Residential`,
                    polVarVal
                  );
                }
              }
            }
            for (let year in JSON.parse(
              response.data.data[i].policy_submissions
            )) {
              for (
                let j = 0;
                j <
                JSON.parse(response.data.data[i].policy_submissions)[year]
                  .length;
                j++
              ) {
                let pol_id = JSON.parse(
                  response.data.data[i].policy_submissions
                )[year][j][0];
                let pol_val = JSON.parse(
                  response.data.data[i].policy_submissions
                )[year][j][1];
                if (pol_id) {
                  policyJSON
                    .filter(
                      (item) =>
                        item.configuration === parseFloat(this.city_config)
                    )
                    .filter((item) => item.polindex === pol_id)
                    .map((item) => {
                      sessionStorage.setItem(
                        `${response.data.data[i].district_name}/${item.name}`,
                        pol_val
                      );
                      sessionStorage.setItem(
                        `${year}/${response.data.data[i].district_name}/${
                          item.name
                        }`,
                        pol_val
                      );
                    });
                }
              }
            }
          }
        }
        console.groupEnd();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  //Need to update content based on url

  //TODO Make expirimental function to capture previous URL props.

  componentWillReceiveProps(nextProps) {
    const policyHdrUrl = window.location.href.split("/")[6];
    const districtUrl = window.location.href.split("/")[5];
    let newDistrict;

    const sectors = [
      "Corbusville",
      "Downtown",
      "Jacobs Hill",
      "Moses Gulch",
      "Howard Gardens",
    ];

    for (let i = 0; i < sectors.length; i++) {
      const zoneMixes = this.state.districtPolicyData
        .filter((item) => item.sector === sectors[i])
        .filter((item) => item.name === "Zoning Mix")[0].parameters;
      if (!sessionStorage.getItem(`${sectors[i]}/Commercial`)) {
        let comVal = Object.values(zoneMixes).filter(
          (item) => item.name === "Commercial"
        )[0].defaultValue;
        sessionStorage.setItem(`${sectors[i]}/Commercial`, comVal);
      } else if (!sessionStorage.getItem(`${sectors[i]}/Residential`)) {
        let resVal = Object.values(zoneMixes).filter(
          (item) => item.name === "Residential"
        )[0].defaultValue;
        sessionStorage.setItem(`${sectors[i]}/Residential`, resVal);
      } else if (!sessionStorage.getItem(`${sectors[i]}/Green`)) {
        let grnVal = Object.values(zoneMixes).filter(
          (item) => item.name === "Green"
        )[0].defaultValue;
        sessionStorage.setItem(`${sectors[i]}/Green`, grnVal);
      } else if (!sessionStorage.getItem(`${sectors[i]}/Mixed`)) {
        let mixVal = Object.values(zoneMixes).filter(
          (item) => item.name === "Mixed"
        )[0].defaultValue;
        sessionStorage.setItem(`${sectors[i]}/Mixed`, mixVal);
      }
    }

    // console.log("Inside Navigation:ComponentWillReceiveProps");

    if (policyHdrUrl) {
      if (policyHdrUrl === "land%20use") {
        this.setState({
          policyNavSelection: "Land Use",
          start: 0,
          stop: 8,
        });
      } else {
        this.setState({
          policyNavSelection:
            policyHdrUrl.charAt(0).toUpperCase() +
            window.location.href.split("/")[6].substring(1),
          start: 0,
          stop: 8,
        });
      }
    }
    // console.log(nextProps.match.params.districtName)
    switch (nextProps.match.params.districtName) {
      case "corbusville":
        newDistrict = "Corbusville";
        break;
      case "jacobs_hill":
        newDistrict = "Jacobs Hill";
        break;
      case "downtown":
        newDistrict = "Downtown";
        break;
      case "howard_gardens":
        newDistrict = "Howard Gardens";
        break;
      case "moses_gulch":
        newDistrict = "Moses Gulch";
        break;
      default:
        break;
    }

    if (this.sName === undefined) {
      window.location.replace("/");
    } else {
      const name = window.location.href.split("/")[4];
      this.setState({ selected: name });
    }

    switch (window.location.href.split("/")[5]) {
      case "corbusville":
        console.log("Setting state to Corbusville");
        this.setState({ districtName: "Corbusville" });
        break;
      case "jacobs_hill":
        this.setState({ districtName: "Jacobs Hill" });
        break;
      case "downtown":
        this.setState({ districtName: "Downtown" });
        break;
      case "howard_gardens":
        this.setState({ districtName: "Howard Gardens" });
        break;
      case "moses_gulch":
        this.setState({ districtName: "Moses Gulch" });
        break;
      default:
        break;
    }

    switch (districtUrl) {
      case "corbusville":
        this.setState({
          districtName: "Corbusville",
          Commercial: parseInt(
            sessionStorage.getItem(`Corbusville/Commercial`)
          ),
          Green: parseInt(sessionStorage.getItem(`Corbusville/Green`)),
          Mixed: parseInt(sessionStorage.getItem(`Corbusville/Mixed`)),
          Residential: parseInt(
            sessionStorage.getItem(`Corbusville/Residential`)
          ),
          Parking: parseInt(sessionStorage.getItem(`Corbusville/Parking`)),
          districtSubPolicyDefaultValue: sessionStorage.getItem(
            `Corbusville/${this.state.districtSubPolicy}`
          ),
          districtSubPolicyPrevtValue: sessionStorage.getItem(
            `${sessionStorage.getItem("previous_year")}/Corbusville/${
              this.state.districtSubPolicy
            }`
          ),
        });
        break;
      case "jacobs_hill":
        this.setState({
          districtName: "Jacobs Hill",
          Commercial: parseInt(
            sessionStorage.getItem(`Jacobs Hill/Commercial`)
          ),
          Green: parseInt(sessionStorage.getItem(`Jacobs Hill/Green`)),
          Mixed: parseInt(sessionStorage.getItem(`Jacobs Hill/Mixed`)),
          Residential: parseInt(
            sessionStorage.getItem(`Jacobs Hill/Residential`)
          ),
          Parking: parseInt(sessionStorage.getItem(`Jacobs Hill/Parking`)),
          districtSubPolicyDefaultValue: sessionStorage.getItem(
            `Jacobs Hill/${this.state.districtSubPolicy}`
          ),
          districtSubPolicyPrevtValue: sessionStorage.getItem(
            `${sessionStorage.getItem("previous_year")}/Jacobs Hill/${
              this.state.districtSubPolicy
            }`
          ),
        });
        break;
      case "downtown":
        this.setState({
          districtName: "Downtown",
          Commercial: parseInt(sessionStorage.getItem(`Downtown/Commercial`)),
          Green: parseInt(sessionStorage.getItem(`Downtown/Green`)),
          Mixed: parseInt(sessionStorage.getItem(`Downtown/Mixed`)),
          Residential: parseInt(sessionStorage.getItem(`Downtown/Residential`)),
          Parking: parseInt(sessionStorage.getItem(`Downtown/Parking`)),
          districtSubPolicyDefaultValue: sessionStorage.getItem(
            `Downtown/${this.state.districtSubPolicy}`
          ),
          districtSubPolicyPrevtValue: sessionStorage.getItem(
            `${sessionStorage.getItem("previous_year")}/Downtown/${
              this.state.districtSubPolicy
            }`
          ),
        });
        break;
      case "howard_gardens":
        this.setState({
          districtName: "Howard Gardens",
          Commercial: parseInt(
            sessionStorage.getItem(`Howard Gardens/Commercial`)
          ),
          Green: parseInt(sessionStorage.getItem(`Howard Gardens/Green`)),
          Mixed: parseInt(sessionStorage.getItem(`Howard Gardens/Mixed`)),
          Residential: parseInt(
            sessionStorage.getItem(`Howard Gardens/Residential`)
          ),
          Parking: parseInt(sessionStorage.getItem(`Howard Gardens/Parking`)),
          districtSubPolicyDefaultValue: sessionStorage.getItem(
            `Howard Gardens/${this.state.districtSubPolicy}`
          ),
          districtSubPolicyPrevtValue: sessionStorage.getItem(
            `${sessionStorage.getItem("previous_year")}/Howard Gardens/${
              this.state.districtSubPolicy
            }`
          ),
        });
        break;
      case "moses_gulch":
        this.setState({
          districtName: "Moses Gulch",
          Commercial: parseInt(
            sessionStorage.getItem(`Moses Gulch/Commercial`)
          ),
          Green: parseInt(sessionStorage.getItem(`Moses Gulch/Green`)),
          Mixed: parseInt(sessionStorage.getItem(`Moses Gulch/Mixed`)),
          Residential: parseInt(
            sessionStorage.getItem(`Moses Gulch/Residential`)
          ),
          Parking: parseInt(sessionStorage.getItem(`Moses Gulch/Parking`)),
          districtSubPolicyDefaultValue: sessionStorage.getItem(
            `Moses Gulch/${this.state.districtSubPolicy}`
          ),
          districtSubPolicyPrevtValue: sessionStorage.getItem(
            `${sessionStorage.getItem("previous_year")}/Moses Gulch/${
              this.state.districtSubPolicy
            }`
          ),
        });
        break;
      default:
        break;
    }
    // console.log("This is the new district: " + newDistrict + " And this is the district name in state: " + this.state.districtName)
    if (newDistrict !== undefined && newDistrict !== this.state.districtName) {
      this.setState({
        subPolicyDefaultValue: sessionStorage.getItem(
          `${newDistrict}/${this.state.subPolicy}`
        ),
        Commercial: parseInt(
          sessionStorage.getItem(`${newDistrict}/Commercial`)
        ),
        Green: parseInt(sessionStorage.getItem(`${newDistrict}/Green`)),
        Mixed: parseInt(sessionStorage.getItem(`${newDistrict}/Mixed`)),
        Residential: parseInt(
          sessionStorage.getItem(`${newDistrict}/Residential`)
        ),
        Parking: parseInt(sessionStorage.getItem(`${newDistrict}/Parking`)),
      });

      let zoneDefaultSelections = zoneVarJSON.filter(
        (item) => item.sector === newDistrict
      );
      let newVarValues = [];
      console.log(zoneDefaultSelections);
      console.log(zoneDefaultSelections.length);
      for (let i = 0; i < zoneDefaultSelections.length; i++) {
        if (zoneDefaultSelections[i].regName === "Commercial") {
          zoneDefaultSelections[i].currentVal = parseInt(
            sessionStorage.getItem(`${newDistrict}/Commercial`)
          );
          newVarValues.push(zoneDefaultSelections[i]);
        } else if (zoneDefaultSelections[i].regName === "Green") {
          zoneDefaultSelections[i].currentVal = parseInt(
            sessionStorage.getItem(`${newDistrict}/Green`)
          );
          newVarValues.push(zoneDefaultSelections[i]);
        } else if (zoneDefaultSelections[i].regName === "Mixed") {
          zoneDefaultSelections[i].currentVal = parseInt(
            sessionStorage.getItem(`${newDistrict}/Mixed`)
          );
          newVarValues.push(zoneDefaultSelections[i]);
        } else if (zoneDefaultSelections[i].regName === "Residential") {
          zoneDefaultSelections[i].currentVal = parseInt(
            sessionStorage.getItem(`${newDistrict}/Residential`)
          );
          newVarValues.push(zoneDefaultSelections[i]);
        } else {
          newVarValues.push(zoneDefaultSelections[i]);
        }
      }
      console.log(
        "Inside component will receive props, newVarValues: ",
        newVarValues
      );
      this.setState({
        zoneSelections: newVarValues,
      });

      if (zoneDefaultSelections) {
        // console.log(this.state.zoneSelections);
        let newZoneObject = {};
        for (let i = 0; i < zoneDefaultSelections.length; i++) {
          newZoneObject[zoneDefaultSelections[i].varName] =
            zoneDefaultSelections[i].currentVal;
        }
        // console.log(newZoneObject);
        this.setState({
          zoneVarsOnly: newZoneObject,
        });
      }

      // this.setState({
      //   zoneSelections: zoneVarJSON.filter(item => item.sector === newDistrict)
      // });

      let defaultCommercial;
      let defaultGreen;
      let defaultMixed;
      let defaultResidential;
      let defaultParking;

      const zoneMixes = this.state.districtPolicyData
        .filter((item) => item.sector === newDistrict)
        .filter((item) => item.category === "Land Use")[0].parameters;
      defaultCommercial = Object.values(zoneMixes).filter(
        (item) => item.name === "Commercial"
      )[0].defaultValue;
      defaultGreen = Object.values(zoneMixes).filter(
        (item) => item.name === "Green"
      )[0].defaultValue;
      defaultMixed = Object.values(zoneMixes).filter(
        (item) => item.name === "Mixed"
      )[0].defaultValue;
      defaultResidential = Object.values(zoneMixes).filter(
        (item) => item.name === "Residential"
      )[0].defaultValue;
      defaultParking = Object.values(zoneMixes).filter(
        (item) => item.name === "Parking"
      )[0].defaultValue;

      if (!sessionStorage.getItem(`${newDistrict}/Commercial`)) {
        sessionStorage.setItem(`${newDistrict}/Commercial`, defaultCommercial);
      } else {
        this.setState({
          Commercial: parseInt(
            sessionStorage.getItem(`${newDistrict}/Commercial`)
          ),
        });
      }
      if (!sessionStorage.getItem(`${newDistrict}/Green`)) {
        sessionStorage.setItem(`${newDistrict}/Green`, defaultGreen);
      } else {
        this.setState({
          Green: parseInt(sessionStorage.getItem(`${newDistrict}/Green`)),
        });
      }
      if (!sessionStorage.getItem(`${newDistrict}/Mixed`)) {
        sessionStorage.setItem(`${newDistrict}/Mixed`, defaultMixed);
      } else {
        this.setState({
          Mixed: parseInt(sessionStorage.getItem(`${newDistrict}/Mixed`)),
        });
      }
      if (!sessionStorage.getItem(`${newDistrict}/Residential`)) {
        sessionStorage.setItem(
          `${newDistrict}/Residential`,
          defaultResidential
        );
      } else {
        this.setState({
          Residential: parseInt(
            sessionStorage.getItem(`${newDistrict}/Residential`)
          ),
        });
      }
      if (!sessionStorage.getItem(`${newDistrict}/Parking`)) {
        sessionStorage.setItem(`${newDistrict}/Parking`, defaultParking);
      } else {
        this.setState({
          Parking: parseInt(sessionStorage.getItem(`${newDistrict}/Parking`)),
        });
      }

      this.setZones(
        parseInt(sessionStorage.getItem(`${newDistrict}/Commercial`)),
        parseInt(sessionStorage.getItem(`${newDistrict}/Green`)),
        parseInt(sessionStorage.getItem(`${newDistrict}/Mixed`)),
        parseInt(sessionStorage.getItem(`${newDistrict}/Residential`)),
        parseInt(sessionStorage.getItem(`${newDistrict}/Parking`))
      );
    }
  }

  handleClose = () => {
    this.setState({ snackOpen: false });
  };

  //Message Handling

  messageTemporary = async (time) => {
    // await this.delay(time);
    this.setState({
      messageDivVisibility: "hidden",
      messageMessage: null,
      messageType: null,
      messageFunction: null,
    });
    // await this.delay(time + 1000);
    // this.setState({
    //   messageMessage: null,
    //   messageType: null,
    //   messageFunction: null
    // })
  };

  logoutYes = (e) => {
    e.preventDefault();

    console.log("In logout");

    axios
      .post(this.fetchURL + "/api/v1/participants/logout/", {
        student_name: this.sName,
        city_skey: this.city_skey,
        city_name: this.city_name,
        p_id: this.p_id,
      })
      .then((response) => {
        if (this.origin) {
          if (this.origin === "CLSG") {
            this.cookies.remove("city_id", { path: "/" });
            this.cookies.remove("city_name", { path: "/" });
            this.cookies.remove("city_skey", { path: "/" });
            this.cookies.remove("p_id", { path: "/" });
            this.cookies.remove("s_name", { path: "/" });
            this.cookies.remove("s_email", { path: "/" });
            this.cookies.remove("game_code", { path: "/" });
            this.cookies.remove("city_config", { path: "/" });
            this.cookies.remove("student_is_manager", { path: "/" });
            this.cookies.remove("origin", { path: "/" });
            this.cookies.remove("student_role", { path: "/" });
            this.cookies.remove("student_team_name", { path: "/" });
            this.cookies.remove("current_year", { path: "/" });
            console.log("after the cookies");
            sessionStorage.clear();
            console.log("session storage cleared");
            window.close();
          }
          if (this.origin === "NOT_CLSG") {
            this.cookies.remove("city_id", { path: "/" });
            this.cookies.remove("city_name", { path: "/" });
            this.cookies.remove("city_skey", { path: "/" });
            this.cookies.remove("p_id", { path: "/" });
            this.cookies.remove("s_name", { path: "/" });
            this.cookies.remove("s_email", { path: "/" });
            this.cookies.remove("origin", { path: "/" });
            this.cookies.remove("game_code", { path: "/" });
            this.cookies.remove("city_config", { path: "/" });
            this.cookies.remove("student_is_manager", { path: "/" });
            this.cookies.remove("student_role", { path: "/" });
            this.cookies.remove("student_team_name", { path: "/" });
            this.cookies.remove("current_year", { path: "/" });
            console.log("after the cookies");
            sessionStorage.clear();
            console.log("session storage cleared");
            window.location.replace(`/`);
          }
        } else {
          this.cookies.remove("city_id", { path: "/" });
          this.cookies.remove("city_name", { path: "/" });
          this.cookies.remove("city_skey", { path: "/" });
          this.cookies.remove("p_id", { path: "/" });
          this.cookies.remove("s_name", { path: "/" });
          this.cookies.remove("s_email", { path: "/" });
          this.cookies.remove("origin", { path: "/" });
          this.cookies.remove("game_code", { path: "/" });
          this.cookies.remove("city_config", { path: "/" });
          this.cookies.remove("student_is_manager", { path: "/" });
          this.cookies.remove("student_role", { path: "/" });
          this.cookies.remove("student_team_name", { path: "/" });
          this.cookies.remove("current_year", { path: "/" });
          console.log("after the cookies");
          sessionStorage.clear();
          console.log("session storage cleared");
          window.location.replace(`/`);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    return "true";
  };

  logoutPrevent = (e) => {
    e.preventDefault();
    if (this.origin) {
      if (this.origin === "CLSG") {
        this.setState({
          messageDivVisibility: "visible",
          messageMessage:
            "Are you sure you want to return to your CLSG account page?",
          messageType: "Warning",
          messageFunction: "Logout",
        });
      }
      if (this.origin === "NOT_CLSG") {
        this.setState({
          messageDivVisibility: "visible",
          messageMessage: "Are you sure you want to logout?",
          messageType: "Warning",
          messageFunction: "Logout",
        });
      }
    } else {
      this.setState({
        messageDivVisibility: "visible",
        messageMessage: "Are you sure you want to logout?",
        messageType: "Warning",
        messageFunction: "Logout",
      });
    }
  };

  districtSubmitPrevent = (e) => {
    e.preventDefault();
    this.setState({
      // snackType: "district-snack-submit",
      // snackOpen: true,
      // snackMsg:
      //   "Are you sure you want to Submit, this will lock in all engagement totals?",
      // snackAutoHideDuration: null,
      messageDivVisibility: "visible",
      messageMessage:
        "Are you sure you want to Submit? This action will lock in all engagement totals? If not, please press cancel and select again.",
      messageType: "Warning",
      messageFunction: "submitDistrict",
    });
  };

  citySubmitPrevent = (e) => {
    e.preventDefault();
    this.setState({
      // snackType: "city-snack-submit",
      // snackOpen: true,
      // snackMsg:
      //   "Are you sure you want to Submit, this will lock in all engagement totals?",
      // snackAutoHideDuration: null,
      messageDivVisibility: "visible",
      messageMessage:
        "Are you sure you want to Submit? This action will lock in all engagement totals? If not, please press cancel and select again.",
      messageType: "Warning",
      messageFunction: "submitCity",
    });
  };

  engagementSubmitPrevent = (e) => {
    e.preventDefault();
    this.setState({
      // snackType: "engagement-snack-submit",
      // snackOpen: true,
      // snackMsg:
      //   "Are you sure you want to Submit, this will lock in all engagement totals?",
      // snackAutoHideDuration: null,
      messageDivVisibility: "visible",
      messageMessage:
        "Are you sure you want to Submit? This action will lock in all engagement totals? If not, please press cancel and select again.",
      messageType: "Warning",
      messageFunction: "submitEngagement",
    });
  };

  setContent = (e, nav) => {
    e.preventDefault();
    this.props.history.push(`/game/${nav.name}`);
    this.setState({
      districtName: "City",
    });
    const name = window.location.href.split("/")[4];
    console.log("Inside set content, name: " + name);
    if (nav.content === LINKS) {
      window.open(nav.href, "_blank");
    } else if (this.state.districtName !== undefined) {
      this.setState({ selected: name });
      console.log(zoneVarJSON.filter((item) => item.sector === name));
      this.setState({
        zoneSelections: zoneVarJSON.filter((item) => item.sector === name),
      });
    } else {
      this.setState({ selected: name, districtName: "" });
    }
  };

  openAccountBook = (e) => {
    console.log(this.state.accountBook);
    e.preventDefault();
    this.setState({
      accountBook: true,
    });
    console.log("accountBook Opened");
  };

  openPolicyHistory = (e) => {
    console.log(this.state.policyHistory);
    e.preventDefault();
    this.fetchPolicies(
      this.city_id,
      this.state.currentYear,
      this.state.previousYear
    );
    this.setState({
      policyHistory: true,
    });
    console.log("policyHistory Opened");
  };

  closeModal = (e) => {
    e.preventDefault();
    if (this.state.accountBook) {
      this.setState({
        accountBook: false,
      });
    }
    if (this.state.policyHistory) {
      this.setState({
        policyHistory: false,
      });
    }
  };

  engagementFunc = (subpol, diff) => {
    // console.groupCollapsed("Navigation:engagementFunc");
    // console.time("engagementFunc answer time");
    // console.log("Diff in function:  ", diff);
    // console.log(subpol);
    let engagementCounter = this.state.engagementCounter;
    // console.log(
    //   `This is the engagement counter in state ${
    //   this.state.engagementCounter
    //   } and Current Engagement in SessionStorage: ${sessionStorage.getItem(
    //     "currentEngagement"
    //   )}`
    // );
    let diffObj = {};
    let diffMultip;
    this.setState({
      subPolicy: subpol,
    });
    // console.log(
    //   `Calculating the difference multiplier for a difference of ${diff}...`
    // );
    if (diff === 1) {
      diffMultip = 3;
    } else if (diff === 2) {
      diffMultip = 5;
    } else if (diff === 3) {
      diffMultip = 15;
    } else if (diff === 4) {
      diffMultip = 30;
    } else if (diff === 5) {
      diffMultip = 50;
    } else if (diff === 6) {
      diffMultip = 80;
    } else if (diff === 7) {
      diffMultip = 120;
    } else if (diff === 8) {
      diffMultip = 200;
    } else if (diff < 0) {
      diffMultip = diff;
    } else if (diff === 0) {
      diffMultip = 0;
    }

    // console.log("DiffMultiplier:  ", diffMultip);

    //if there isn't a current subpolicy, populate it
    if (!this.state.subPolicy) {
      // console.log("Setting the subpolicy for the first time...");
      this.setState({
        subPolicy: subpol,
      });

      if (this.state.engageObj) {
        // console.log(
        //   "Engagement Object already exists, making placeholder object to add new values..."
        // );
        diffObj = this.state.engageObj;
      }

      //Try an Object//
      // console.log(
      //   "Adding the new value to the existing key..." + JSON.stringify(diffObj)
      // );
      diffObj[subpol] = diffMultip;

      this.setState({
        engageObj: diffObj,
      });
      // console.log("setting to sessionStorage");

      sessionStorage.setItem("engageObj", JSON.stringify(diffObj));
    } else if (subpol !== this.state.subPolicy) {
      // console.log(
      //   "Object Exists, but this is a new policy...creating new state and object..."
      // );

      //search for policy in the object/array and change/add it if it is new

      this.setState({
        subPolicy: subpol,
      });
      // console.log(
      //   "State created...Making mutatable object out of existing object"
      // );
      diffObj = this.state.engageObj;

      diffObj[subpol] = diffMultip;
      // console.log(
      //   "New key value pair added to the object:  " + JSON.stringify(diffObj)
      // );

      this.setState({
        engageObj: diffObj,
      });

      sessionStorage.setItem("engageObj", JSON.stringify(diffObj));

      // console.log("New State set and session storage changed");
    } else if (subpol === this.state.subPolicy) {
      // console.log(
      //   "Object exists and item is already present, changing value..."
      // );
      diffObj = this.state.engageObj;

      diffObj[subpol] = diffMultip;

      // console.log("item in object changed:  " + JSON.stringify(diffObj));

      this.setState({
        engageObj: diffObj,
      });

      sessionStorage.setItem("engageObj", JSON.stringify(diffObj));
      // console.log(
      //   `State created...Making mutatable object out of existing object`
      // );
    }

    // loop through the object and subtract its values from the main number

    // console.log("Loop through object to get current engagement...");
    // console.time("engagementFunc answer time");
    for (let item in this.state.engageObj) {
      engagementCounter -= this.state.engageObj[item];
    }
    // console.log(
    //   `Object at state has been looped through:  ${this.state.engageObj} and this is the current count from the object:  ${engagementCounter}`
    // );
    // console.timeEnd("engagementFunc answer time");

    this.setState({
      currentEngagement: engagementCounter,
    });

    sessionStorage.setItem("currentEngagement", engagementCounter);

    //if player submits, the current value becomes the Total value
    //If player reaches less than or equal to zero, all policies except community engagement are disabled
    //Players unlock higher levels of engegement the more engagement policies that are put into place
    // console.timeEnd("engagementFunc end time");
    // console.groupEnd();
  };

  engagementSetTotalEngagement = () => {
    // console.log(
    //   "This is current engagement in state: " +
    //   this.state.currentEngagement +
    //   " This is total Engagement in state:  " +
    //   this.state.totalEngagement +
    //   " this is currentEngagement from ss: " +
    //   sessionStorage.getItem("currentEngagement") +
    //   " this is totalEngagement from ss:  " +
    //   sessionStorage.getItem("totalEngagement")
    // );
    this.setState({
      totalEngagement: this.state.currentEngagement,
      engagementCounter: this.state.currentEngagement,
    });
    sessionStorage.setItem("totalEngagement", this.state.currentEngagement);

    // let totalEngagement = this.state.currentEngagement
    // console.log(this.state.engagementSuspended)
    // if (totalEngagement > 50) {
    //   console.log("total Engagement greater than 20");
    //   this.setState({
    //     toolTipMessage: "",
    //     policySuspended: false
    //   });
    // } else if ((totalEngagement <= 50 && totalEngagement > 0) && this.state.engagementSuspended !== true) {
    //   this.setState({
    //     toolTipMessage:
    //       "Community Engagement getting low, please increase engagement by going to the engagement policy panel.",
    //     policySuspended: false
    //   });
    //   let warning = "Warning"
    //   let message = "Community Engagement getting low, please increase engagement by going to the engagement policy panel."

    //   this.setWarningMessage(warning, message)
    // } else if (totalEngagement <= 0) {
    //   this.setState({
    //     toolTipMessage:
    //       "Policy selection has been suspended, please increase engagement by going to the engagement policy panel.",
    //     policySuspended: true
    //   });

    //   let warning = "Error"
    //   let message = "Policy selection has been suspended, please increase engagement by going to the engagement policy panel."

    //   this.setWarningMessage(warning, message)

    // }

    sessionStorage.setItem("engagementCounter", this.state.currentEngagement);
    let diffObj = this.state.engageObj;

    for (let item in diffObj) {
      diffObj[item] = 0;
    }
    this.setState({
      engageObj: diffObj,
    });
    console.log(diffObj);
    sessionStorage.setItem("engageObj", JSON.stringify(diffObj));

    //reset Inform Obj and Inform Total
    let InformObj = JSON.parse(sessionStorage.getItem("InformObj"));
    let InformTotal = sessionStorage.getItem("Inform");
    let ConsultObj = JSON.parse(sessionStorage.getItem("ConsultObj"));
    let ConsultTotal = sessionStorage.getItem("Consult");
    let InvolveObj = JSON.parse(sessionStorage.getItem("InvolveObj"));
    let InvolveTotal = sessionStorage.getItem("Involve");
    let CollaborateObj = JSON.parse(sessionStorage.getItem("CollaborateObj"));
    let CollaborateTotal = sessionStorage.getItem("Collaborate");

    console.log(InformObj);
    console.log(
      "This is the Inform Total: " +
        InformTotal +
        " This is the state: " +
        this.state.InformSubmitted
    );

    for (let item in InformObj) {
      InformObj[item] = 0;
    }

    for (let item in ConsultObj) {
      ConsultObj[item] = 0;
    }

    for (let item in InvolveObj) {
      InvolveObj[item] = 0;
    }

    for (let item in CollaborateObj) {
      CollaborateObj[item] = 0;
    }

    if (InformTotal && InformObj) {
      this.setState({
        InformObj: InformObj,
        Inform: InformTotal,
      });

      this.setState({
        InformSubmitted: parseInt(InformTotal),
      });

      sessionStorage.setItem("InformObj", JSON.stringify(InformObj));
      sessionStorage.setItem("Inform", InformTotal);
      sessionStorage.setItem("InformSubmitted", InformTotal);
    } else if (InformTotal) {
      this.setState({
        Inform: InformTotal,
      });
    } else {
      this.setState({
        InformObj: InformObj,
        Inform: InformTotal,
      });
      sessionStorage.setItem("Inform", 0);
    }

    if (ConsultTotal && ConsultObj) {
      this.setState({
        ConsultObj: ConsultObj,
        Consult: ConsultTotal,
      });

      this.setState({
        ConsultSubmitted: parseInt(ConsultTotal),
      });

      sessionStorage.setItem("ConsultObj", JSON.stringify(ConsultObj));
      sessionStorage.setItem("Consult", ConsultTotal);
      sessionStorage.setItem("ConsultSubmitted", ConsultTotal);
    } else if (ConsultTotal) {
      this.setState({
        Consult: ConsultTotal,
      });
    } else {
      this.setState({
        ConsultObj: ConsultObj,
        Consult: ConsultTotal,
      });
      sessionStorage.setItem("Consult", 0);
    }

    if (InvolveTotal && InvolveObj) {
      this.setState({
        InvolveObj: InvolveObj,
        Involve: InvolveTotal,
      });

      this.setState({
        InvolveSubmitted: parseInt(InvolveTotal),
      });

      sessionStorage.setItem("InvolveObj", JSON.stringify(InvolveObj));
      sessionStorage.setItem("Involve", InvolveTotal);
      sessionStorage.setItem("InvolveSubmitted", InvolveTotal);
    } else if (InvolveTotal) {
      this.setState({
        Involve: InvolveTotal,
      });
    } else {
      this.setState({
        InvolveObj: InvolveObj,
        Involve: InvolveTotal,
      });
      sessionStorage.setItem("Involve", 0);
    }

    if (CollaborateTotal && CollaborateObj) {
      this.setState({
        CollaborateObj: CollaborateObj,
        Collaborate: CollaborateTotal,
      });

      this.setState({
        CollaborateSubmitted: parseInt(CollaborateTotal),
      });

      sessionStorage.setItem("CollaborateObj", JSON.stringify(CollaborateObj));
      sessionStorage.setItem("Collaborate", CollaborateTotal);
      sessionStorage.setItem("CollaborateSubmitted", CollaborateTotal);
    } else if (CollaborateTotal) {
      this.setState({
        Collaborate: CollaborateTotal,
      });
    } else {
      this.setState({
        CollaborateObj: CollaborateObj,
        Collaborate: CollaborateTotal,
      });
      sessionStorage.setItem("Collaborate", 0);
    }

    sessionStorage.setItem(
      `engagement`,
      JSON.stringify({
        city_id: parseFloat(this.city_id),
        engagement: {
          currentEngagement: sessionStorage.getItem("currentEngagement"),
          totalEngagement: sessionStorage.getItem("totalEngagement"),
          Inform: sessionStorage.getItem("Inform"),
          InformTarget: this.state.InformTarget,
          InformLock: this.state.InformLock,
          InformMaxReached: this.state.InformMaxReached,
          InformObj: sessionStorage.getItem("InformObj"),
          InformSubmitted: parseInt(InformTotal),
          Consult: sessionStorage.getItem("Consult"),
          ConsultTarget: this.state.ConsultTarget,
          ConsultLock: this.state.ConsultLock,
          ConsultDisabled: this.state.ConsultDisabled,
          ConsultMaxReached: this.state.ConsultMaxReached,
          ConsultObj: sessionStorage.getItem("ConsultObj"),
          ConsultSubmitted: parseInt(ConsultTotal),
          Involve: sessionStorage.getItem("Involve"),
          InvolveTarget: this.state.InvolveTarget,
          InvolveLock: this.state.InvolveLock,
          InvolveDisabled: this.state.InvolveDisabled,
          InvolveMaxReached: this.state.InvolveMaxReached,
          InvolveObj: sessionStorage.getItem("InvolveObj"),
          InvolveSubmitted: parseInt(InvolveTotal),
          Collaborate: sessionStorage.getItem("Collaborate"),
          CollaborateTarget: this.state.CollaborateTarget,
          CollaborateLock: this.state.CollaborateLock,
          CollaborateDisabled: this.state.CollaborateDisabled,
          CollaborateObj: sessionStorage.getItem("CollaborateObj"),
          CollaborateMaxReached: this.state.CollaborateMaxReached,
          CollaborateSubmitted: parseInt(CollaborateTotal),
          engageObj: sessionStorage.getItem("engageObj"),
        },
      })
    );
  };

  setTotalEngagement = () => {
    console.log(
      "This is current engagement in state: " +
        this.state.currentEngagement +
        " This is total Engagement in state:  " +
        this.state.totalEngagement +
        " this is currentEngagement from ss: " +
        sessionStorage.getItem("currentEngagement") +
        " this is totalEngagement from ss:  " +
        sessionStorage.getItem("totalEngagement")
    );
    this.setState({
      totalEngagement: this.state.currentEngagement,
      engagementCounter: this.state.currentEngagement,
    });
    sessionStorage.setItem("totalEngagement", this.state.currentEngagement);

    let totalEngagement = this.state.currentEngagement;
    console.log(this.state.engagementSuspended);
    if (!this.state.engagementSuspended) {
      if (totalEngagement > 75) {
        console.log("total Engagement greater than 20");
        this.setState({
          toolTipMessage: "",
          policySuspended: false,
        });
      } else if (totalEngagement <= 75 && totalEngagement > 0) {
        this.setState({
          toolTipMessage:
            "Community Engagement getting low, please increase engagement by going to the engagement policy panel.",
          policySuspended: false,
        });
        let warning = "Warning";
        let message =
          "Community Engagement getting low, please increase engagement by going to the engagement policy panel.";

        this.setWarningMessage(warning, message);
      } else if (totalEngagement <= 0) {
        this.setState({
          toolTipMessage:
            "Policy selection has been suspended, please increase engagement by going to the engagement policy panel.",
          policySuspended: true,
        });

        let warning = "Error";
        let message =
          "Policy selection has been suspended, please increase engagement by going to the engagement policy panel.";

        this.setWarningMessage(warning, message);
      }
    }

    sessionStorage.setItem("engagementCounter", this.state.currentEngagement);
    let diffObj = this.state.engageObj;

    for (let item in diffObj) {
      diffObj[item] = 0;
    }
    this.setState({
      engageObj: diffObj,
    });
    console.log(diffObj);
    sessionStorage.setItem("engageObj", JSON.stringify(diffObj));

    //reset Inform Obj and Inform Total
    let InformObj = JSON.parse(sessionStorage.getItem("InformObj"));
    let InformTotal = sessionStorage.getItem("Inform");
    let ConsultObj = JSON.parse(sessionStorage.getItem("ConsultObj"));
    let ConsultTotal = sessionStorage.getItem("Consult");
    let InvolveObj = JSON.parse(sessionStorage.getItem("InvolveObj"));
    let InvolveTotal = sessionStorage.getItem("Involve");
    let CollaborateObj = JSON.parse(sessionStorage.getItem("CollaborateObj"));
    let CollaborateTotal = sessionStorage.getItem("Collaborate");

    console.log(InformObj);
    console.log(
      "This is the Inform Total: " +
        InformTotal +
        " This is the state: " +
        this.state.InformSubmitted
    );

    for (let item in InformObj) {
      InformObj[item] = 0;
    }

    for (let item in ConsultObj) {
      ConsultObj[item] = 0;
    }

    for (let item in InvolveObj) {
      InvolveObj[item] = 0;
    }

    for (let item in CollaborateObj) {
      CollaborateObj[item] = 0;
    }

    if (InformTotal && InformObj) {
      this.setState({
        InformObj: InformObj,
        Inform: InformTotal,
      });

      this.setState({
        InformSubmitted: parseInt(InformTotal),
      });

      sessionStorage.setItem("InformObj", JSON.stringify(InformObj));
      sessionStorage.setItem("Inform", InformTotal);
      sessionStorage.setItem("InformSubmitted", InformTotal);
    } else if (InformTotal) {
      this.setState({
        Inform: InformTotal,
      });
    } else {
      this.setState({
        InformObj: InformObj,
        Inform: InformTotal,
      });
      sessionStorage.setItem("Inform", 0);
    }

    if (ConsultTotal && ConsultObj) {
      this.setState({
        ConsultObj: ConsultObj,
        Consult: ConsultTotal,
      });

      this.setState({
        ConsultSubmitted: (this.state.ConsultSubmitted += ConsultTotal),
      });

      sessionStorage.setItem("ConsultObj", JSON.stringify(ConsultObj));
      sessionStorage.setItem("Consult", ConsultTotal);
      sessionStorage.setItem("ConsultSubmitted", ConsultTotal);
    } else if (ConsultTotal) {
      this.setState({
        Consult: ConsultTotal,
      });
    } else {
      this.setState({
        ConsultObj: ConsultObj,
        Consult: ConsultTotal,
      });
      sessionStorage.setItem("Consult", 0);
    }

    if (InvolveTotal && InvolveObj) {
      this.setState({
        InvolveObj: InvolveObj,
        Involve: InvolveTotal,
      });

      this.setState({
        InvolveSubmitted: (this.state.InvolveSubmitted += InvolveTotal),
      });

      sessionStorage.setItem("InvolveObj", JSON.stringify(InvolveObj));
      sessionStorage.setItem("Involve", InvolveTotal);
      sessionStorage.setItem("InvolveSubmitted", InvolveTotal);
    } else if (InvolveTotal) {
      this.setState({
        Involve: InvolveTotal,
      });
    } else {
      this.setState({
        InvolveObj: InvolveObj,
        Involve: InvolveTotal,
      });
      sessionStorage.setItem("Involve", 0);
    }

    if (CollaborateTotal && CollaborateObj) {
      this.setState({
        CollaborateObj: CollaborateObj,
        Collaborate: CollaborateTotal,
      });

      this.setState({
        CollaborateSubmitted: (this.state.CollaborateSubmitted += CollaborateTotal),
      });

      sessionStorage.setItem("CollaborateObj", JSON.stringify(CollaborateObj));
      sessionStorage.setItem("Collaborate", CollaborateTotal);
      sessionStorage.setItem("CollaborateSubmitted", CollaborateTotal);
    } else if (CollaborateTotal) {
      this.setState({
        Collaborate: CollaborateTotal,
      });
    } else {
      this.setState({
        CollaborateObj: CollaborateObj,
        Collaborate: CollaborateTotal,
      });
      sessionStorage.setItem("Collaborate", 0);
    }

    sessionStorage.setItem(
      `engagement`,
      JSON.stringify({
        city_id: parseFloat(this.city_id),
        engagement: {
          currentEngagement: sessionStorage.getItem("currentEngagement"),
          totalEngagement: sessionStorage.getItem("totalEngagement"),
          Inform: sessionStorage.getItem("Inform"),
          InformTarget: this.state.InformTarget,
          InformLock: this.state.InformLock,
          InformMaxReached: this.state.InformMaxReached,
          InformObj: sessionStorage.getItem("InformObj"),
          InformSubmitted: this.state.InformSubmitted,
          Consult: sessionStorage.getItem("Consult"),
          ConsultTarget: this.state.ConsultTarget,
          ConsultLock: this.state.ConsultLock,
          ConsultDisabled: this.state.ConsultDisabled,
          ConsultMaxReached: this.state.ConsultMaxReached,
          ConsultObj: sessionStorage.getItem("ConsultObj"),
          ConsultSubmitted: this.state.ConsultSubmitted,
          Involve: sessionStorage.getItem("Involve"),
          InvolveTarget: this.state.InvolveTarget,
          InvolveLock: this.state.InvolveLock,
          InvolveDisabled: this.state.InvolveDisabled,
          InvolveMaxReached: this.state.InvolveMaxReached,
          InvolveObj: sessionStorage.getItem("InvolveObj"),
          InvolveSubmitted: this.state.InvolveSubmitted,
          Collaborate: sessionStorage.getItem("Collaborate"),
          CollaborateTarget: this.state.CollaborateTarget,
          CollaborateLock: this.state.CollaborateLock,
          CollaborateDisabled: this.state.CollaborateDisabled,
          CollaborateObj: sessionStorage.getItem("CollaborateObj"),
          CollaborateMaxReached: this.state.CollaborateMaxReached,
          CollaborateSubmitted: this.state.CollaborateSubmitted,
          engageObj: sessionStorage.getItem("engageObj"),
        },
      })
    );
  };

  setWarningMessage = async (warningType, message) => {
    await this.delay(2000);
    this.setState({
      messageDivVisibility: "visible",
      messageMessage: message,
      messageType: warningType,
    });
  };

  setEngagement = (
    message,
    currentEngagement,
    totalEngagement,
    InformObj,
    ConsultObj,
    InvolveObj,
    CollaborateObj,
    engageObj,
    Inform,
    Consult,
    Involve,
    Collaborate
  ) => {
    // console.groupCollapsed("Navigation:setEngagement");
    console.log("Triggered by :  " + message);
    console.log(totalEngagement);
    console.log(currentEngagement);
    console.log(
      `InformObj: ${InformObj}, ConsultObj: ${ConsultObj}, InvolveObj: ${InvolveObj}, CollaborateObj: ${CollaborateObj}, EngageObj: ${engageObj}`
    );

    if (InformObj) {
      // console.log("Received Inform Obj");
      this.setState({ InformObj: JSON.parse(InformObj) });
    }
    if (ConsultObj) {
      console.log("Received ConsultObj");
      this.setState({ ConsultObj: JSON.parse(ConsultObj) });
    }
    if (InvolveObj) {
      console.log("Received InvolveObj");
      this.setState({ InvolveObj: JSON.parse(InvolveObj) });
    }
    if (CollaborateObj) {
      console.log("Received CollaborateObj");
      this.setState({ CollaborateObj: JSON.parse(CollaborateObj) });
    }

    if (engageObj) {
      // console.log("Received engageObj");
      console.log("Type of engageobj", typeof engageObj, engageObj);
      this.setState({ engageObj: JSON.parse(engageObj) });
    }

    if (Inform) {
      // console.log("Received Inform Total");
      this.setState({ Inform: JSON.parse(Inform) });
    }

    if (Consult) {
      // console.log("Received Consult Total");
      this.setState({ Consult: JSON.parse(Consult) });
    }

    if (Involve) {
      // console.log("Received Involve Total");
      this.setState({ Involve: JSON.parse(Involve) });
    }

    if (Collaborate) {
      // console.log("Received Collaborate total");
      this.setState({ Collaborate: JSON.parse(Collaborate) });
    }

    // console.log(
    //   `This is currentEngagement from inside the listener ${currentEngagement}, And this is current Engagement as it is in State:  ${this.state.currentEngagement} and this is total engagement from inside the listener:  ${totalEngagement} and this is total engagement in state:  ${this.state.totalEngagement}`
    // );
    // if((currentEngagement === "undefined" || !currentEngagement) && (totalEngagement === "undefined" || !totalEngagement)) {
    //   console.log("In current Engagement function")
    //   this.setState({
    //     currentEngagement: 100,
    //     totalEngagement: 100
    //   });
    //   sessionStorage.setItem("currentEngagement", 100)
    //   sessionStorage.setItem("totalEngagement", 100)
    // }
    if (totalEngagement === "undefined" || !totalEngagement) {
      // console.log("total engagement was undifined or null");
      this.setState({
        totalEngagement: 100,
      });
      sessionStorage.setItem("totalEngagement", 100);
    } else {
      // console.log(totalEngagement);
      this.setState({
        currentEngagement: currentEngagement,
        totalEngagement: totalEngagement,
        engagementCounter: totalEngagement,
      });
      sessionStorage.setItem("currentEngagement", currentEngagement);
      sessionStorage.setItem("totalEngagement", totalEngagement);
      sessionStorage.setItem("engagementCounter", totalEngagement);
    }
    if (totalEngagement > 20) {
      // console.log("total Engagement greater than 20");
      this.setState({
        toolTipMessage: "",
        policySuspended: false,
      });
    } else if (totalEngagement <= 50 && totalEngagement > 0) {
      this.setState({
        toolTipMessage:
          "Community Engagement getting low, please increase engagement by going to the engagement policy panel.",
        policySuspended: false,
      });
      // let warning = "Warning"
      // let message = "Community Engagement getting low, please increase engagement by going to the engagement policy panel."

      // this.setWarningMessage(warning, message)
    } else if (totalEngagement <= 0) {
      this.setState({
        toolTipMessage:
          "Policy selection has been suspended, please increase engagement by going to the engagement policy panel.",
        policySuspended: true,
      });

      // let warning = "Error"
      // let message = "Policy selection has been suspended, please increase engagement by going to the engagement policy panel."

      // this.setWarningMessage(warning, message)
    }
    this.setEngagementDefaults();
    console.groupEnd();
  };

  eventListenerSelections = () => {
    const city_skey = this.city_skey;
    const city_path =
      this.ws_scheme + "://transcity.dmsi-sims.com/citysocket/" + city_skey;
    // const city_path =
    //   this.ws_scheme + "://localhost:7000/citysocket/" + city_skey;
    this.socket = new ReconnectingWebSocket(city_path);
    this.socket.addEventListener("open", (e) => {
      console.log("ws opened", e);
    });
    this.socket.addEventListener("close", (e) => {
      console.log("ws closed", e);
    });
    this.socket.addEventListener("message", (e) => {
      console.log("ws message", e);
      const message = JSON.parse(e.data).message;
      const data = JSON.parse(e.data).data;
      console.log(message);
      if (message === "data_selections") {
        console.log(data);
        this.setState({
          eventSourceMessage: data,
        });
        for (let item in this.state.eventSourceMessage) {
          sessionStorage.setItem(item, this.state.eventSourceMessage[item]);
        }

        this.setEngagement(
          "From Self",
          sessionStorage.getItem("currentEngagement"),
          sessionStorage.getItem("totalEngagement"),
          sessionStorage.getItem("InformObj"),
          sessionStorage.getItem("ConsultObj"),
          sessionStorage.getItem("InvolveObj"),
          sessionStorage.getItem("CollaborateObj"),
          sessionStorage.getItem("engageObj"),
          sessionStorage.getItem("Inform"),
          sessionStorage.getItem("Consult"),
          sessionStorage.getItem("Involve"),
          sessionStorage.getItem("Collaborate")
        );
        let suspendedObj = {};

        if (sessionStorage.getItem("InformMaxReached") === "true") {
          console.log("Max Reached");
          suspendedObj["InformMaxReached"] = true;
        } else if (
          sessionStorage.getItem("InformMaxReached") === "false" ||
          !sessionStorage.getItem("InformMaxReached")
        ) {
          console.log("Max Not Reached");
          suspendedObj["InformMaxReached"] = false;
        }

        if (sessionStorage.getItem("ConsultMaxReached") === "true") {
          suspendedObj["ConsultMaxReached"] = true;
        } else if (
          sessionStorage.getItem("ConsultMaxReached") === "false" ||
          !sessionStorage.getItem("ConsultMaxReached")
        ) {
          suspendedObj["ConsultMaxReached"] = false;
        }

        if (sessionStorage.getItem("InvolveMaxReached") === "true") {
          suspendedObj["InvolveMaxReached"] = true;
        } else if (
          sessionStorage.getItem("InvolveMaxReached") === "false" ||
          !sessionStorage.getItem("InvolveMaxReached")
        ) {
          suspendedObj["InvolveMaxReached"] = false;
        }

        if (sessionStorage.getItem("CollaborateMaxReached") === "true") {
          suspendedObj["CollaborateMaxReached"] = true;
        } else if (
          sessionStorage.getItem("CollaborateMaxReached") === "false" ||
          !sessionStorage.getItem("CollaborateMaxReached")
        ) {
          suspendedObj["CollaborateMaxReached"] = false;
        }
        let falseCounter = 0;
        for (let item in suspendedObj) {
          if (suspendedObj[item] === true) {
            // console.log(suspendedObj);
            this.setState({
              suspendButton: true,
            });
          }

          if (suspendedObj[item] === false) {
            // console.log(suspendedObj);
            falseCounter++;
            // console.log(falseCounter);
          }
          // console.log(falseCounter);
          if (falseCounter === 4) {
            this.setState({
              suspendButton: false,
            });
          }
        }
        // console.log(this.state.citySubPolicy);
        this.setState({
          citySubPolicyDefaultValue: sessionStorage.getItem(
            `${this.state.districtName}/${this.state.citySubPolicy}`
          ),
        });
        console.log(
          "This is the current districtName: " +
            this.state.districtName +
            " and this is the current districtSubPolicy:  " +
            this.state.districtSubPolicy
        );
        this.setState({
          districtSubPolicyDefaultValue: sessionStorage.getItem(
            `${this.state.districtName}/${this.state.districtSubPolicy}`
          ),
          Commercial: parseInt(
            sessionStorage.getItem(`${this.state.districtName}/Commercial`)
          ),
          Green: parseInt(
            sessionStorage.getItem(`${this.state.districtName}/Green`)
          ),
          Mixed: parseInt(
            sessionStorage.getItem(`${this.state.districtName}/Mixed`)
          ),
          Residential: parseInt(
            sessionStorage.getItem(`${this.state.districtName}/Residential`)
          ),
          Parking: parseInt(
            sessionStorage.getItem(`${this.state.districtName}/Parking`)
          ),
        });
      }
      if (message === "city_reset") {
        sessionStorage.clear();
        this.cookies.remove("origin", { path: "/" });
        this.cookies.remove("s_email", { path: "/" });
        this.cookies.remove("game_code", { path: "/" });
        this.cookies.remove("s_name", { path: "/" });
        window.location.replace(
          `/assign/${this.sName}/${this.sEmail}/${this.game_code}/`
        );
      }
      if (message === "plot_data") {
        const engagement = JSON.parse(data.metrics_data.engagement);
        console.log("City Advanced, here is the engagement data", engagement);
        if (Object.entries(engagement).length !== 0) {
          console.log(engagement.currentEngagement);
          this.setState({
            currentEngagement: engagement.currentEngagement,
            totalEngagement: engagement.totalEngagement,
            Inform: engagement.Inform,
            InformTarget: engagement.InformTarget,
            InformLock: engagement.InformLock,
            InformMaxReached: engagement.InformMaxReached,
            InformObj: engagement.InformObj,
            // InformSubmitted: engagement.InformSubmitted,
            Consult: engagement.Consult,
            ConsultTarget: engagement.ConsultTarget,
            ConsultLock: engagement.ConsultLock,
            ConsultDisabled: engagement.ConsultDisabled,
            ConsultMaxReached: engagement.ConsultMaxReached,
            ConsultObj: engagement.ConsultObj,
            // ConsultSubmitted: engagement.ConsultSubmitted,
            Involve: engagement.Involve,
            InvolveTarget: engagement.InvolveTarget,
            InvolveLock: engagement.InvolveLock,
            InvolveDisabled: engagement.InvolveDisabled,
            InvolveMaxReached: engagement.InvolveMaxReached,
            InvolveObj: engagement.InvolveObj,
            // InvolveSubmitted: engagement.InvolveSubmitted,
            Collaborate: engagement.Collaborate,
            CollaborateTarget: engagement.CollaborateTarget,
            CollaborateLock: engagement.CollaborateLock,
            CollaborateDisabled: engagement.CollaborateDisabled,
            CollaborateObj: engagement.CollaborateObj,
            CollaborateMaxReached: engagement.CollaborateMaxReached,
            // CollaborateSubmitted: engagement.CollaborateSubmitted,
            engageObj: JSON.parse(engagement.engageObj),
          });
          sessionStorage.setItem("engagement", JSON.stringify(engagement));
          sessionStorage.setItem(
            "currentEngagement",
            engagement.currentEngagement
          );
          sessionStorage.setItem("totalEngagement", engagement.totalEngagement);
          sessionStorage.setItem("Inform", engagement.Inform);
          sessionStorage.setItem("InformTarget", engagement.InformTarget);
          sessionStorage.setItem("InformLock", engagement.InformLock);
          sessionStorage.setItem(
            "InformMaxReached",
            engagement.InformMaxReached
          );
          sessionStorage.setItem("InformObj", engagement.InformObj);
          // sessionStorage.setItem("InformSubmitted", engagement.InformSubmitted)
          sessionStorage.setItem("Consult", engagement.Consult);
          sessionStorage.setItem("ConsultTarget", engagement.ConsultTarget);
          sessionStorage.setItem("ConsultLock", engagement.ConsultLock);
          sessionStorage.setItem("ConsultDisabled", engagement.ConsultDisabled);
          sessionStorage.setItem(
            "ConsultMaxReached",
            engagement.ConsultMaxReached
          );
          sessionStorage.setItem("ConsultObj", engagement.ConsultObj);
          // sessionStorage.setItem("ConsultSubmitted", engagement.ConsultSubmitted)
          sessionStorage.setItem("Involve", engagement.Involve);
          sessionStorage.setItem("InvolveTarget", engagement.InvolveTarget);
          sessionStorage.setItem("InvolveLock", engagement.InvolveLock);
          sessionStorage.setItem("InvolveDisabled", engagement.InvolveDisabled);
          sessionStorage.setItem(
            "InvolveMaxReached",
            engagement.InvolveMaxReached
          );
          sessionStorage.setItem("InvolveObj", engagement.InvolveObj);
          // sessionStorage.setItem("InvolveSubmitted", engagement.InvolveSubmitted)
          sessionStorage.setItem("Collaborate", engagement.Collaborate);
          sessionStorage.setItem(
            "CollaborateTarget",
            engagement.CollaborateTarget
          );
          sessionStorage.setItem("CollaborateLock", engagement.CollaborateLock);
          sessionStorage.setItem(
            "CollaborateDisabled",
            engagement.CollaborateDisabled
          );
          sessionStorage.setItem("CollaborateObj", engagement.CollaborateObj);
          sessionStorage.setItem(
            "CollaborateMaxReached",
            engagement.CollaborateMaxReached
          );
          // sessionStorage.setItem("CollaborateSubmitted", engagement.CollaborateSubmitted)
          sessionStorage.setItem("engageObj", engagement.engageObj);
        } else {
          console.log(
            "Engagement is an empty object, setting current and total engagement back to zero"
          );
          this.setState({
            totalEngagement: 100,
            currentEngagement: 100,
            engageObj: {},
          });
          sessionStorage.setItem("currentEngagement", 100);
          sessionStorage.removeItem("engageObj");
        }
        if (engagement.currentEngagement === engagement.totalEngagement) {
          this.setState({
            fact_sheets: false,
            website: false,
            newsletter: false,
            open_house: false,
            surveys: false,
            focus_groups: false,
            public_meetings: false,
            public_forums: false,
            utilizing_social_media: false,
            deliberative_polling: false,
            workshops: false,
            charrettes: false,
            consensus_building: false,
            citizens_juries: false,
            advisory_board: false,
          });
          sessionStorage.setItem("fact_sheets", false);
          sessionStorage.setItem("website", false);
          sessionStorage.setItem("newsletter", false);
          sessionStorage.setItem("open_house", false);
          sessionStorage.setItem("surveys", false);
          sessionStorage.setItem("focus_groups", false);
          sessionStorage.setItem("public_meetings", false);
          sessionStorage.setItem("utilizing_social_media", false);
          sessionStorage.setItem("deliberative_polling", false);
          sessionStorage.setItem("workshops", false);
          sessionStorage.setItem("charrettes", false);
          sessionStorage.setItem("consensus_building", false);
          sessionStorage.setItem("citizens_juries", false);
          sessionStorage.setItem("advisory_board", false);
        }
        //*********plot data from below goes here************
        console.log("I can haz plotdata");
        this.setState({
          everythingTable: [],
          remainingForecastAttempts: data.metrics_data.forecast_attempts,
          engagementSuspended: false,
        });
        // console.log(JSON.parse(JSON.parse(e.data).plotData.city_metrics));

        let advanceBudget = JSON.parse(data.metrics_data.city_metrics);
        if (advanceBudget) {
          for (let item in advanceBudget) {
            let everythingObj = {};

            // console.log(item);
            // console.log(advanceBudget[item][0]);
            //--Current Revenue Metrics

            if (
              (advanceBudget[item][0].type === "cityrevenue" ||
                advanceBudget[item][0].type === "districtrevenue" ||
                advanceBudget[item][0].type === "districtcost" ||
                advanceBudget[item][0].type === "citycost") &&
              advanceBudget[item][0].category
            ) {
              // console.log(item.replace(" Table", ""));
              everythingObj[item.replace(" Table", "")] = advanceBudget[item];
              // console.log(everythingObj);
            }
            // console.log(everythingObj);
            if (Object.entries(everythingObj).length !== 0) {
              this.setState({
                everythingTable: this.state.everythingTable.concat(
                  everythingObj
                ),
              });
            }
          }
        }

        sessionStorage.setItem(
          "current_year",
          JSON.parse(data.metrics_data.current_year) + 1
        );
        sessionStorage.setItem(
          "previous_year",
          JSON.parse(data.metrics_data.current_year)
        );

        this.setState({
          // snackOpen: true,
          // snackMsg: `City Has Advanced! The year is now ${sessionStorage.getItem(
          //   "previous_year"
          // )}`,
          // snackType: "snack-success",
          // snackAutoHideDuration: 5000,
          messageDivVisibility: "visible",
          messageMessage: `City Has Advanced! The year is now ${sessionStorage.getItem(
            "previous_year"
          )}.  Please, do not proceed until instructed.`,
          messageType: "Success",
        });

        // this.messageTemporary(5000)

        // console.log(
        //   JSON.parse(JSON.parse(e.data).plotData.metrics_data.city_metrics)
        // );

        this.setState({
          metricsJSON: JSON.parse(data.metrics_data.city_metrics),
          previousYear: JSON.parse(data.metrics_data.current_year),
          currentYear: JSON.parse(data.metrics_data.current_year) + 1,
          forecastJSON: null,
          combinedPlotData1: [],
          combinedPlotData2: [],
          selectedPlotData2: [],
          selectedForecastPlotData1: [],
          selectedForecastPlotData2: [],
          combinedDistrictPlotData: [],
          selectedDistrictPlotData: [],
          selectedForecastDistrictPlotData: [],

          // districtSubPolicyPrevtValue: sessionStorage.getItem(
          //   `${JSON.parse(JSON.parse(e.data).plotData.current_year)}/${
          //     this.state.districtName
          //   }/${this.state.districtSubPolicy}`
          // )
        });

        sessionStorage.setItem("cityForecastData", null);
        sessionStorage.setItem("districtForecastData", null);

        // console.log(this.state.metricsJSON);
        this.setState({
          cityCurrent: [],
          districtCurrent: [],
          parkingZone: [],
        });
        for (let item in this.state.metricsJSON) {
          if ([item][0] === "District Road And Parking Portion Now") {
            // console.log(this.state.metricsJSON[item][0]);
            this.setState({
              parkingZone: this.state.metricsJSON[item][0],
            });
          }
          // console.log(this.state.metricsJSON[item][0].type);
          let currentObj = {};
          if (this.state.metricsJSON[item][0].type === "citycurrent") {
            // console.log(item);
            currentObj[item.replace(" Now", "")] = this.state.metricsJSON[item];
            this.setState({
              cityCurrent: this.state.cityCurrent.concat(currentObj),
            });
          }
          let districtCurrentObj = {};
          if (this.state.metricsJSON[item][0].type === "districtcurrent") {
            // console.log(this.state.metricsJSON[item][0]);
            districtCurrentObj[
              item.replace(" Now", "")
            ] = this.state.metricsJSON[item];
            this.setState({
              districtCurrent: this.state.districtCurrent.concat(
                districtCurrentObj
              ),
            });
          }
        }

        let metricsPlot;
        let metricsPlot2;
        const plottype1 = sessionStorage.getItem("selectedPlot1");
        const plottype2 = sessionStorage.getItem("selectedPlot2");
        const districtPlotType = sessionStorage.getItem("selectedDistrictPlot");

        if (plottype1) {
          this.setState({
            selectedMetric1: plottype1,
          });
          for (let item in this.state.metricsJSON) {
            if (item === plottype1) {
              // console.log(item);
              // console.log(
              //   "After plot selection in onChange Function:  ",
              //   this.state.metricsJSON[item]
              // );
              // console.log(
              //   "Searching for type:  ",
              //   this.state.metricsJSON[item][0].type
              // );

              let newFormattedMetric;
              if (this.state.metricsJSON[item]) {
                switch (this.state.metricsJSON[item][0].type) {
                  case "city":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("current_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType1: "city",
                    });
                    break;
                  case "district":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("current_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType1: "district",
                    });
                    break;
                  case "transportation":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Walk": item.Walk,
                        "Forecasted Car": item.Car,
                        "Forecasted Rail": item.Rail,
                        "Forecasted Bus": item.Bus,
                        "Forecasted Bike": item.Bike,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("current_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted Car"];
                        delete item["Forecasted Rail"];
                        delete item["Forecasted Bus"];
                        delete item["Forecasted Bike"];
                        delete item["Forecasted Walk"];
                      }
                    });

                    this.setState({
                      plotType1: "transportation",
                    });
                    break;
                  case "districtrevenue":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("current_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType1: "districtrevenue",
                    });
                    break;
                  case "cityrevenue":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("current_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType1: "cityrevenue",
                    });
                    break;
                  case "districtcost":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("current_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType1: "districtcost",
                    });
                    break;
                  case "citycost":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("current_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType1: "citycost",
                    });
                    break;
                  default:
                    break;
                }
                // console.log(newFormattedMetric);
              }
              this.setState({
                selectedPlotData1: newFormattedMetric,
              });
              metricsPlot = newFormattedMetric;
              sessionStorage.setItem("selectedPlot1", plottype1);
            }
          }

          for (let item in this.state.forecastJSON) {
            // console.log(e.target.value);
            // console.log(item);
            if (item === e.target.value) {
              // console.log(item);
              // console.log(
              //   "After plot selection in onChange Function:  ",
              //   this.state.forecastJSON[item]
              // );
              // console.log(
              //   "Searching for type:  ",
              //   this.state.forecastJSON[item][0].type
              // );

              let newFormattedMetric;

              if (this.state.forecastJSON[item]) {
                switch (this.state.forecastJSON[item][0].type) {
                  case "city":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType1: "city",
                    });
                    break;
                  case "district":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      plotType1: "district",
                    });

                    break;
                  case "transportation":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Walk": item.Walk,
                        "Forecasted Car": item.Car,
                        "Forecasted Rail": item.Rail,
                        "Forecasted Bus": item.Bus,
                        "Forecasted Bike": item.Bike,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.Car);
                    newFormattedMetric.forEach((item) => delete item.Rail);

                    newFormattedMetric.forEach((item) => delete item.Bus);

                    newFormattedMetric.forEach((item) => delete item.Bike);

                    newFormattedMetric.forEach((item) => delete item.Walk);

                    this.setState({
                      plotType1: "transportation",
                    });

                    break;
                  case "districtcost":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      plotType1: "districtcost",
                    });
                    break;
                  case "citycost":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType1: "citycost",
                    });
                    break;
                  case "districtrevenue":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );
                    this.setState({
                      plotType1: "districtrevenue",
                    });
                    break;
                  case "cityrevenue":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType1: "cityrevenue",
                    });
                    break;
                  default:
                    break;
                }
                console.log(newFormattedMetric);
              }

              // console.log(metricsPlot);
              this.setState({
                selectedForecastPlotData1: newFormattedMetric,
                combinedPlotData1: metricsPlot.concat(newFormattedMetric),
              });
              sessionStorage.setItem("selectedForecastPlotData1", plottype1);
              sessionStorage.setItem("selectedPlot1", plottype1);
            }
          }
        }

        if (plottype2) {
          this.setState({
            selectedMetric2: plottype2,
          });
          let newFormattedMetric;

          for (let item in this.state.metricsJSON) {
            if (item === plottype2) {
              // console.log(item);
              // console.log(this.state.metricsJSON[item]);
              if (this.state.metricsJSON[item]) {
                switch (this.state.metricsJSON[item][0].type) {
                  case "city":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("current_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("current_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType2: "city",
                    });
                    break;
                  case "district":
                    // console.log(
                    //   "Inside the second Metrics JSON:  " +
                    //     this.state.metricsJSON[item]
                    // );
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("current_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType2: "district",
                    });
                    break;
                  case "transportation":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Car": item.Car,
                        "Forecasted Rail": item.Rail,
                        "Forecasted Bus": item.Bus,
                        "Forecasted Bike": item.Bike,
                        "Forecasted Walk": item.Walk,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("current_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted Car"];
                        delete item["Forecasted Rail"];
                        delete item["Forecasted Bus"];
                        delete item["Forecasted Bike"];
                        delete item["Forecasted Walk"];
                      }
                    });

                    this.setState({
                      plotType2: "transportation",
                    });
                    break;
                  case "districtcost":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("current_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType2: "districtcost",
                    });
                    break;
                  case "citycost":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("current_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType2: "citycost",
                    });
                    break;
                  case "districtrevenue":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("current_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType2: "districtrevenue",
                    });
                    break;
                  case "cityrevenue":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("current_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType2: "cityrevenue",
                    });
                    break;
                  default:
                    break;
                }
                // console.log(newFormattedMetric);
              }
              this.setState({
                selectedPlotData2: newFormattedMetric,
              });
              metricsPlot2 = newFormattedMetric;
              sessionStorage.setItem("selectedPlot2", plottype2);
            }
          }
          for (let item in this.state.forecastJSON) {
            // console.log(plottype2);
            // console.log(item);
            if (item === plottype2) {
              // console.log(item);
              // console.log(
              //   "After plot selection in onChange Function:  ",
              //   this.state.forecastJSON[item]
              // );
              // console.log(
              //   "Searching for type:  ",
              //   this.state.forecastJSON[item][0].type
              // );

              let newFormattedMetric;
              if (this.state.forecastJSON[item]) {
                switch (this.state.forecastJSON[item][0].type) {
                  case "city":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType2: "city",
                    });
                    break;
                  case "district":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      plotType2: "district",
                    });

                    break;
                  case "transportation":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Walk": item.Walk,
                        "Forecasted Car": item.Car,
                        "Forecasted Rail": item.Rail,
                        "Forecasted Bus": item.Bus,
                        "Forecasted Bike": item.Bike,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.Car);
                    newFormattedMetric.forEach((item) => delete item.Rail);

                    newFormattedMetric.forEach((item) => delete item.Bus);

                    newFormattedMetric.forEach((item) => delete item.Bike);

                    newFormattedMetric.forEach((item) => delete item.Walk);

                    this.setState({
                      plotType2: "transportation",
                    });

                    break;
                  case "districtcost":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      plotType2: "districtcost",
                    });
                    break;
                  case "citycost":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType2: "citycost",
                    });
                    break;
                  case "districtrevenue":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      plotType2: "districtrevenue",
                    });
                    break;
                  case "cityrevenue":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType2: "cityrevenue",
                    });
                    break;
                  default:
                    break;
                }
                // console.log(newFormattedMetric);
              }

              // console.log(metricsPlot2);
              this.setState({
                selectedForecastPlotData2: newFormattedMetric,
                combinedPlotData2: metricsPlot2.concat(newFormattedMetric),
              });
              sessionStorage.setItem("selectedForecastPlotData2", plottype2);
              sessionStorage.setItem("selectedPlot2", plottype2);
            }
          }
        }
        if (districtPlotType) {
          this.setState({
            selectedDistrictMetric: districtPlotType,
          });
          for (let item in this.state.metricsJSON) {
            if (item === districtPlotType) {
              // console.log(item);
              // console.log(
              //   "After plot selection in onChange Function:  ",
              //   this.state.metricsJSON[item]
              // );
              // console.log(
              //   "Searching for type:  ",
              //   this.state.metricsJSON[item][0].type
              // );

              let newFormattedMetric;
              if (this.state.metricsJSON[item]) {
                switch (this.state.metricsJSON[item][0].type) {
                  case "city":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      districtPlotType: "city",
                    });
                    break;
                  case "district":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      districtPlotType: "district",
                    });
                    break;
                  case "transportation":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Car": item.Car,
                        "Forecasted Rail": item.Rail,
                        "Forecasted Bus": item.Bus,
                        "Forecasted Bike": item.Bike,
                        "Forecasted Walk": item.Walk,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted Car"];
                        delete item["Forecasted Rail"];
                        delete item["Forecasted Bus"];
                        delete item["Forecasted Bike"];
                        delete item["Forecasted Walk"];
                      }
                    });

                    this.setState({
                      districtPlotType: "transportation",
                    });
                    break;
                  case "districtrevenue":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      districtPlotType: "districtrevenue",
                    });
                    break;
                  case "cityrevenue":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      districtPlotType: "cityrevenue",
                    });
                    break;
                  case "districtcost":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      districtPlotType: "districtcost",
                    });
                    break;
                  case "citycost":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      // console.log(typeof item.year);
                      // console.log(
                      //   typeof sessionStorage.getItem("previous_year")
                      // );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        // console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      districtPlotType: "citycost",
                    });
                    break;
                  default:
                    break;
                }
                console.log(newFormattedMetric);
              }
              this.setState({
                selectedDistrictPlotData: newFormattedMetric,
              });
              metricsPlot = newFormattedMetric;
              sessionStorage.setItem("selectedDistrictPlot", districtPlotType);
            }
          }

          for (let item in this.state.forecastJSON) {
            // console.log(districtPlotType);
            // console.log(item);
            if (item === districtPlotType) {
              // console.log(item);
              // console.log(
              //   "After plot selection in onChange Function:  ",
              //   this.state.forecastJSON[item]
              // );
              // console.log(
              //   "Searching for type:  ",
              //   this.state.forecastJSON[item][0].type
              // );

              let newFormattedMetric;

              if (this.state.forecastJSON[item]) {
                switch (this.state.forecastJSON[item][0].type) {
                  case "city":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      districtPlotType: "city",
                    });
                    break;
                  case "district":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      districtPlotType: "district",
                    });

                    break;
                  case "transportation":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Walk": item.Walk,
                        "Forecasted Car": item.Car,
                        "Forecasted Rail": item.Rail,
                        "Forecasted Bus": item.Bus,
                        "Forecasted Bike": item.Bike,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.Car);
                    newFormattedMetric.forEach((item) => delete item.Rail);

                    newFormattedMetric.forEach((item) => delete item.Bus);

                    newFormattedMetric.forEach((item) => delete item.Bike);

                    newFormattedMetric.forEach((item) => delete item.Walk);

                    this.setState({
                      districtPlotType: "transportation",
                    });
                    break;
                  case "districtcost":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      districtPlotType: "districtcost",
                    });
                    break;
                  case "citycost":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      districtPlotType: "citycost",
                    });
                    break;
                  case "districtrevenue":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      districtPlotType: "districtrevenue",
                    });
                    break;
                  case "cityrevenue":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      districtPlotType: "cityrevenue",
                    });
                    break;
                  default:
                    break;
                }
                // console.log(newFormattedMetric);
              }

              // console.log(metricsPlot);
              this.setState({
                selectedForecastDistrictPlotData: newFormattedMetric,
                combinedDistrictPlotData: metricsPlot.concat(
                  newFormattedMetric
                ),
              });
              sessionStorage.setItem(
                "selectedForecastDistrictPlot",
                districtPlotType
              );
            }
          }
        }
        if (data.policy_data) {
          console.log(
            "Policy Data from Advance",
            data.policy_data.map((item) => item)
          );
          let policies = data.policy_data;
          let testArr = data.policy_data.map((item) => ({
            district_name: item.district_name,
            year: Object.keys(JSON.parse(item.policy_submissions)),
            policy_submittions: [
              {
                policies: Object.values(
                  JSON.parse(item.policy_submissions)
                ).map((group) => ({
                  policyName: group.map(
                    (number) =>
                      policyJSON.filter(
                        (item) => item.polindex === number[0]
                      )[0].name
                  ),
                  policyChoice: group.map(
                    (choice) =>
                      policyJSON.filter(
                        (item) => item.polindex === choice[0]
                      )[0].parameters[parseInt(choice[1])].name
                  ),
                })),
              },
            ],
            zone_variables: [JSON.parse(item.zone_variables)],
          }));
          console.log(testArr);
          this.setState({
            allPolicyData: testArr,
          });

          console.log("Running For Loop...");

          for (let i = 0; i < policies.length; i++) {
            if (i === policies.length - 1) {
              // console.log(i);
              // console.log("Loop Finished");
            }
            // console.log(JSON.parse(e.data).plotData.policy_data[i]);
            // console.log(
            //   JSON.parse(
            //     JSON.parse(e.data).plotData.policy_data[i].policy_submissions
            //   )
            // );
            switch (data.policy_data[i].district_name) {
              case "City":
                console.log("City");
                console.log(sessionStorage.getItem("previous_year"));
                console.log(
                  JSON.parse(data.policy_data[i].policy_submissions)[
                    sessionStorage.getItem("previous_year")
                  ]
                );
                this.setState({
                  citySelections: JSON.parse(
                    data.policy_data[i].policy_submissions
                  )[sessionStorage.getItem("previous_year")],
                });
                sessionStorage.setItem(
                  `City`,
                  JSON.stringify({
                    city_id: parseFloat(this.city_id),
                    sector_name: "City",
                    pollist: JSON.parse(data.policy_data[i].policy_submissions)[
                      sessionStorage.getItem("previous_year")
                    ],
                    varsObj: { CxCityHolderVal: 0 },
                  })
                );

                break;
              case "Downtown":
                console.log("Downtown");
                console.log(sessionStorage.getItem("previous_year"));
                this.setState({
                  downtown: JSON.parse(data.policy_data[i].policy_submissions)[
                    sessionStorage.getItem("previous_year")
                  ],
                });
                sessionStorage.setItem(
                  `Downtown`,
                  JSON.stringify({
                    city_id: parseFloat(this.city_id),
                    sector_name: "Downtown",
                    pollist: JSON.parse(data.policy_data[i].policy_submissions)[
                      sessionStorage.getItem("previous_year")
                    ],
                    varsObj: JSON.parse(data.policy_data[i].zone_variables)[
                      sessionStorage.getItem("previous_year")
                    ],
                  })
                );
                break;
              case "Jacobs Hill":
                console.log("Jacobs Hill");
                console.log(sessionStorage.getItem("previous_year"));
                this.setState({
                  jacobs_hill: JSON.parse(
                    data.policy_data[i].policy_submissions
                  )[sessionStorage.getItem("previous_year")],
                });
                sessionStorage.setItem(
                  `Jacobs Hill`,
                  JSON.stringify({
                    city_id: parseFloat(this.city_id),
                    sector_name: "Jacobs Hill",
                    pollist: JSON.parse(data.policy_data[i].policy_submissions)[
                      sessionStorage.getItem("previous_year")
                    ],
                    varsObj: JSON.parse(data.policy_data[i].zone_variables)[
                      sessionStorage.getItem("previous_year")
                    ],
                  })
                );
                break;
              case "Moses Gulch":
                console.log("Moses Gulch");
                console.log(sessionStorage.getItem("previous_year"));
                this.setState({
                  moses_gulch: JSON.parse(
                    data.policy_data[i].policy_submissions
                  )[sessionStorage.getItem("previous_year")],
                });
                sessionStorage.setItem(
                  `Moses Gulch`,
                  JSON.stringify({
                    city_id: parseFloat(this.city_id),
                    sector_name: "Moses Gulch",
                    pollist: JSON.parse(data.policy_data[i].policy_submissions)[
                      sessionStorage.getItem("previous_year")
                    ],
                    varsObj: JSON.parse(data.policy_data[i].zone_variables)[
                      sessionStorage.getItem("previous_year")
                    ],
                  })
                );
                break;
              case "Corbusville":
                console.log("Corbusville");
                console.log(sessionStorage.getItem("previous_year"));
                this.setState({
                  corbusville: JSON.parse(
                    data.policy_data[i].policy_submissions
                  )[sessionStorage.getItem("previous_year")],
                });
                sessionStorage.setItem(
                  `Corbusville`,
                  JSON.stringify({
                    city_id: parseFloat(this.city_id),
                    sector_name: "Corbusville",
                    pollist: JSON.parse(data.policy_data[i].policy_submissions)[
                      sessionStorage.getItem("previous_year")
                    ],
                    varsObj: JSON.parse(data.policy_data[i].zone_variables)[
                      sessionStorage.getItem("previous_year")
                    ],
                  })
                );
                break;
              case "Howard Gardens":
                console.log("Howard Gardens");
                console.log(sessionStorage.getItem("current_year"));
                this.setState({
                  howard_gardens: JSON.parse(
                    data.policy_data[i].policy_submissions
                  )[sessionStorage.getItem("previous_year")],
                });
                sessionStorage.setItem(
                  `Howard Gardens`,
                  JSON.stringify({
                    city_id: parseFloat(this.city_id),
                    sector_name: "Howard Gardens",
                    pollist: JSON.parse(data.policy_data[i].policy_submissions)[
                      sessionStorage.getItem("previous_year")
                    ],
                    varsObj: JSON.parse(data.policy_data[i].zone_variables)[
                      sessionStorage.getItem("previous_year")
                    ],
                  })
                );
                break;
              default:
                break;
            }
            for (let year in JSON.parse(
              data.policy_data[i].policy_submissions
            )) {
              for (
                let j = 0;
                j <
                JSON.parse(data.policy_data[i].policy_submissions)[year].length;
                j++
              ) {
                // console.log(JSON.parse(JSON.parse(e.data).plotData.policy_data[i].policy_submissions
                // )[year])
                let pol_id = JSON.parse(data.policy_data[i].policy_submissions)[
                  year
                ][j][0];
                let pol_val = JSON.parse(
                  data.policy_data[i].policy_submissions
                )[year][j][1];
                if (pol_id) {
                  policyJSON
                    .filter(
                      (item) =>
                        item.configuration === parseFloat(this.city_config)
                    )
                    .filter((item) => item.polindex === pol_id)
                    .map((item) => {
                      sessionStorage.setItem(
                        `${data.policy_data[i].district_name}/${item.name}`,
                        pol_val
                      );
                      sessionStorage.setItem(
                        `${year}/${data.policy_data[i].district_name}/${
                          item.name
                        }`,
                        pol_val
                      );
                    });
                }
              }
            }
          }
          console.log("After for loop in code, setting button..");
          this.setState({
            citySubPolicyPrevtValue: sessionStorage.getItem(
              `${JSON.parse(data.metrics_data.current_year)}/City/${
                this.state.citySubPolicy
              }`
            ),
            citySubPolicyDefaultValue: sessionStorage.getItem(
              `${JSON.parse(data.metrics_data.current_year)}/City/${
                this.state.citySubPolicy
              }`
            ),
            districtSubPolicyPrevtValue: sessionStorage.getItem(
              `${JSON.parse(data.metrics_data.current_year)}/${
                this.state.districtName
              }/${this.state.districtSubPolicy}`
            ),
            districtSubPolicyDefaultValue: sessionStorage.getItem(
              `${JSON.parse(data.metrics_data.current_year)}/${
                this.state.districtName
              }/${this.state.districtSubPolicy}`
            ),
          });
        }
      }
      if (message === "forecast_data") {
        console.log("We have forecast Data!!!");

        if (data === "Out of forecast attempts.") {
          this.setState({
            remainingForecastAttempts: 0,
            messageDivVisibility: "visible",
            messageMessage: "Out of forecast attempts until the next round.",
            messageType: "Warning",
          });

          // sessionStorage.setItem(
          //   "cityForecastData",
          //   null
          // );
        } else {
          this.setState({
            forecastJSON: data.city_metrics,
            remainingForecastAttempts: data.forecast_attempts,
            // snackOpen: true,
            // snackMsg: "Forecast Data now available!!!",
            // snackType: "snack-success",
            // snackAutoHideDuration: 5000,
            messageDivVisibility: "visible",
            messageMessage: "Forecast Data now available!!!",
            messageType: "Success",
          });

          sessionStorage.setItem(
            "cityForecastData",
            JSON.stringify(data.city_metrics)
          );
        }

        // this.messageTemporary(5000)

        let metricsPlot;
        let metricsPlot2;
        const plottype1 = sessionStorage.getItem("selectedPlot1");
        const plottype2 = sessionStorage.getItem("selectedPlot2");
        const districtPlotType = sessionStorage.getItem("selectedDistrictPlot");

        if (plottype1) {
          this.setState({
            selectedMetric1: plottype1,
          });
          for (let item in this.state.metricsJSON) {
            if (item === plottype1) {
              console.log(item);
              console.log(
                "After plot selection in onChange Function:  ",
                this.state.metricsJSON[item]
              );
              console.log(
                "Searching for type:  ",
                this.state.metricsJSON[item][0].type
              );

              let newFormattedMetric;
              if (this.state.metricsJSON[item]) {
                switch (this.state.metricsJSON[item][0].type) {
                  case "city":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType1: "city",
                    });
                    break;
                  case "district":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType1: "district",
                    });
                    break;
                  case "transportation":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Car": item.Car,
                        "Forecasted Rail": item.Rail,
                        "Forecasted Bus": item.Bus,
                        "Forecasted Bike": item.Bike,
                        "Forecasted Walk": item.Walk,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Car"];
                        delete item["Forecasted Rail"];
                        delete item["Forecasted Bus"];
                        delete item["Forecasted Bike"];
                        delete item["Forecasted Walk"];
                      }
                    });

                    this.setState({
                      plotType1: "transportation",
                    });
                    break;
                  case "districtrevenue":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType1: "districtrevenue",
                    });
                    break;
                  case "cityrevenue":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType1: "cityrevenue",
                    });
                    break;
                  case "districtcost":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType1: "districtcost",
                    });
                    break;
                  case "citycost":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType1: "citycost",
                    });
                    break;
                  default:
                    break;
                }
                console.log(newFormattedMetric);
              }
              this.setState({
                selectedPlotData1: newFormattedMetric,
              });
              metricsPlot = newFormattedMetric;
              sessionStorage.setItem("selectedPlot1", plottype1);
            }
          }

          for (let item in this.state.forecastJSON) {
            // console.log(plottype1);
            // console.log(item);
            if (item === plottype1) {
              // console.log(item);
              // console.log(
              //   "After plot selection in onChange Function:  ",
              //   this.state.forecastJSON[item]
              // );
              // console.log(
              //   "Searching for type:  ",
              //   this.state.forecastJSON[item][0].type
              // );

              let newFormattedMetric;

              if (this.state.forecastJSON[item]) {
                switch (this.state.forecastJSON[item][0].type) {
                  case "city":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType1: "city",
                    });
                    break;
                  case "district":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      plotType1: "district",
                    });

                    break;
                  case "transportation":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Walk": item.Walk,
                        "Forecasted Car": item.Car,
                        "Forecasted Rail": item.Rail,
                        "Forecasted Bus": item.Bus,
                        "Forecasted Bike": item.Bike,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.Car);
                    newFormattedMetric.forEach((item) => delete item.Rail);

                    newFormattedMetric.forEach((item) => delete item.Bus);

                    newFormattedMetric.forEach((item) => delete item.Bike);

                    newFormattedMetric.forEach((item) => delete item.Walk);

                    this.setState({
                      plotType1: "transportation",
                    });
                    break;
                  case "districtcost":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      plotType1: "districtcost",
                    });
                    break;
                  case "citycost":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType1: "citycost",
                    });
                    break;
                  case "districtrevenue":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      plotType1: "districtrevenue",
                    });
                    break;
                  case "cityrevenue":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType1: "cityrevenue",
                    });
                    break;
                  default:
                    break;
                }
                console.log(newFormattedMetric);
              }

              console.log(metricsPlot);
              this.setState({
                selectedForecastPlotData1: newFormattedMetric,
                combinedPlotData1: metricsPlot.concat(newFormattedMetric),
              });
              sessionStorage.setItem("selectedForecastPlotData1", plottype1);
              sessionStorage.setItem("selectedPlot1", plottype1);
            }
          }
        }

        if (plottype2) {
          this.setState({
            selectedMetric2: plottype2,
          });
          let newFormattedMetric;

          for (let item in this.state.metricsJSON) {
            if (item === plottype2) {
              console.log(item);
              console.log(this.state.metricsJSON[item]);
              if (this.state.metricsJSON[item]) {
                switch (this.state.metricsJSON[item][0].type) {
                  case "city":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType2: "city",
                    });
                    break;
                  case "district":
                    console.log(
                      "Inside the second Metrics JSON:  " +
                        this.state.metricsJSON[item]
                    );
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType2: "district",
                    });
                    break;
                  case "transportation":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Car": item.Car,
                        "Forecasted Rail": item.Rail,
                        "Forecasted Bus": item.Bus,
                        "Forecasted Bike": item.Bike,
                        "Forecasted Walk": item.Walk,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Car"];
                        delete item["Forecasted Rail"];
                        delete item["Forecasted Bus"];
                        delete item["Forecasted Bike"];
                        delete item["Forecasted Walk"];
                      }
                    });

                    this.setState({
                      plotType2: "transportation",
                    });
                    break;
                  case "districtcost":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType2: "districtcost",
                    });
                    break;
                  case "citycost":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType2: "citycost",
                    });
                    break;
                  case "districtrevenue":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      plotType2: "districtrevenue",
                    });
                    break;
                  case "cityrevenue":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      plotType2: "cityrevenue",
                    });
                    break;
                  default:
                    break;
                }
                console.log(newFormattedMetric);
              }
              this.setState({
                selectedPlotData2: newFormattedMetric,
              });
              metricsPlot2 = newFormattedMetric;
              sessionStorage.setItem("selectedPlot2", plottype2);
            }
          }
          for (let item in this.state.forecastJSON) {
            console.log(plottype2);
            console.log(item);
            if (item === plottype2) {
              console.log(item);
              console.log(
                "After plot selection in onChange Function:  ",
                this.state.forecastJSON[item]
              );
              console.log(
                "Searching for type:  ",
                this.state.forecastJSON[item][0].type
              );

              let newFormattedMetric;
              if (this.state.forecastJSON[item]) {
                switch (this.state.forecastJSON[item][0].type) {
                  case "city":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType2: "city",
                    });
                    break;
                  case "district":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      plotType2: "district",
                    });

                    break;
                  case "transportation":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Walk": item.Walk,
                        "Forecasted Car": item.Car,
                        "Forecasted Rail": item.Rail,
                        "Forecasted Bus": item.Bus,
                        "Forecasted Bike": item.Bike,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.Car);
                    newFormattedMetric.forEach((item) => delete item.Rail);

                    newFormattedMetric.forEach((item) => delete item.Bus);

                    newFormattedMetric.forEach((item) => delete item.Bike);

                    newFormattedMetric.forEach((item) => delete item.Walk);

                    this.setState({
                      plotType2: "transportation",
                    });
                    break;
                  case "districtcost":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      plotType2: "districtcost",
                    });
                    break;
                  case "citycost":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType2: "citycost",
                    });
                    break;
                  case "districtrevenue":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      plotType2: "districtrevenue",
                    });
                    break;
                  case "cityrevenue":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      plotType2: "cityrevenue",
                    });
                    break;
                  default:
                    break;
                }
                console.log(newFormattedMetric);
              }

              console.log(metricsPlot2);
              this.setState({
                selectedForecastPlotData2: newFormattedMetric,
                combinedPlotData2: metricsPlot2.concat(newFormattedMetric),
              });
              sessionStorage.setItem("selectedForecastPlotData2", plottype2);
            }
          }
        }

        if (districtPlotType) {
          this.setState({
            selectedDistrictMetric: districtPlotType,
          });
          for (let item in this.state.metricsJSON) {
            if (item === districtPlotType) {
              console.log(item);
              console.log(
                "After plot selection in onChange Function:  ",
                this.state.metricsJSON[item]
              );
              console.log(
                "Searching for type:  ",
                this.state.metricsJSON[item][0].type
              );

              let newFormattedMetric;
              if (this.state.metricsJSON[item]) {
                switch (this.state.metricsJSON[item][0].type) {
                  case "city":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      districtPlotType: "city",
                    });
                    break;
                  case "district":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      districtPlotType: "district",
                    });
                    break;
                  case "transportation":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Car": item.Car,
                        "Forecasted Rail": item.Rail,
                        "Forecasted Bus": item.Bus,
                        "Forecasted Bike": item.Bike,
                        "Forecasted Walk": item.Walk,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Car"];
                        delete item["Forecasted Rail"];
                        delete item["Forecasted Bus"];
                        delete item["Forecasted Bike"];
                        delete item["Forecasted Walk"];
                      }
                    });

                    this.setState({
                      districtPlotType: "transportation",
                    });
                    break;
                  case "districtrevenue":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      districtPlotType: "districtrevenue",
                    });
                    break;
                  case "cityrevenue":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      districtPlotType: "cityrevenue",
                    });
                    break;
                  case "districtcost":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted Corbusville"];
                        delete item["Forecasted Downtown"];
                        delete item["Forecasted HowardGardens"];
                        delete item["Forecasted JacobsHill"];
                        delete item["Forecasted MosesGulch"];
                      }
                    });

                    this.setState({
                      districtPlotType: "districtcost",
                    });
                    break;
                  case "citycost":
                    newFormattedMetric = this.state.metricsJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => {
                      console.log(typeof item.year);
                      console.log(
                        typeof sessionStorage.getItem("previous_year")
                      );
                      if (
                        item.year !==
                        parseInt(sessionStorage.getItem("previous_year"))
                      ) {
                        console.log(item.year);
                        delete item["Forecasted City"];
                      }
                    });

                    this.setState({
                      districtPlotType: "citycost",
                    });
                    break;
                  default:
                    break;
                }
                console.log(newFormattedMetric);
              }
              this.setState({
                selectedDistrictPlotData: newFormattedMetric,
              });
              metricsPlot = newFormattedMetric;
              sessionStorage.setItem("selectedDistrictPlot", districtPlotType);
            }
          }

          for (let item in this.state.forecastJSON) {
            console.log(districtPlotType);
            console.log(item);
            if (item === districtPlotType) {
              console.log(item);
              console.log(
                "After plot selection in onChange Function:  ",
                this.state.forecastJSON[item]
              );
              console.log(
                "Searching for type:  ",
                this.state.forecastJSON[item][0].type
              );

              let newFormattedMetric;

              if (this.state.forecastJSON[item]) {
                switch (this.state.forecastJSON[item][0].type) {
                  case "city":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      districtPlotType: "city",
                    });
                    break;
                  case "district":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      districtPlotType: "district",
                    });

                    break;
                  case "transportation":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Walk": item.Walk,
                        "Forecasted Car": item.Car,
                        "Forecasted Rail": item.Rail,
                        "Forecasted Bus": item.Bus,
                        "Forecasted Bike": item.Bike,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.Car);
                    newFormattedMetric.forEach((item) => delete item.Rail);

                    newFormattedMetric.forEach((item) => delete item.Bus);

                    newFormattedMetric.forEach((item) => delete item.Bike);

                    newFormattedMetric.forEach((item) => delete item.Walk);

                    this.setState({
                      districtPlotType: "transportation",
                    });
                    break;
                  case "districtcost":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      districtPlotType: "districtcost",
                    });
                    break;
                  case "citycost":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      districtPlotType: "citycost",
                    });
                    break;
                  case "districtrevenue":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item, index) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted Corbusville": item.Corbusville,
                        "Forecasted Downtown": item.Downtown,
                        "Forecasted HowardGardens": item.HowardGardens,
                        "Forecasted JacobsHill": item.JacobsHill,
                        "Forecasted MosesGulch": item.MosesGulch,
                      })
                    );
                    newFormattedMetric.forEach(
                      (item) => delete item.Corbusville
                    );
                    newFormattedMetric.forEach((item) => delete item.Downtown);

                    newFormattedMetric.forEach(
                      (item) => delete item.HowardGardens
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.JacobsHill
                    );

                    newFormattedMetric.forEach(
                      (item) => delete item.MosesGulch
                    );

                    this.setState({
                      districtPlotType: "districtrevenue",
                    });
                    break;
                  case "cityrevenue":
                    newFormattedMetric = this.state.forecastJSON[item].map(
                      (item) => ({
                        ...item,
                        year: parseInt(item.year),
                        "Forecasted City": item.City,
                      })
                    );
                    newFormattedMetric.forEach((item) => delete item.City);
                    this.setState({
                      districtPlotType: "cityrevenue",
                    });
                    break;
                  default:
                    break;
                }
                console.log(newFormattedMetric);
              }

              console.log(metricsPlot);
              this.setState({
                selectedForecastDistrictPlotData: newFormattedMetric,
                combinedDistrictPlotData: metricsPlot.concat(
                  newFormattedMetric
                ),
              });
              sessionStorage.setItem(
                "selectedForecastDistrictPlot",
                districtPlotType
              );
            }
          }
        }
      }
    });
    this.socket.addEventListener("error", (e) => {
      console.log("ws error", e);
      if (this.socket) {
        this.socket.close();
      }
    });
  };

  setZones = (Commercial, Green, Mixed, Residential, Parking) => {
    if (Commercial && Green && Mixed && Residential && Parking) {
      // console.log(Commercial + Green + Mixed + Residential + Parking)
      this.setState({
        Total: Commercial + Green + Mixed + Residential + Parking,
      });
    }
  };

  setDistrictDefaults = () => {
    // console.log("Inside setDistrictDefaults");
    let district;
    let defaultCommercial;
    let defaultGreen;
    let defaultMixed;
    let defaultResidential;
    let defaultParking;

    const sectors = [
      "Corbusville",
      "Downtown",
      "Jacobs Hill",
      "Moses Gulch",
      "Howard Gardens",
    ];

    for (let i = 0; i < sectors.length; i++) {
      const zoneMixes = this.state.districtPolicyData
        .filter((item) => item.sector === sectors[i])
        .filter((item) => item.name === "Zoning Mix")[0].parameters;
      if (!sessionStorage.getItem(`${sectors[i]}/Commercial`)) {
        let comVal = Object.values(zoneMixes).filter(
          (item) => item.name === "Commercial"
        )[0].defaultValue;
        sessionStorage.setItem(`${sectors[i]}/Commercial`, comVal);
      } else if (!sessionStorage.getItem(`${sectors[i]}/Residential`)) {
        let resVal = Object.values(zoneMixes).filter(
          (item) => item.name === "Residential"
        )[0].defaultValue;
        sessionStorage.setItem(`${sectors[i]}/Residential`, resVal);
      } else if (!sessionStorage.getItem(`${sectors[i]}/Green`)) {
        let grnVal = Object.values(zoneMixes).filter(
          (item) => item.name === "Green"
        )[0].defaultValue;
        sessionStorage.setItem(`${sectors[i]}/Green`, grnVal);
      } else if (!sessionStorage.getItem(`${sectors[i]}/Mixed`)) {
        let mixVal = Object.values(zoneMixes).filter(
          (item) => item.name === "Mixed"
        )[0].defaultValue;
        sessionStorage.setItem(`${sectors[i]}/Mixed`, mixVal);
      }
    }

    //Check to see if forecast data is present
    if (
      sessionStorage.getItem("districtForecastData") ||
      sessionStorage.getItem("districtForecastData") !== "undefined" ||
      sessionStorage.getItem("districtForecastData") !== undefined ||
      sessionStorage.getItem("districtForecastData") !== null
    ) {
      // console.log(
      //   "District Forecast Data from session storage is:  " +
      //   sessionStorage.getItem("districtForecastData")
      // );
      this.setState({
        forecastJSON: JSON.parse(
          sessionStorage.getItem("districtForecastData")
        ),
      });
    }

    // Checking to see if district is available
    if (window.location.href.split("/")[5]) {
      switch (window.location.href.split("/")[5]) {
        case "corbusville":
          district = "Corbusville";
          console.log(district);
          if (!sessionStorage.getItem(`${district}`)) {
            this.setState({
              [window.location.href.split("/")[5]]: policyJSON
                .filter(
                  (item) => item.configuration === parseFloat(this.city_config)
                )
                .filter((item) => item.sector === "Corbusville")
                .map((item) => [item.polindex, item.defaultValue]),
            });
          } else {
            this.setState({
              [window.location.href.split("/")[5]]: JSON.parse(
                sessionStorage.getItem(`${district}`)
              ).pollist,
            });
          }
          break;
        case "jacobs_hill":
          district = "Jacobs Hill";
          if (!sessionStorage.getItem(`${district}`)) {
            this.setState({
              [window.location.href.split("/")[5]]: policyJSON
                .filter(
                  (item) => item.configuration === parseFloat(this.city_config)
                )
                .filter((item) => item.sector === "Jacobs Hill")
                .map((item) => [item.polindex, item.defaultValue]),
            });
          } else {
            this.setState({
              [window.location.href.split("/")[5]]: JSON.parse(
                sessionStorage.getItem(`${district}`)
              ).pollist,
            });
          }
          break;
        case "downtown":
          district = "Downtown";
          if (!sessionStorage.getItem(`${district}`)) {
            this.setState({
              [window.location.href.split("/")[5]]: policyJSON
                .filter(
                  (item) => item.configuration === parseFloat(this.city_config)
                )
                .filter((item) => item.sector === "Downtown")
                .map((item) => [item.polindex, item.defaultValue]),
            });
          } else {
            this.setState({
              [window.location.href.split("/")[5]]: JSON.parse(
                sessionStorage.getItem(`${district}`)
              ).pollist,
            });
          }
          break;
        case "howard_gardens":
          district = "Howard Gardens";
          if (!sessionStorage.getItem(`${district}`)) {
            this.setState({
              [window.location.href.split("/")[5]]: policyJSON
                .filter(
                  (item) => item.configuration === parseFloat(this.city_config)
                )
                .filter((item) => item.sector === "Howard Gardens")
                .map((item) => [item.polindex, item.defaultValue]),
            });
          } else {
            this.setState({
              [window.location.href.split("/")[5]]: JSON.parse(
                sessionStorage.getItem(`${district}`)
              ).pollist,
            });
          }
          break;
        case "moses_gulch":
          district = "Moses Gulch";
          if (!sessionStorage.getItem(`${district}`)) {
            this.setState({
              [window.location.href.split("/")[5]]: policyJSON
                .filter(
                  (item) => item.configuration === parseFloat(this.city_config)
                )
                .filter((item) => item.sector === "Moses Gulch")
                .map((item) => [item.polindex, item.defaultValue]),
            });
          } else {
            this.setState({
              [window.location.href.split("/")[5]]: JSON.parse(
                sessionStorage.getItem(`${district}`)
              ).pollist,
            });
          }
      }
    }

    // If district is available, set variables for default values from the JSON
    let zoneDefaultSelections;
    if (district) {
      zoneDefaultSelections = zoneVarJSON.filter(
        (item) => item.sector === district
      );
      const zoneMixes = this.state.districtPolicyData
        .filter((item) => item.sector === district)
        .filter((item) => item.category === "Land Use")[0].parameters;
      // console.log(this.state.policyData.filter(item => item.sector === district)
      // .filter(item => item.category === "Land Use")[0])
      defaultCommercial = Object.values(zoneMixes).filter(
        (item) => item.name === "Commercial"
      )[0].defaultValue;
      defaultGreen = Object.values(zoneMixes).filter(
        (item) => item.name === "Green"
      )[0].defaultValue;
      defaultMixed = Object.values(zoneMixes).filter(
        (item) => item.name === "Mixed"
      )[0].defaultValue;
      defaultResidential = Object.values(zoneMixes).filter(
        (item) => item.name === "Residential"
      )[0].defaultValue;
      defaultParking = Object.values(zoneMixes).filter(
        (item) => item.name === "Parking"
      )[0].defaultValue;
    }

    //If state is not set, set as the default from the JSON
    if (this.state.Commercial === null || this.state.Commercial === undefined) {
      console.log("No state for commercial");
      this.setState({
        Commercial: defaultCommercial,
      });
    }
    if (this.state.Green === null || this.state.Green === undefined) {
      this.setState({
        Green: defaultGreen,
      });
    }
    if (this.state.Mixed === null || this.state.Mixed === undefined) {
      this.setState({
        Mixed: defaultMixed,
      });
    }
    if (
      this.state.Residential === null ||
      this.state.Residential === undefined
    ) {
      this.setState({
        Residential: defaultResidential,
      });
    }
    if (this.state.Parking === null || this.state.Parking === undefined) {
      this.setState({
        Parking: defaultParking,
      });
    }
    //If session storage does not have a value, set it
    if (district) {
      if (!sessionStorage.getItem(`${district}/Commercial`)) {
        sessionStorage.setItem(`${district}/Commercial`, defaultCommercial);
      } else {
        this.setState({
          Commercial: parseInt(
            sessionStorage.getItem(`${district}/Commercial`)
          ),
        });
      }
      if (!sessionStorage.getItem(`${district}/Green`)) {
        sessionStorage.setItem(`${district}/Green`, defaultGreen);
      } else {
        this.setState({
          Green: parseInt(sessionStorage.getItem(`${district}/Green`)),
        });
      }
      if (!sessionStorage.getItem(`${district}/Mixed`)) {
        sessionStorage.setItem(`${district}/Mixed`, defaultMixed);
      } else {
        this.setState({
          Mixed: parseInt(sessionStorage.getItem(`${district}/Mixed`)),
        });
      }
      if (!sessionStorage.getItem(`${district}/Residential`)) {
        sessionStorage.setItem(`${district}/Residential`, defaultResidential);
      } else {
        this.setState({
          Residential: parseInt(
            sessionStorage.getItem(`${district}/Residential`)
          ),
        });
      }
      if (!sessionStorage.getItem(`${district}/Parking`)) {
        sessionStorage.setItem(`${district}/Parking`, defaultParking);
      } else {
        this.setState({
          Parking: parseInt(sessionStorage.getItem(`${district}/Parking`)),
        });
      }
    }

    this.setZones(
      parseInt(sessionStorage.getItem(`${district}/Commercial`)),
      parseInt(sessionStorage.getItem(`${district}/Green`)),
      parseInt(sessionStorage.getItem(`${district}/Mixed`)),
      parseInt(sessionStorage.getItem(`${district}/Residential`)),
      parseInt(sessionStorage.getItem(`${district}/Parking`))
    );

    let newVarValues = [];
    if (district) {
      console.log(district);
      console.log(
        "Inside setDistrictDefaults, zone selections: ",
        zoneDefaultSelections
      );
      for (let i = 0; i < zoneDefaultSelections.length; i++) {
        if (zoneDefaultSelections[i].regName === "Commercial") {
          zoneDefaultSelections[i].currentVal = parseInt(
            sessionStorage.getItem(`${district}/Commercial`)
          );
          newVarValues.push(zoneDefaultSelections[i]);
        } else if (zoneDefaultSelections[i].regName === "Green") {
          zoneDefaultSelections[i].currentVal = parseInt(
            sessionStorage.getItem(`${district}/Green`)
          );
          newVarValues.push(zoneDefaultSelections[i]);
        } else if (zoneDefaultSelections[i].regName === "Mixed") {
          zoneDefaultSelections[i].currentVal = parseInt(
            sessionStorage.getItem(`${district}/Mixed`)
          );
          newVarValues.push(zoneDefaultSelections[i]);
        } else if (zoneDefaultSelections[i].regName === "Residential") {
          zoneDefaultSelections[i].currentVal = parseInt(
            sessionStorage.getItem(`${district}/Residential`)
          );
          newVarValues.push(zoneDefaultSelections[i]);
        } else {
          newVarValues.push(zoneDefaultSelections[i]);
        }
      }
      this.setState({
        zoneSelections: newVarValues,
      });
      let newZoneObject = {};
      if (zoneDefaultSelections) {
        console.log(this.state.zoneSelections);

        for (let i = 0; i < zoneDefaultSelections.length; i++) {
          newZoneObject[zoneDefaultSelections[i].varName] =
            zoneDefaultSelections[i].currentVal;
        }
        console.log(newZoneObject);
        this.setState({
          zoneVarsOnly: newZoneObject,
        });
      }
      if (!sessionStorage.getItem(`${district}`)) {
        console.log("setting new district session storage object");
        sessionStorage.setItem(
          `${district}`,
          JSON.stringify({
            city_id: parseFloat(this.city_id),
            sector_name: district,
            pollist: this.state[window.location.href.split("/")[5]],
            varsObj: newZoneObject,
          })
        );
      }
    }
  };

  lockCheck = () => {
    // console.groupCollapsed("DistrictEngagement:lockCheck");
    if (
      this.state.Inform >= this.state.InformTarget &&
      !this.state.InformMaxReached
    ) {
      console.log(
        `This is the counter: ${this.state.Inform} and this is the target: ${
          this.state.InformTarget
        }`
      );
      this.setState({
        ConsultLock: false,
      });
    } else if (this.state.Inform < this.state.InformTarget) {
      // console.log(
      //   `This is the counter: ${this.state.Inform} and this is the target: ${this.state.InformTarget}`
      // );
      this.setState({
        ConsultLock: true,
      });
    }

    if (
      this.state.Inform >= this.state.InformTarget &&
      this.state.Consult >= this.state.ConsultTarget &&
      !this.state.ConsultMaxReached
    ) {
      console.log(
        `This is the Inform counter: ${
          this.state.Inform
        } and this is the Inform target: ${
          this.state.InformTarget
        } This is the Consult counter: ${
          this.state.Consult
        } and this is the Consult target: ${this.state.ConsultTarget}`
      );
      this.setState({
        InvolveLock: false,
      });
    } else if (
      this.state.Inform >= this.state.InformTarget &&
      this.state.Consult < this.state.ConsultTarget
    ) {
      console.log(
        `This is the Inform counter: ${
          this.state.Inform
        } and this is the Inform target: ${
          this.state.InformTarget
        } This is the Consult counter: ${
          this.state.Consult
        } and this is the Consult target: ${this.state.ConsultTarget}`
      );
      this.setState({
        InvolveLock: true,
      });
    }

    if (
      this.state.Inform >= this.state.InformTarget &&
      this.state.Consult >= this.state.ConsultTarget &&
      this.state.Involve >= this.state.InvolveTarget &&
      !this.state.InvolveMaxReached
    ) {
      this.setState({
        CollaborateLock: false,
      });
    } else if (
      this.state.Inform >= this.state.InformTarget &&
      this.state.Consult >= this.state.ConsultTarget &&
      this.state.Involve < this.state.InvolveTarget
    ) {
      this.setState({
        CollaborateLock: true,
      });
    }
    console.groupEnd();
  };

  setEngagementDefaults = () => {
    // console.groupCollapsed("DistrictEngagement:setDefaults");
    let targetsFromJSON = this.state.districtEngagementData;

    for (let i = 0; i < targetsFromJSON.length; i++) {
      if (sessionStorage.getItem(`${targetsFromJSON[i].name}MaxButton`)) {
        this.setState({
          [`${targetsFromJSON[i].name}MaxButton`]: sessionStorage.getItem(
            `${targetsFromJSON[i].name}MaxButton`
          ),
        });
      } else {
        this.setState({
          [`${targetsFromJSON[i].name}MaxButton`]: null,
        });
      }
      // console.log(
      //   sessionStorage.getItem(`${targetsFromJSON[i].name}MaxReached`)
      // );
      if (
        sessionStorage.getItem(`${targetsFromJSON[i].name}MaxReached`) ===
        "true"
      ) {
        // console.log("Max is true");
        // this.setState({
        //   [`${targetsFromJSON[i].name}MaxReached`]: true
        // });
      } else if (
        !sessionStorage.getItem(`${targetsFromJSON[i].name}MaxReached`) ||
        sessionStorage.getItem(`${targetsFromJSON[i].name}MaxReached`) ===
          "false"
      ) {
        // console.log("Max is out");
        // this.setState({
        //   [`${targetsFromJSON[i].name}MaxReached`]: false
        // });
      }
      let total = 0;
      // console.log(targetsFromJSON[i])
      // console.log(targetsFromJSON[i].name)
      // console.log(targetsFromJSON[i].parameters)

      //Set Category Objects
      if (sessionStorage.getItem(`${targetsFromJSON[i].name}Obj`)) {
        // console.log(sessionStorage.getItem(`${targetsFromJSON[i].name}Obj`))
        this.setState({
          [`${targetsFromJSON[i].name}Obj`]: JSON.parse(
            sessionStorage.getItem(`${targetsFromJSON[i].name}Obj`)
          ),
        });
        for (let key in JSON.parse(
          sessionStorage.getItem(`${targetsFromJSON[i].name}Obj`)
        )) {
          // console.log([key][0]);
          // console.log(
          //   JSON.parse(sessionStorage.getItem(`${targetsFromJSON[i].name}Obj`))[
          //     key
          //   ]
          // );
          if (
            !JSON.parse(
              sessionStorage.getItem(`${targetsFromJSON[i].name}Obj`)
            )[key]
          ) {
            sessionStorage.setItem(`${[key][0]}`, false);
          }
        }
      }

      //Set Toggled Values
      for (let item in targetsFromJSON[i].parameters) {
        //Compare with session storage to see if
        let formattedName = Object.values(
          targetsFromJSON[i].parameters[item]
        )[0]
          .replace(" ", "_")
          .toLowerCase();
        // console.log(formattedName)
        if (sessionStorage.getItem(`${formattedName}`)) {
          // console.log(`${formattedName} is present in storage...and...`)
          // console.log(`Here is its value: ${sessionStorage.getItem(formattedName)} and type ${typeof(sessionStorage.getItem(formattedName))}`)
          if (sessionStorage.getItem(`${formattedName}`) === "true") {
            // console.log(`${formattedName} was labled as true`)
            this.setState({
              [formattedName]: true,
            });
          } else if (sessionStorage.getItem(`${formattedName}`) === "false") {
            // console.log(`${formattedName} was labled as false`)
            this.setState({
              [formattedName]: false,
            });
          }
        } else if (!sessionStorage.getItem(`${formattedName}`)) {
          // console.log(`Nothing present in storage for ${formattedName}`)
          this.setState({
            [formattedName]: false,
          });
        }

        total += Object.values(targetsFromJSON[i].parameters[item])[1];
        sessionStorage.setItem(
          `${Object.values(targetsFromJSON[i].parameters[item])[0]}`,
          `${total}`
        );
      }
      // console.log(total)
      if (sessionStorage.getItem(targetsFromJSON[i].name)) {
        this.setState({
          [`${targetsFromJSON[i].name}`]: sessionStorage.getItem(
            targetsFromJSON[i].name
          ),
        });
      }
      this.setState({
        [`${targetsFromJSON[i].name}Target`]: total,
      });
    }
    // console.log(this.state.engagementData);
    if (this.state.engagementData) {
      //set locks and counters if present
    }
    console.groupEnd();
  };

  componentDidMount() {
    // console.groupCollapsed("Navigation:componentDidMount");
    this.eventListenerSelections();
    // setInterval(() => {
    //   this.eventSource.close();
    //   this.eventListenerSelections();
    // }, 10000);

    // this.setEngagementPolicyHeader();
    this.setState({
      messageDivVisibility: "visible",
      messageMessage: `Welcome to the game, the year is ${
        this.state.previousYear
      }.`,
      messageType: "Success",
    });
    this.lockCheck();

    if (this.student_is_manager === "false") {
      this.setState({
        disabledButton: true,
      });
    } else if (this.student_is_manager === "true") {
      this.setState({
        disabledButton: false,
      });
    }

    this.setState({
      cityPolicies: policyJSON
        .filter((item) => item.configuration === parseFloat(this.city_config))
        .filter((item) => item.sector === "City"),
      citySelections: policyJSON
        .filter((item) => item.configuration === parseFloat(this.city_config))
        .filter((item) => item.sector === "City")
        .map((item) => [item.polindex, item.defaultValue]),
    });

    if (this.city_skey) {
      this.fetchCityMetrics(this.city_skey);
    }
    if (this.city_id) {
      this.fetchPolicies(
        this.city_id,
        this.state.currentYear,
        this.state.previousYear
      );
    }

    this.setDistrictDefaults();

    if (this.sName === undefined) {
      window.location.replace("/");
    } else {
      const name = window.location.href.split("/")[4];
      this.setState({
        selected: name,
      });
    }

    sessionStorage.setItem("policyheading", "overview");

    if (
      sessionStorage.getItem("currentEngagement") === "undefined" ||
      !sessionStorage.getItem("currentEngagement")
    ) {
      this.setState({ currentEngagement: 100 });
      sessionStorage.setItem("currentEngagement", 100);
    } else {
      this.setState({
        currentEngagement: sessionStorage.getItem("currentEngagement"),
      });
    }

    if (
      sessionStorage.getItem("totalEngagement") === "undefined" ||
      !sessionStorage.getItem("totalEngagement")
    ) {
      this.setState({ totalEngagement: 100 });
      sessionStorage.setItem("totalEngagement", 100);
    } else {
      this.setState({
        totalEngagement: sessionStorage.getItem("totalEngagement"),
      });
    }

    if (
      sessionStorage.getItem("engagementCounter") === "undefined" ||
      !sessionStorage.getItem("engagementCounter")
    ) {
      this.setState({ engagementCounter: 100 });
      sessionStorage.setItem("engagementCounter", 100);
    } else {
      this.setState({
        engagementCounter: sessionStorage.getItem("engagementCounter"),
      });
    }
    if (
      sessionStorage.getItem("engageObj") === "undefined" ||
      !sessionStorage.getItem("engageObj")
    ) {
      this.setState({ engageObj: {} });
    } else {
      // console.log("Engagement State Reset");
      this.setState({
        engageObj: JSON.parse(sessionStorage.getItem("engageObj")),
      });
    }

    let suspendedObj = {};

    if (sessionStorage.getItem("InformMaxReached") === "true") {
      // console.log("Info Max Reached");
      suspendedObj["InformMaxReached"] = true;
    } else if (
      sessionStorage.getItem("InformMaxReached") === "false" ||
      !sessionStorage.getItem("InformMaxReached")
    ) {
      // console.log("Info Max Not Reached");
      suspendedObj["InformMaxReached"] = false;
    }

    if (sessionStorage.getItem("ConsultMaxReached") === "true") {
      suspendedObj["ConsultMaxReached"] = true;
    } else if (
      sessionStorage.getItem("ConsultMaxReached") === "false" ||
      !sessionStorage.getItem("ConsultMaxReached")
    ) {
      suspendedObj["ConsultMaxReached"] = false;
    }

    if (sessionStorage.getItem("InvolveMaxReached") === "true") {
      suspendedObj["InvolveMaxReached"] = true;
    } else if (
      sessionStorage.getItem("InvolveMaxReached") === "false" ||
      !sessionStorage.getItem("InvolveMaxReached")
    ) {
      suspendedObj["InvolveMaxReached"] = false;
    }

    if (sessionStorage.getItem("CollaborateMaxReached") === "true") {
      suspendedObj["CollaborateMaxReached"] = true;
    } else if (
      sessionStorage.getItem("CollaborateMaxReached") === "false" ||
      !sessionStorage.getItem("CollaborateMaxReached")
    ) {
      suspendedObj["CollaborateMaxReached"] = false;
    }
    let falseCounter = 0;
    for (let item in suspendedObj) {
      if (suspendedObj[item] === true) {
        this.setState({
          suspendButton: true,
        });
      }

      if (suspendedObj[item] === false) {
        falseCounter++;
      }
      if (falseCounter === 4) {
        this.setState({
          suspendButton: false,
        });
      }
      if (
        sessionStorage.getItem("cityForecastData") !== "undefined" ||
        sessionStorage.getItem("cityForecastData") !== undefined ||
        sessionStorage.getItem("cityForecastData") !== null
      ) {
        // console.log(
        //   "Cityforecast data in session storage is:  " +
        //   sessionStorage.getItem("cityForecastData")
        // );
        this.setState({
          forecastJSON: JSON.parse(sessionStorage.getItem("cityForecastData")),
        });
      } else {
        this.setState({
          forecastJSON: "",
        });
      }
    }

    console.groupEnd();
  }

  componentWillMount() {
    this.setEngagementDefaults();
  }

  onDistrictPolicyClickHandler = (e) => {
    e.preventDefault();

    const zoneMixes = this.state.districtPolicyData
      .filter((item) => item.sector === this.state.districtName)
      .filter((item) => item.category === "Land Use")[0].parameters;
    const defaultCommercial = Object.values(zoneMixes).filter(
      (item) => item.name === "Commercial"
    )[0].defaultValue;
    const defaultGreen = Object.values(zoneMixes).filter(
      (item) => item.name === "Green"
    )[0].defaultValue;
    const defaultMixed = Object.values(zoneMixes).filter(
      (item) => item.name === "Mixed"
    )[0].defaultValue;
    const defaultResidential = Object.values(zoneMixes).filter(
      (item) => item.name === "Residential"
    )[0].defaultValue;
    const defaultParking = Object.values(zoneMixes).filter(
      (item) => item.name === "Parking"
    )[0].defaultValue;
    console.log(zoneMixes);
    console.log(this.state.policyNavSelection);
    const districtSubPolicyDefaultValue = this.state.districtPolicyData
      .filter((item) => item.sector === this.state.districtName)
      .filter((item) => item.category === this.state.policyNavSelection)
      .filter((item) => item.name === e.target.getAttribute("subpol"))[0]
      .defaultValue;

    console.log(
      `These are the zone mix values, Commercial, state:  ${
        this.state.Commercial
      } and ss ${sessionStorage.getItem(
        this.state.districtName + "/Commercial"
      )}`
    );

    if (this.state.Commercial === null || this.state.Commercial === undefined) {
      console.log("State is being reset to default...");
      this.setState({
        Commercial: defaultCommercial,
      });
    }
    if (this.state.Green === null || this.state.Green === undefined) {
      this.setState({
        Green: defaultGreen,
      });
    }
    if (this.state.Mixed === null || this.state.Mixed === undefined) {
      this.setState({
        Mixed: defaultMixed,
      });
    }
    if (
      this.state.Residential === null ||
      this.state.Residential === undefined
    ) {
      this.setState({
        Residential: defaultResidential,
      });
    }
    if (this.state.Parking === null || this.state.Parking === undefined) {
      this.setState({
        Parking: defaultParking,
      });
    }
    // if the value of the default and the current value is the same, keep as the default value.  Used this to maintain default values if nothing changed from prev value.
    console.log(
      `DefaultCommercial: ${defaultCommercial} Commercial in state: ${
        this.state.Commercial
      }`
    );
    // Set the subpolicy value
    this.setState({
      districtSubPolicy: e.target.getAttribute("subpol"),
    });

    //if the item has never been selected, set selected item as default from JSON, otherwise set as in session storage

    if (
      sessionStorage.getItem(
        `${this.state.districtName}/${e.target.getAttribute("subpol")}`
      )
    ) {
      console.log(
        "----IN SUBPOLICY, SS SUBPOLICY FOUND FOR " +
          this.state.districtName +
          " " +
          e.target.getAttribute("subpol")
      );
      this.setState({
        districtSubPolicyDefaultValue: sessionStorage.getItem(
          `${this.state.districtName}/${e.target.getAttribute("subpol")}`
        ),
      });
    } else {
      console.log(
        "----IN SUBPOLICY, NO SS SUBPOLICY FOUND FOR " +
          this.state.districtName +
          " " +
          e.target.getAttribute("subpol") +
          " set as: " +
          districtSubPolicyDefaultValue
      );
      this.setState({
        districtSubPolicyDefaultValue: districtSubPolicyDefaultValue,
      });
    }
    console.log(
      `Inside Subpolicy Click, for Previousyear: ${
        this.state.previousYear
      }, subpolicy: ${e.target.getAttribute("subpol")}, and district Name:  ${
        this.state.districtName
      }`
    );

    //If the previous year's item does not exist in session storage, use the above value, otherwise, use the previous year's value from session storage
    if (
      sessionStorage.getItem(
        `${this.state.previousYear}/${
          this.state.districtName
        }/${e.target.getAttribute("subpol")}`
      )
    ) {
      console.log("---CHECKING FOR LAST YEAR'S VALUE, FOUND IT");
      this.setState({
        districtSubPolicyPrevtValue: sessionStorage.getItem(
          `${this.state.previousYear}/${
            this.state.districtName
          }/${e.target.getAttribute("subpol")}`
        ),
      });
    } else {
      console.log("---CHECKING FOR LAST YEAR'S VALUE, DIDNT FIND IT");
      this.setState({
        districtSubPolicyPrevtValue: districtSubPolicyDefaultValue,
      });
    }
  };

  onCityPolicyClickHandler = (e) => {
    e.preventDefault();

    //---FIRSTCHILD NODE VALUE AND GET ATTRIBUTE ARE THE SAME--
    // console.log(
    //   "NODE VALUE: " +
    //   e.target.firstChild.nodeValue +
    //   " CITYPOL: " +
    //   e.target.getAttribute("citypol")
    // );

    //-----------------------

    const citySubPolicyDefaultValue = this.state.cityPolicies.filter(
      (item) => item.name === e.target.getAttribute("citypol")
    )[0].defaultValue;

    this.setState({
      citySubPolicy: e.target.getAttribute("citypol"),
    });

    if (sessionStorage.getItem(`City/${e.target.firstChild.nodeValue}`)) {
      this.setState({
        citySubPolicyDefaultValue: sessionStorage.getItem(
          `City/${e.target.getAttribute("citypol")}`
        ),
      });
    } else {
      this.setState({
        citySubPolicyDefaultValue: citySubPolicyDefaultValue,
      });
    }

    if (
      sessionStorage.getItem(
        `${this.state.previousYear}/City/${e.target.getAttribute("citypol")}`
      )
    ) {
      // console.log("---CHECKING FOR LAST YEAR'S VALUE, FOUND IT");
      // console.log(
      //   sessionStorage.getItem(
      //     `${this.state.previousYear}/City/${e.target.getAttribute('citypol')}`
      //   )
      // );
      this.setState({
        citySubPolicyPrevtValue: sessionStorage.getItem(
          `${this.state.previousYear}/City/${e.target.getAttribute("citypol")}`
        ),
      });
    } else {
      console.log("---CHECKING FOR LAST YEAR'S VALUE, DIDNT FIND IT");
      this.setState({
        citySubPolicyPrevtValue: citySubPolicyDefaultValue,
      });
    }
  };

  citySelectionFunction = (policy_id, newValue) => {
    // console.groupCollapsed("Navigation:selectionFunction");
    // console.log(
    //   "This function creates an array of selections to be sent to the back-end for model processing"
    // );
    // console.timeLog("selection made");
    const newSelection = [policy_id, newValue];
    const newArray = [];
    for (let i = 0; i < this.state.citySelections.length; i++) {
      if (this.state.citySelections[i][0] === policy_id) {
        newArray.push(newSelection);
      } else {
        newArray.push(this.state.citySelections[i]);
      }
    }
    // console.log(newArray);
    this.setState({
      citySelections: newArray,
    });

    sessionStorage.setItem(
      `City`,
      JSON.stringify({
        city_id: parseFloat(this.city_id),
        sector_name: "City",
        pollist: newArray,
        varsObj: { CxCityHolderVal: 0 },
      })
    );
    // console.log(
    //   "Object has been created and sent to session storage, back to onSelectHandler..."
    // );
    // console.groupEnd();
  };

  onCitySelectHandler = (e) => {
    // console.groupCollapsed("Navigation:onSelectHandler");
    // console.time("selection made");
    e.preventDefault();

    if (!this.state.citySubmitted) {
      // console.log(
      //   `${this.state.citySubPolicy} has not yet been submitted, please test by pressing the submit button`
      // );
      let diff = Math.abs(
        parseInt(e.target.value) -
          parseInt(e.target.getAttribute("previousval"))
      );
      // console.log(
      //   `${this.state.citySubPolicy} is ${diff} step away from the default`
      // );

      if (!isNaN(diff)) {
        this.engagementFunc(`City/${this.state.citySubPolicy}`, diff);
      } else {
        this.engagementFunc(`City/${this.state.citySubPolicy}`, 0);
      }
    } else {
      // console.log(this.state.subPolicy);
      let diff = Math.abs(
        parseInt(
          sessionStorage.getItem(`submitted/City/${this.state.citySubPolicy}`)
        ) - parseInt(e.target.value)
      );
      if (!isNaN(diff)) {
        this.engagementFunc(`City/${this.state.citySubPolicy}`, diff);
      } else {
        this.engagementFunc(`City/${this.state.citySubPolicy}`, 0);
      }
    }

    sessionStorage.setItem(
      `engagement`,
      JSON.stringify({
        city_id: parseFloat(this.city_id),
        engagement: {
          currentEngagement: sessionStorage.getItem("currentEngagement"),
          totalEngagement: sessionStorage.getItem("totalEngagement"),
          Inform: sessionStorage.getItem("Inform"),
          InformTarget: this.state.InformTarget,
          InformLock: this.state.InformLock,
          InformMaxReached: this.state.InformMaxReached,
          InformObj: sessionStorage.getItem("InformObj"),
          InformSubmitted: this.state.InformSubmitted,
          Consult: sessionStorage.getItem("Consult"),
          ConsultTarget: this.state.ConsultTarget,
          ConsultLock: this.state.ConsultLock,
          ConsultDisabled: this.state.ConsultDisabled,
          ConsultMaxReached: this.state.ConsultMaxReached,
          ConsultObj: sessionStorage.getItem("ConsultObj"),
          ConsultSubmitted: this.state.ConsultSubmitted,
          Involve: sessionStorage.getItem("Involve"),
          InvolveTarget: this.state.InvolveTarget,
          InvolveLock: this.state.InvolveLock,
          InvolveDisabled: this.state.InvolveDisabled,
          InvolveMaxReached: this.state.InvolveMaxReached,
          InvolveObj: sessionStorage.getItem("InvolveObj"),
          InvolveSubmitted: this.state.InvolveSubmitted,
          Collaborate: sessionStorage.getItem("Collaborate"),
          CollaborateTarget: this.state.CollaborateTarget,
          CollaborateLock: this.state.CollaborateLock,
          CollaborateDisabled: this.state.CollaborateDisabled,
          CollaborateObj: sessionStorage.getItem("CollaborateObj"),
          CollaborateMaxReached: this.state.CollaborateMaxReached,
          CollaborateSubmitted: this.state.CollaborateSubmitted,
          engageObj: sessionStorage.getItem("engageObj"),
        },
      })
    );

    this.citySelectionFunction(
      parseFloat(e.target.getAttribute("polid")),
      e.target.value
    );

    // console.log(
    //   "...Back in onSelectHandler...setting the subpolicy default value, which should change the selected button to the new selection..."
    // );

    this.setState({
      citySubPolicyDefaultValue: e.target.value,
    });

    // console.log("...new value set in state..." + e.target.value);

    sessionStorage.setItem(
      `City/${this.state.citySubPolicy}`,
      `${e.target.value}`
    );

    //---YEAR BEING SET HERE----//

    // console.log(
    //   `Item being set for the year in session storage ${e.target.getAttribute(
    //     "year"
    //   )}/City/${this.state.citySubPolicy} , value:  ${e.target.value}`
    // );
    sessionStorage.setItem(
      `${e.target.getAttribute("year")}/City/${this.state.citySubPolicy}`,
      `${e.target.value}`
    );
    // console.log(
    //   `this is what EngageObj looks like before being sent to the client:  ${sessionStorage.getItem(
    //     "engageObj"
    //   )}`
    // );
    // console.log(
    //   `session storage being sent to back end to be routed to other clients...`
    // );
    // console.time("to session storage");
    axios
      .post(this.fetchURL + "/api/v1/selections/", {
        selections: sessionStorage,
        city_skey: this.city_skey,
      })
      .then((response) => {
        this.setState({ startRequestSent: false });
        if (response.data.success) {
          console.timeEnd("Routing to back-end successful...");
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({ startRequestSent: false });
        this.setState({
          messageDivVisibility: "visible",
          messageMessage:
            "There are currently too many people accessing the network, please make your selection again.",
          messageType: "Error",
        });
      });
    // console.timeEnd("selection made");
    // console.groupEnd();
  };

  onEngagementRunSelectionHandler = () => {
    axios
      .post(this.fetchURL + "/api/v1/selections/", {
        selections: sessionStorage,
        city_skey: this.city_skey,
      })
      .then((response) => {
        this.setState({ startRequestSent: false });
        if (response.data.success) {
          console.groupCollapsed("Selections Routing Test Started");
          console.log("Test Successfull!");
          console.log(response.data.data);
          console.groupEnd();
        }
      })
      //     this.setState({
      //       snackOpen: true,
      //       snackMsg: response.data.message,
      //       snackType: "snack-success",
      //       snackAutoHideDuration: 5000
      //     });

      //     // added to update objectives after starting the scenario
      //     window.location.reload();
      //   } else {
      //     console.log(response.data.message);
      //     this.setState({
      //       snackOpen: true,
      //       snackMsg: response.data.message,
      //       snackType: "snack-error",
      //       snackAutoHideDuration: null
      //     });
      //   }
      // })
      .catch((error) => {
        console.log(error.response);
        this.setState({ startRequestSent: false });
        this.setState({
          messageDivVisibility: "visible",
          messageMessage:
            "There are currently too many people accessing the network, please make your selection again.",
          messageType: "Error",
        });
      });
  };

  onEngagementSelectHandler = async (e) => {
    console.groupCollapsed("DistrictEngagement:onSelectHandler");
    e.preventDefault();

    let diff = -Math.abs(e.target.getAttribute("engageval"));
    // console.log(diff)
    let formattedName = e.target
      .getAttribute("name")
      .replace(/ /g, "_")
      .toLowerCase();
    let value = e.target.getAttribute("engageVal");
    let category = this.state.engagementSubPolicy;
    let categoryObj = {};
    let categoryTotal = 0;

    this.setState({
      engagementDefaultValue: e.target.value,
    });

    if (this.state[formattedName]) {
      console.log("Formatted name present");
      // console.log(this.state[category]);
      categoryObj = this.state[`${category}Obj`];
      if (this.state[formattedName] === false) {
        console.log(`${formattedName} is false`);
        this.setState({
          [category]: (this.state[category] += parseInt(value)),
        });
        if (this.state[category]) {
          categoryTotal = parseInt(this.state[category]);
        } else {
          categoryTotal = 0;
        }
        categoryObj[formattedName] = value;
        // console.log(this.state.fact_sheets);
        console.log(categoryObj);
        for (let item in categoryObj) {
          // console.log("Inside the for loop")
          // console.log(categoryObj[item])
          // console.log(categoryTotal)
          categoryTotal += parseInt(categoryObj[item]);
          // console.log("Inform in if for loop: " + this.state.Inform)
          // this.setState({categoryTotal: categoryTotal, [category]: categoryTotal})
          // this.lockCheck()
          if (this.state.categoryTotal > this.state[`${category}Max`]) {
            // console.log(`This is the total for ${category}:  ` + categoryTotal)
            console.log(categoryObj);
            this.setState({
              [`${category}MaxReached`]: true,
            });
          } else {
            console.log(categoryObj);
            this.setState({
              [`${category}MaxReached`]: false,
            });
          }
        }
        // console.log(categoryTotal)
        this.setState({
          [formattedName]: true,
          [`${category}Obj`]: categoryObj,
          categoryTotal: categoryTotal,
          [category]: categoryTotal,
        });
        sessionStorage.setItem(`${category}Obj`, JSON.stringify(categoryObj));
        sessionStorage.setItem(formattedName, true);
        sessionStorage.setItem(category, categoryTotal);
        this.lockCheck();
        await this.engagementFunc(formattedName, diff);
        // console.log("Inform outside the for loop: " + this.state.Inform)
      } else if (this.state[formattedName] === true) {
        // console.log(`${formattedName} is true: ` + this.state[formattedName]);
        this.setState({
          [category]: (this.state[category] -= parseInt(value)),
        });

        categoryTotal = 0;

        categoryObj = this.state[`${category}Obj`];
        categoryObj[formattedName] = 0;
        this.setState({
          [formattedName]: false,
        });
        sessionStorage.setItem(formattedName, false);
        await this.engagementFunc(formattedName, 0);

        for (let item in categoryObj) {
          // console.log(categoryObj);
          // console.log(categoryObj[item]);
          categoryTotal += parseInt(categoryObj[item]);
          // console.log(categoryTotal);
          // console.log("Inform in if for loop: " + this.state.Inform);
          if (categoryTotal > this.state[`${category}Max`]) {
            // console.log(`This is the total for ${category}:  ` + categoryTotal);
            console.log(categoryObj);
            this.setState({
              [`${category}MaxReached`]: true,
            });
            sessionStorage.setItem(`${category}MaxReached`, true);
            let comparoKey = 0;
            let comparoKeyName;
            for (let key in categoryObj) {
              if (parseInt(categoryObj[key]) > comparoKey) {
                console.log(key);
                comparoKey = parseInt(categoryObj[key]);
                comparoKeyName = key;
              } else if (parseInt(categoryObj[key]) === comparoKey) {
                console.log("equal");
                console.log(key);
                comparoKey = parseInt(categoryObj[key]);
                comparoKeyName = key;
              }
              console.log(comparoKeyName);
              let unFormattedText = comparoKeyName
                .split("_")
                .map((s) => s.charAt(0).toUpperCase() + s.substring(1))
                .join(" ");
              console.log(unFormattedText);
              sessionStorage.setItem(`${category}MaxButton`, unFormattedText);
              this.setState({
                [`${category}MaxButton`]: unFormattedText,
              });
            }
          } else {
            console.log(categoryObj);
            this.setState({
              [`${category}MaxReached`]: false,
              [`${category}MaxButton`]: null,
            });
            sessionStorage.setItem(`${category}MaxReached`, false);
            sessionStorage.setItem(`${category}MaxButton`, null);
          }
        }
        // console.log(categoryTotal);
        // console.log("Inform out of for loop: " + this.state.Inform);
        this.setState({
          [`${category}Obj`]: categoryObj,
          categoryTotal: categoryTotal,
          [category]: categoryTotal,
        });
        console.log(
          "Inside OnEngagementSelectHandler, categoryObj, categoryTotal, category:  ",
          [`${category}Obj`],
          " ",
          categoryTotal,
          " ",
          [category]
        );
        sessionStorage.setItem(category, categoryTotal);
        if (!isNaN(parseInt(sessionStorage.getItem(`${category}Submitted`)))) {
          console.log(categoryTotal);
          let newTotal =
            categoryTotal +
            parseInt(sessionStorage.getItem(`${category}Submitted`));
          this.setState({
            [category]: newTotal,
          });
          sessionStorage.setItem(category, newTotal);
          // console.log("Total of running and existing: " + newTotal)
        }

        sessionStorage.setItem(`${category}Obj`, JSON.stringify(categoryObj));
        await this.lockCheck();
      }
    } else if (!this.state[formattedName]) {
      console.log(`${formattedName} is newly added`);
      // console.log(`${formattedName} is new or false`);
      // console.log(parseInt(this.state[category]));
      let sessionStorageValue;
      console.log(parseInt(value));

      if (sessionStorage.getItem(`${category}`)) {
        sessionStorageValue = parseInt(sessionStorage.getItem(`${category}`));
        console.log(sessionStorageValue);
        this.setState({
          [category]: (this.state[category] += parseInt(value)),
        });
      } else {
        this.setState({
          [category]: (this.state[category] += parseInt(value)),
        });
      }

      console.log(category);
      // console.log(parseInt(this.state[category]));
      let categoryTotal = 0;
      console.log(this.state.ConsultObj);
      if (this.state[`${category}Obj`]) {
        categoryObj = this.state[`${category}Obj`];
      } else {
        categoryObj = {};
      }
      console.log("Item Created in Object: " + JSON.stringify(categoryObj));
      categoryObj[formattedName] = value;

      //KEEPS A RUNNING TOTAL OF THE ITEMS IN THE OBJECT

      for (let item in categoryObj) {
        // console.log("Inside the for loop");
        categoryTotal += parseInt(categoryObj[item]);
        // console.log(categoryTotal);
        this.setState({
          categoryTotal: categoryTotal,
          [category]: categoryTotal,
        });
        sessionStorage.setItem(category, categoryTotal);
        if (categoryTotal > this.state[`${category}Max`]) {
          console.log(e.target.getAttribute("name"));
          this.setState({
            [`${category}MaxReached`]: true,
            [`${category}MaxButton`]: e.target.getAttribute("name"),
          });
          sessionStorage.setItem(`${category}MaxReached`, true);
          sessionStorage.setItem(
            `${category}MaxButton`,
            e.target.getAttribute("name")
          );
        } else {
          console.log(categoryObj);
          this.setState({
            [`${category}MaxReached`]: false,
          });
        }
      }
      //-----------------------------------------------//

      // console.log(typeof(sessionStorage.getItem("InformSubmitted")))
      // console.log(typeof(categoryTotal))

      if (!isNaN(parseInt(sessionStorage.getItem(`${category}Submitted`)))) {
        console.log(
          "Inside conditional where I think its happening" +
            categoryTotal +
            " " +
            parseInt(sessionStorage.getItem(`${category}Submitted`))
        );
        let newTotal =
          categoryTotal +
          parseInt(sessionStorage.getItem(`${category}Submitted`));
        this.setState({
          [category]: newTotal,
        });
        sessionStorage.setItem(category, newTotal);
        // console.log("Total of running and existing: " + newTotal)
      }

      // console.log("Running Lock Check");
      await this.lockCheck();

      this.setState({
        [formattedName]: true,
        [`${category}Obj`]: categoryObj,
      });
      sessionStorage.setItem(formattedName, true);
      sessionStorage.setItem(`${category}Obj`, JSON.stringify(categoryObj));
      await this.engagementFunc(formattedName, diff);
    }

    this.lockCheck();

    // this.props.engagementFunc(formattedName, diff)
    console.log(sessionStorage.getItem("engageObj"));
    await sessionStorage.setItem(
      `engagement`,
      JSON.stringify({
        city_id: parseFloat(this.city_id),
        engagement: {
          currentEngagement: sessionStorage.getItem("currentEngagement"),
          totalEngagement: sessionStorage.getItem("totalEngagement"),
          Inform: sessionStorage.getItem("Inform"),
          InformTarget: this.state.InformTarget,
          InformLock: this.state.InformLock,
          InformMaxReached: this.state.InformMaxReached,
          InformObj: sessionStorage.getItem("InformObj"),
          InformSubmitted: this.state.InformSubmitted,
          Consult: sessionStorage.getItem("Consult"),
          ConsultTarget: this.state.ConsultTarget,
          ConsultLock: this.state.ConsultLock,
          ConsultDisabled: this.state.ConsultDisabled,
          ConsultMaxReached: this.state.ConsultMaxReached,
          ConsultObj: sessionStorage.getItem("ConsultObj"),
          ConsultSubmitted: this.state.ConsultSubmitted,
          Involve: sessionStorage.getItem("Involve"),
          InvolveTarget: this.state.InvolveTarget,
          InvolveLock: this.state.InvolveLock,
          InvolveDisabled: this.state.InvolveDisabled,
          InvolveMaxReached: this.state.InvolveMaxReached,
          InvolveObj: sessionStorage.getItem("InvolveObj"),
          InvolveSubmitted: this.state.InvolveSubmitted,
          Collaborate: sessionStorage.getItem("Collaborate"),
          CollaborateTarget: this.state.CollaborateTarget,
          CollaborateLock: this.state.CollaborateLock,
          CollaborateDisabled: this.state.CollaborateDisabled,
          CollaborateObj: sessionStorage.getItem("CollaborateObj"),
          CollaborateMaxReached: this.state.CollaborateMaxReached,
          CollaborateSubmitted: this.state.CollaborateSubmitted,
          engageObj: sessionStorage.getItem("engageObj"),
        },
      })
    );
    this.onEngagementRunSelectionHandler();

    console.groupEnd();
  };

  onEngagementClickHandler = (e) => {
    console.groupCollapsed("DistrictEngagement:onClickHandler");
    e.preventDefault();
    this.setState({
      engagementSubPolicy: e.target.getAttribute("subpol"),
    });

    const engagementDefaultValue = this.state.districtEngagementData.filter(
      (item) => item.name === e.target.getAttribute("subpol")
    )[0].defaultValue;

    if (
      sessionStorage.getItem(
        `${this.state.districtName}/${e.target.getAttribute("subpol")}`
      )
    ) {
      this.setState({
        engagementSubPolicyDefaultValue: sessionStorage.getItem(
          `${this.state.districtName}/${e.target.getAttribute("subpol")}`
        ),
      });
    } else {
      this.setState({
        engagementDefaultValue: engagementDefaultValue,
      });
    }
    console.groupEnd();
  };

  onEngagementSubmitHandler = async (e) => {
    console.groupCollapsed("DistrictEngagement:onSubmitHandler");
    e.preventDefault();

    this.setState({
      snackAutoHideDuration: 500,
      engagementSuspended: true,
    });

    sessionStorage.setItem(
      `engagement`,
      JSON.stringify({
        city_id: parseFloat(this.city_id),
        engagement: {
          currentEngagement: sessionStorage.getItem("currentEngagement"),
          totalEngagement: sessionStorage.getItem("totalEngagement"),
          Inform: sessionStorage.getItem("Inform"),
          InformTarget: this.state.InformTarget,
          InformLock: this.state.InformLock,
          InformMaxReached: this.state.InformMaxReached,
          InformObj: sessionStorage.getItem("InformObj"),
          InformSubmitted: this.state.InformSubmitted,
          Consult: sessionStorage.getItem("Consult"),
          ConsultTarget: this.state.ConsultTarget,
          ConsultLock: this.state.ConsultLock,
          ConsultDisabled: this.state.ConsultDisabled,
          ConsultMaxReached: this.state.ConsultMaxReached,
          ConsultObj: sessionStorage.getItem("ConsultObj"),
          ConsultSubmitted: this.state.ConsultSubmitted,
          Involve: sessionStorage.getItem("Involve"),
          InvolveTarget: this.state.InvolveTarget,
          InvolveLock: this.state.InvolveLock,
          InvolveDisabled: this.state.InvolveDisabled,
          InvolveMaxReached: this.state.InvolveMaxReached,
          InvolveObj: sessionStorage.getItem("InvolveObj"),
          InvolveSubmitted: this.state.InvolveSubmitted,
          Collaborate: sessionStorage.getItem("Collaborate"),
          CollaborateTarget: this.state.CollaborateTarget,
          CollaborateLock: this.state.CollaborateLock,
          CollaborateDisabled: this.state.CollaborateDisabled,
          CollaborateObj: sessionStorage.getItem("CollaborateObj"),
          CollaborateMaxReached: this.state.CollaborateMaxReached,
          CollaborateSubmitted: this.state.CollaborateSubmitted,
          engageObj: sessionStorage.getItem("engageObj"),
        },
      })
    );

    await this.engagementSetTotalEngagement();
    await this.setEngagementDefaults();
    const moses_gulch = JSON.parse(sessionStorage.getItem("Moses Gulch"));
    const downtown = JSON.parse(sessionStorage.getItem("Downtown"));
    const jacobs_hill = JSON.parse(sessionStorage.getItem("Jacobs Hill"));
    const howard_gardens = JSON.parse(sessionStorage.getItem("Howard Gardens"));
    const corbusville = JSON.parse(sessionStorage.getItem("Corbusville"));
    const city = JSON.parse(sessionStorage.getItem("City"));
    const engagement = JSON.parse(sessionStorage.getItem("engagement"));
    let sectorsArray = [
      moses_gulch,
      downtown,
      jacobs_hill,
      howard_gardens,
      corbusville,
      city,
      engagement,
    ];
    let validSectorsArray = [];

    for (let i = 0; i < sectorsArray.length; i++) {
      if (sectorsArray[i]) {
        validSectorsArray.push(sectorsArray[i]);
      }
    }

    await axios
      .post(this.fetchURL + "/api/v1/policies/submissions/", {
        city_id: this.city_id,
        sector_name: "City",
        pollist: this.state.selections,
        varsObj: { CxCityHolderVal: 0 },
        submitObject: validSectorsArray,
      })
      .then((response) => {
        this.setState({ startRequestSent: false });
        if (response.data.success) {
          console.groupCollapsed("Policy Submissions Test");
          console.log("Test Successfull!");
          console.log(response.data.data);
          this.onsubmitSyncToClients();
          console.groupEnd();
          this.messageTemporary(500);
        } else if (!response.data.success) {
          console.log(response.data.message);
          this.setState({
            snackOpen: true,
            snackMsg: response.data.message,
            snackType: "snack-error",
            snackAutoHideDuration: null,
            engagementSuspended: false,
            messageDivVisibility: "visible",
            messageMessage: response.data.message,
            messageType: "Error",
          });
        }
      })
      //     this.setState({
      //       snackOpen: true,
      //       snackMsg: response.data.message,
      //       snackType: "snack-success",
      //       snackAutoHideDuration: 5000
      //     });

      //     // added to update objectives after starting the scenario
      //     window.location.reload();
      // } else {
      //   console.log(response.data.message);
      //   this.setState({
      //     snackOpen: true,
      //     snackMsg: response.data.message,
      //     snackType: "snack-error",
      //     snackAutoHideDuration: null
      //   });
      // }
      // })
      .catch((error) => {
        console.log(error.response);
        // this.setState({ startRequestSent: false });
        this.setState({
          messageDivVisibility: "visible",
          messageMessage:
            "There are currently too many people accessing the network, please make your selection again.",
          messageType: "Error",
        });
      });

    console.groupEnd();
  };

  onForecastHandler = () => {
    axios
      .post(this.fetchURL + "/api/v1/cities/forecast/", {
        city_id: this.city_id,
        city_name: this.city_name,
        city_skey: this.city_skey,
      })
      .then((response) => {
        this.setState({ startRequestSent: false });
        if (response.data.success) {
          // console.groupCollapsed("Policy Submissions Test");
          // console.log("Test Successfull!");
          // console.log(response.data.data);
          // console.groupEnd();
        }
        this.setState({ forecasting: false });
      })
      .catch((error) => {
        console.log(error.response);
        // this.setState({ startRequestSent: false });
        this.setState({
          messageDivVisibility: "visible",
          messageMessage:
            "There are currently too many people accessing the network, please make your selection again.",
          messageType: "Error",
          forecasting: false,
        });
      });
    console.groupEnd();
  };

  onForecastSubmit = (e) => {
    e.preventDefault();
    this.setState({ forecasting: true });
    const moses_gulch = JSON.parse(sessionStorage.getItem("Moses Gulch"));
    const downtown = JSON.parse(sessionStorage.getItem("Downtown"));
    const jacobs_hill = JSON.parse(sessionStorage.getItem("Jacobs Hill"));
    const howard_gardens = JSON.parse(sessionStorage.getItem("Howard Gardens"));
    const corbusville = JSON.parse(sessionStorage.getItem("Corbusville"));
    const city = JSON.parse(sessionStorage.getItem("City"));
    // const engagement = JSON.parse(sessionStorage.getItem("engagement"));
    let sectorsArray = [
      moses_gulch,
      downtown,
      jacobs_hill,
      howard_gardens,
      corbusville,
      city,
      // engagement
    ];
    let validSectorsArray = [];

    for (let i = 0; i < sectorsArray.length; i++) {
      if (sectorsArray[i]) {
        validSectorsArray.push(sectorsArray[i]);
      }
    }
    axios
      .post(this.fetchURL + "/api/v1/policies/forecast_submissions/", {
        city_id: this.city_id,
        sector_name: "City",
        pollist: this.state.selections,
        varsObj: { CxCityHolderVal: 0 },
        submitObject: validSectorsArray,
      })
      .then((response) => {
        this.setState({ startRequestSent: false });
        if (response.data.success) {
          console.groupCollapsed("Policy Submissions Test");
          console.log("Test Successfull!");
          console.log(response.data.data);
          this.onForecastHandler();
          console.groupEnd();
        } else if (!response.data.success) {
          console.log("dude, there's nothing there!");
          this.setState({
            // snackOpen: true,
            // snackMsg: "No policies to submit",
            // snackType: "snack-error",
            // snackAutoHideDuration: 5000,
            messageDivVisibility: "visible",
            messageMessage: "Please choose initial policies first.",
            messageType: "Warning",
            forecasting: false,
          });

          this.setState({ submitting: false });
        }
      })
      .catch((error) => {
        console.log(error.response);
        // this.setState({ startRequestSent: false });
        this.setState({
          messageDivVisibility: "visible",
          messageMessage:
            "There are currently too many people accessing the network, please make your selection again.",
          messageType: "Error",
          forecasting: false,
        });
      });
  };

  onsubmitSyncToClients = () => {
    console.log("Inside sync function");
    axios
      .post(this.fetchURL + "/api/v1/selections/", {
        selections: sessionStorage,
        city_skey: this.city_skey,
      })
      .then((response) => {
        this.setState({
          startRequestSent: false,
          submitting: false,
          disabledButton: false,
        });
        if (response.data.success) {
          console.groupCollapsed("Selections Routing Test Started");
          console.log("Test Successfull!");
          console.log(response.data.data);
          console.groupEnd();
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({ startRequestSent: false });
        this.setState({
          messageDivVisibility: "visible",
          messageMessage:
            "There are currently too many people accessing the network, please make your selection again.",
          messageType: "Error",
        });
      });
  };

  onCitySubmitHandler = async (e) => {
    e.preventDefault();
    console.log("In submit");
    console.log(this.city_id);
    console.log(this.state.citySelections);

    if (this.state.citySelections && this.city_id) {
      console.log("submitted");
      this.setState({
        citySubmitted: true,
        submitted: true,
        submitting: true,
        snackAutoHideDuration: 500,
        disabledButton: true,
      });
      for (let i = 0; i < this.state.citySelections.length; i++) {
        console.log(this.state.citySelections[i]);
        console.log(
          policyJSON.filter(
            (item) => item.polindex === this.state.citySelections[i][0]
          )[0].name
        );
        sessionStorage.setItem(
          `submitted/City/${
            policyJSON.filter(
              (item) => item.polindex === this.state.citySelections[i][0]
            )[0].name
          }`,
          `${this.state.citySelections[i][1]}`
        );
      }
      if (sessionStorage.getItem(`City/${this.state.citySubPolicy}`))
        console.log(
          "Item was submitted, this is the new default value:  " +
            this.state.citySubPolicyDefaultValue
        );
      await this.setTotalEngagement();
      // this.props.setEngagement(sessionStorage.getItem("currentEngagement"), sessionStorage.getItem("totalEngagement"))
      const moses_gulch = JSON.parse(sessionStorage.getItem("Moses Gulch"));
      const downtown = JSON.parse(sessionStorage.getItem("Downtown"));
      const jacobs_hill = JSON.parse(sessionStorage.getItem("Jacobs Hill"));
      const howard_gardens = JSON.parse(
        sessionStorage.getItem("Howard Gardens")
      );
      const corbusville = JSON.parse(sessionStorage.getItem("Corbusville"));
      const city = JSON.parse(sessionStorage.getItem("City"));
      const engagement = JSON.parse(sessionStorage.getItem("engagement"));
      let sectorsArray = [
        moses_gulch,
        downtown,
        jacobs_hill,
        howard_gardens,
        corbusville,
        city,
        engagement,
      ];
      let validSectorsArray = [];

      for (let i = 0; i < sectorsArray.length; i++) {
        if (sectorsArray[i]) {
          validSectorsArray.push(sectorsArray[i]);
        }
      }

      await axios
        .post(this.fetchURL + "/api/v1/policies/submissions/", {
          city_id: this.city_id,
          sector_name: "City",
          pollist: this.state.selections,
          varsObj: { CxCityHolderVal: 0 },
          submitObject: validSectorsArray,
        })
        .then((response) => {
          this.setState({ startRequestSent: false });
          if (response.data.success) {
            console.groupCollapsed("Policy Submissions Test");
            console.log("Test Successfull!");
            console.log(response.data.data);
            this.onsubmitSyncToClients();
            console.groupEnd();
            this.messageTemporary(500);
          } else if (!response.data.success) {
            console.log("dude, there's nothing there!");
            this.setState({
              messageDivVisibility: "visible",
              messageMessage: response.data.message,
              messageType: "Error",
            });

            this.setState({ submitting: false, disabledButton: false });
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.setState({
            messageDivVisibility: "visible",
            messageMessage:
              "There are currently too many people accessing the network, please wait before making your selection again.",
            messageType: "Error",
            submitting: false,
            disabledButton: false,
          });
        });
      console.groupEnd();
    }
  };

  onDistrictSubmitHandler = async (e) => {
    let districtUrl = window.location.href.split("/")[5];
    e.preventDefault();

    if (
      this.state.districtName &&
      this.state[districtUrl] &&
      this.state.zoneVarsOnly &&
      this.city_id
    ) {
      // console.log("submitted");
      this.setState({
        districtSubmitted: true,
        submitting: true,
        disabledButton: true,
      });
      for (let i = 0; i < this.state[districtUrl].length; i++) {
        sessionStorage.setItem(
          `submitted/${districtUrl}/${
            policyJSON.filter(
              (item) => item.polindex === this.state[districtUrl][i][0]
            )[0].name
          }`,
          `${this.state[districtUrl][i][1]}`
        );
      }

      // console.log("Inside submit handler:  " + this.state.districtName);
      await this.setTotalEngagement();
      const moses_gulch = JSON.parse(sessionStorage.getItem("Moses Gulch"));
      const downtown = JSON.parse(sessionStorage.getItem("Downtown"));
      const jacobs_hill = JSON.parse(sessionStorage.getItem("Jacobs Hill"));
      const howard_gardens = JSON.parse(
        sessionStorage.getItem("Howard Gardens")
      );
      const corbusville = JSON.parse(sessionStorage.getItem("Corbusville"));
      const city = JSON.parse(sessionStorage.getItem("City"));
      const engagement = JSON.parse(sessionStorage.getItem("engagement"));

      let sectorsArray = [
        moses_gulch,
        downtown,
        jacobs_hill,
        howard_gardens,
        corbusville,
        city,
        engagement,
      ];
      let validSectorsArray = [];

      for (let i = 0; i < sectorsArray.length; i++) {
        if (sectorsArray[i]) {
          validSectorsArray.push(sectorsArray[i]);
        }
      }
      console.log(validSectorsArray);
      await axios
        .post(this.fetchURL + "/api/v1/policies/submissions/", {
          city_id: this.city_id,
          sector_name: this.state.districtName,
          pollist: this.state[districtUrl],
          varsObj: this.state.zoneVarsOnly,
          submitObject: validSectorsArray,
        })
        .then((response) => {
          this.setState({ startRequestSent: false });
          if (response.data.success) {
            console.groupCollapsed("Policy Submissions Test");
            console.log("Test Successfull!");
            console.log(response.data.data);
            this.onsubmitSyncToClients();
            console.groupEnd();
            this.messageTemporary(500);
          } else {
            console.log(response.data.message);
            this.setState({
              messageDivVisibility: "visible",
              messageMessage: response.data.message,
              messageType: "Error",
            });
            this.setState({ submitting: false, disabledButton: false });
          }
        })
        .catch((error) => {
          console.log(error.response);
          this.setState({
            messageDivVisibility: "visible",
            messageMessage:
              "There are currently too many people accessing the network, please make your selection again.",
            messageType: "Error",
            submitting: false,
            disabledButton: false,
          });
        });
      console.groupEnd();
    }
  };

  districtSelectionFunction = (policy_id, newValue) => {
    let districtUrl = window.location.href.split("/")[5];
    console.log(
      `${this.state.districtName} array in state: ${this.state[districtUrl]}`
    );
    console.log(this.state[districtUrl]);
    const newSelection = [policy_id, newValue];
    const newArray = [];
    for (let i = 0; i < this.state[districtUrl].length; i++) {
      if (this.state[districtUrl][i][0] === policy_id) {
        newArray.push(newSelection);
        console.log(`Selection ${policy_id} changed to ${newValue}`);
      } else {
        newArray.push(this.state[districtUrl][i]);
      }
    }
    console.log(newArray);
    this.setState({
      [districtUrl]: newArray,
    });
    console.log(this.state.zoneSelections);
    if (this.state.zoneSelections > 0) {
      console.log(this.state.zoneSelections);
      let newZoneObject = {};
      for (let i = 0; i < this.state.zoneSelections.length; i++) {
        newZoneObject[
          this.state.zoneSelections[i].varName
        ] = this.state.zoneSelections[i].currentVal;
      }
      // console.log(newZoneObject);
      this.setState({
        zoneVarsOnly: newZoneObject,
      });

      console.log(this.state.districtName);
      sessionStorage.setItem(
        `${this.state.districtName}`,
        JSON.stringify({
          city_id: parseFloat(this.city_id),
          sector_name: this.state.districtName,
          pollist: newArray,
          varsObj: this.state.zoneVarsOnly,
        })
      );
    } else {
      let newVarValues = [];
      let zoneDefaultSelections = zoneVarJSON.filter(
        (item) => item.sector === this.state.districtName
      );
      for (let i = 0; i < zoneDefaultSelections.length; i++) {
        if (
          zoneDefaultSelections[i].regName === "Commercial" &&
          sessionStorage.getItem(`${this.state.districtName}/Commercial`)
        ) {
          zoneDefaultSelections[i].currentVal = parseInt(
            sessionStorage.getItem(`${this.state.districtName}/Commercial`)
          );
          newVarValues.push(zoneDefaultSelections[i]);
        } else if (
          zoneDefaultSelections[i].regName === "Green" &&
          sessionStorage.getItem(`${this.state.districtName}/Green`)
        ) {
          zoneDefaultSelections[i].currentVal = parseInt(
            sessionStorage.getItem(`${this.state.districtName}/Green`)
          );
          newVarValues.push(zoneDefaultSelections[i]);
        } else if (
          zoneDefaultSelections[i].regName === "Mixed" &&
          sessionStorage.getItem(`${this.state.districtName}/Mixed`)
        ) {
          zoneDefaultSelections[i].currentVal = parseInt(
            sessionStorage.getItem(`${this.state.districtName}/Mixed`)
          );
          newVarValues.push(zoneDefaultSelections[i]);
        } else if (
          zoneDefaultSelections[i].regName === "Residential" &&
          sessionStorage.getItem(`${this.state.districtName}/Residential`)
        ) {
          zoneDefaultSelections[i].currentVal = parseInt(
            sessionStorage.getItem(`${this.state.districtName}/Residential`)
          );
          newVarValues.push(zoneDefaultSelections[i]);
        } else {
          newVarValues.push(zoneDefaultSelections[i]);
        }
      }
      console.log(newVarValues);
      this.setState({
        zoneSelections: newVarValues,
      });
      let districtUrl = window.location.href.split("/")[5];
      let newZoneObject = {};
      for (let i = 0; i < newVarValues.length; i++) {
        newZoneObject[newVarValues[i].varName] = newVarValues[i].currentVal;
      }
      console.log(newZoneObject);
      this.setState({
        zoneVarsOnly: newZoneObject,
      });

      sessionStorage.setItem(
        `${this.state.districtName}`,
        JSON.stringify({
          city_id: parseFloat(this.city_id),
          sector_name: this.state.districtName,
          pollist: newArray,
          varsObj: newZoneObject,
        })
      );
    }
  };

  onDistrictSelectHandler = (e) => {
    e.preventDefault();
    console.log("Inside DistrictSelectHandler");
    let districtUrl = window.location.href.split("/")[5];
    if (
      !this.state.districtSubmitted ||
      sessionStorage.getItem(
        `submitted/${districtUrl}/${this.state.districtSubPolicy}`
      ) === null
    ) {
      // console.log("Item not submitted yet");
      let diff = Math.abs(
        parseInt(e.target.value) -
          parseInt(e.target.getAttribute("previousval"))
      );
      // console.log("Diff before submit:  " + diff);
      if (!isNaN(diff)) {
        this.engagementFunc(
          `${districtUrl}/${this.state.districtSubPolicy}`,
          diff
        );
      } else {
        // console.log("DIFF WAS NAN, WHAT HAPPENED???????")
      }
    } else {
      // console.log(this.state.districtSubPolicy);
      // console.log(this.state.districtName);
      // console.log(`Here's what's being added to get the NAN:  session storage:  ${
      //   sessionStorage.getItem(
      //     `submitted/${districtUrl}/${this.state.districtSubPolicy}`)} and here is the target value: ${e.target.value}`)
      let diff = Math.abs(
        parseInt(
          sessionStorage.getItem(
            `submitted/${districtUrl}/${this.state.districtSubPolicy}`
          )
        ) - parseInt(e.target.value)
      );
      // console.log("Diff before submit:  " + diff);
      if (!isNaN(diff)) {
        this.engagementFunc(
          `${districtUrl}/${this.state.districtSubPolicy}`,
          diff
        );
      } else {
        // console.log("DIFF WAS NAN, WHAT HAPPENED???????")
      }
    }

    this.districtSelectionFunction(
      parseFloat(e.target.getAttribute("polid")),
      e.target.value
    );
    this.setState({
      districtSubPolicyDefaultValue: e.target.value,
    });
    sessionStorage.setItem(
      `${this.state.districtName}/${this.state.districtSubPolicy}`,
      `${e.target.value}`
    );
    sessionStorage.setItem(
      `${e.target.getAttribute("year")}/${this.state.districtName}/${
        this.state.districtSubPolicy
      }`,
      `${e.target.value}`
    );
    sessionStorage.setItem(
      `engagement`,
      JSON.stringify({
        city_id: parseFloat(this.city_id),
        engagement: {
          currentEngagement: sessionStorage.getItem("currentEngagement"),
          totalEngagement: sessionStorage.getItem("totalEngagement"),
          Inform: sessionStorage.getItem("Inform"),
          InformTarget: this.state.InformTarget,
          InformLock: this.state.InformLock,
          InformMaxReached: this.state.InformMaxReached,
          InformObj: sessionStorage.getItem("InformObj"),
          InformSubmitted: this.state.InformSubmitted,
          Consult: sessionStorage.getItem("Consult"),
          ConsultTarget: this.state.ConsultTarget,
          ConsultLock: this.state.ConsultLock,
          ConsultDisabled: this.state.ConsultDisabled,
          ConsultMaxReached: this.state.ConsultMaxReached,
          ConsultObj: sessionStorage.getItem("ConsultObj"),
          ConsultSubmitted: this.state.ConsultSubmitted,
          Involve: sessionStorage.getItem("Involve"),
          InvolveTarget: this.state.InvolveTarget,
          InvolveLock: this.state.InvolveLock,
          InvolveDisabled: this.state.InvolveDisabled,
          InvolveMaxReached: this.state.InvolveMaxReached,
          InvolveObj: sessionStorage.getItem("InvolveObj"),
          InvolveSubmitted: this.state.InvolveSubmitted,
          Collaborate: sessionStorage.getItem("Collaborate"),
          CollaborateTarget: this.state.CollaborateTarget,
          CollaborateLock: this.state.CollaborateLock,
          CollaborateDisabled: this.state.CollaborateDisabled,
          CollaborateObj: sessionStorage.getItem("CollaborateObj"),
          CollaborateMaxReached: this.state.CollaborateMaxReached,
          CollaborateSubmitted: this.state.CollaborateSubmitted,
          engageObj: sessionStorage.getItem("engageObj"),
          // fact_sheets: this.state.fact_sheets,
          // website: this.state.website,
          // newsletter: this.state.newsletter,
          // open_house: this.state.open_house,
          // surveys: this.state.surveys,
          // focus_groups: this.state.focus_groups,
          // public_meetings: this.state.public_meetings,
          // public_forums: this.state.public_forums,
          // utilizing_social_media: this.state.utilizing_social_media,
          // deliberative_polling: this.state.deliberative_polling,
          // workshops: this.state.workshops,
          // charrettes: this.state.charrettes,
          // consensus_building: this.state.consensus_building,
          // citizens_juries: this.state.citizens_juries,
          // advisory_board: this.state.advisory_board,
        },
      })
    );
    //-------Data to send to selections URL for broadcasting-----//
    // console.log(sessionStorage);
    axios
      .post(this.fetchURL + "/api/v1/selections/", {
        selections: sessionStorage,
        city_skey: this.city_skey,
      })
      .then((response) => {
        this.setState({ startRequestSent: false });
        if (response.data.success) {
          // console.groupCollapsed("Selections Routing Test Started");
          // console.log("Test Successfull!");
          // console.log(response.data.data);
          // console.groupEnd();
        }
      })
      //     this.setState({
      //       snackOpen: true,
      //       snackMsg: response.data.message,
      //       snackType: "snack-success",
      //       snackAutoHideDuration: 5000
      //     });

      //     // added to update objectives after starting the scenario
      //     window.location.reload();
      //   } else {
      //     console.log(response.data.message);
      //     this.setState({
      //       snackOpen: true,
      //       snackMsg: response.data.message,
      //       snackType: "snack-error",
      //       snackAutoHideDuration: null
      //     });
      //   }
      // })
      .catch((error) => {
        console.log(error.response);
        this.setState({
          messageDivVisibility: "visible",
          messageMessage:
            "There are currently too many people accessing the network, please make your selection again.",
          messageType: "Error",
        });
      });
    // console.groupEnd();
  };

  onPageClick = (page) => {
    // console.log(page);
    if (page === 1) {
      this.setState({ start: 0, stop: 8, districtSubPolicy: "" });
    } else if (page === 2) {
      this.setState({ start: 8, stop: 16, districtSubPolicy: "" });
    }
  };

  onZoneChange = (e, name, value) => {
    const regex = RegExp(/^\d{1,3}$/);
    console.log(value);
    console.log(regex.test(value));
    if (regex.test(value) === false) {
      e.preventDefault();
      console.log(value);
    }

    // console.log(e.target.getAttribute("varname"));
    let varName = e.target.getAttribute("varname");
    if (!value || regex.test(value) === false) {
      value = 0;
    }

    // Set session storage to recall to state when districtNama is
    sessionStorage.setItem(`${this.state.districtName}/${[name]}`, value);
    this.setState({
      [name]: parseFloat(value),
    });
    // console.log(
    //   "Setting zones:  , commercial has this vlaue in session storage:  " +
    //     sessionStorage.getItem(`${this.state.districtName}/Commercial`) +  " and this value in state " + this.state.Commercial
    // );
    this.setZones(
      parseInt(sessionStorage.getItem(`${this.state.districtName}/Commercial`)),
      parseInt(sessionStorage.getItem(`${this.state.districtName}/Green`)),
      parseInt(sessionStorage.getItem(`${this.state.districtName}/Mixed`)),
      parseInt(
        sessionStorage.getItem(`${this.state.districtName}/Residential`)
      ),
      parseInt(sessionStorage.getItem(`${this.state.districtName}/Parking`))
    );

    // console.log(sessionStorage);

    // console.log(varName);
    // console.log(this.state.zoneSelections);

    let newVarValues = [];
    //---TODO---
    //Change value where the varName matches the changed value.
    // If a varName is chosen and there is a district chosen, iterate through array
    console.log(this.state.districtName);
    console.log(this.state.zoneSelections);

    //-------Need to replicate this inside prop change///
    console.log(
      "There is a district name: " +
        this.state.districtName +
        " there is a varName: " +
        varName
    );
    if (this.state.districtName && varName) {
      //if zoneSelections length is 0, make a new one
      if (this.state.zoneSelections.length === 0) {
        console.log(
          "Zone selections is blank.  Make a new zone object here from the JSON and use it instead!"
        );
        let zoneDefaultSelections = zoneVarJSON.filter(
          (item) => item.sector === this.state.districtName
        );
        for (let i = 0; i < zoneDefaultSelections.length; i++) {
          if (zoneDefaultSelections[i].varName === varName) {
            zoneDefaultSelections[i].currentVal = parseInt(value);
            newVarValues.push(zoneDefaultSelections[i]);
          } else if (
            zoneDefaultSelections[i].regName === "Commercial" &&
            sessionStorage.getItem(`${this.state.districtName}/Commercial`)
          ) {
            zoneDefaultSelections[i].currentVal = parseInt(
              sessionStorage.getItem(`${this.state.districtName}/Commercial`)
            );
            newVarValues.push(zoneDefaultSelections[i]);
          } else if (
            zoneDefaultSelections[i].regName === "Green" &&
            sessionStorage.getItem(`${this.state.districtName}/Green`)
          ) {
            zoneDefaultSelections[i].currentVal = parseInt(
              sessionStorage.getItem(`${this.state.districtName}/Green`)
            );
            newVarValues.push(zoneDefaultSelections[i]);
          } else if (
            zoneDefaultSelections[i].regName === "Mixed" &&
            sessionStorage.getItem(`${this.state.districtName}/Mixed`)
          ) {
            zoneDefaultSelections[i].currentVal = parseInt(
              sessionStorage.getItem(`${this.state.districtName}/Mixed`)
            );
            newVarValues.push(zoneDefaultSelections[i]);
          } else if (
            zoneDefaultSelections[i].regName === "Residential" &&
            sessionStorage.getItem(`${this.state.districtName}/Residential`)
          ) {
            zoneDefaultSelections[i].currentVal = parseInt(
              sessionStorage.getItem(`${this.state.districtName}/Residential`)
            );
            newVarValues.push(zoneDefaultSelections[i]);
          } else {
            newVarValues.push(zoneDefaultSelections[i]);
          }
        }
      } else {
        for (let i = 0; i < this.state.zoneSelections.length; i++) {
          console.log("Inside zone change loop to set zone selections");
          if (this.state.zoneSelections[i].varName === varName) {
            this.state.zoneSelections[i].currentVal = parseInt(value);
            newVarValues.push(this.state.zoneSelections[i]);
          } else {
            newVarValues.push(this.state.zoneSelections[i]);
          }
        }
      }
      console.log(newVarValues);
      this.setState({
        zoneSelections: newVarValues,
      });
    }
    console.log(this.state.zoneSelections);
    if (this.state.zoneSelections.length > 0) {
      console.log(this.state.zoneSelections);
      let districtUrl = window.location.href.split("/")[5];
      let newZoneObject = {};
      for (let i = 0; i < this.state.zoneSelections.length; i++) {
        newZoneObject[
          this.state.zoneSelections[i].varName
        ] = this.state.zoneSelections[i].currentVal;
      }
      console.log(newZoneObject);
      this.setState({
        zoneVarsOnly: newZoneObject,
      });
      // console.log(districtUrl);
      sessionStorage.setItem(
        `${this.state.districtName}`,
        JSON.stringify({
          city_id: parseFloat(this.city_id),
          sector_name: this.state.districtName,
          pollist: this.state[districtUrl],
          varsObj: newZoneObject,
        })
      );
    } else {
      let districtUrl = window.location.href.split("/")[5];
      let newZoneObject = {};
      for (let i = 0; i < newVarValues.length; i++) {
        newZoneObject[newVarValues[i].varName] = newVarValues[i].currentVal;
      }
      console.log(newZoneObject);
      this.setState({
        zoneVarsOnly: newZoneObject,
      });
      // console.log(districtUrl);
      sessionStorage.setItem(
        `${this.state.districtName}`,
        JSON.stringify({
          city_id: parseFloat(this.city_id),
          sector_name: this.state.districtName,
          pollist: this.state[districtUrl],
          varsObj: newZoneObject,
        })
      );
    }
    // console.log(this.state.zoneVarsOnly);
    console.log(this.state.zoneSelections);

    axios
      .post(this.fetchURL + "/api/v1/selections/", {
        selections: sessionStorage,
        zoneSelections: this.state.zoneSelections,
        city_skey: this.city_skey,
      })
      .then((response) => {
        this.setState({ startRequestSent: false });
        if (response.data.success) {
          // console.groupCollapsed("Selections Routing Test Started");
          // console.log("Test Successfull!");
          // console.log(response.data.data);
          // console.groupEnd();
        }
      })
      .catch((error) => {
        console.log(error.response);
        this.setState({ startRequestSent: false });
        this.setState({
          messageDivVisibility: "visible",
          messageMessage:
            "There are currently too many people accessing the network, please make your selection again.",
          messageType: "Error",
        });
      });
    // console.groupEnd();
  };

  componentWillUnmount() {
    this.socket.close();
  }

  onMouseOverLandHandler(e) {
    e.preventDefault();
  }

  onMouseOverCorbusvilleHandler(e) {
    e.preventDefault();
    this.setState({ CorbusvilleHover: true });
  }
  onMouseOverDowntownHandler(e) {
    e.preventDefault();
    this.setState({ DowntownHover: true });
  }
  onMouseOverHowardHandler(e) {
    e.preventDefault();
    this.setState({ HowardHover: true });
  }
  onMouseOverJacobsHandler(e) {
    e.preventDefault();
    this.setState({ JacobsHover: true });
  }
  onMouseOverMosesHandler(e) {
    e.preventDefault();
    this.setState({ MosesHover: true });
  }

  onMouseOverHandler(e) {
    e.preventDefault();
  }

  onMouseOutHandler(e) {
    e.preventDefault();
    this.setState({ hover: false });
  }

  onMouseOutCorbusvilleHandler(e) {
    e.preventDefault();
    this.setState({ CorbusvilleHover: false });
  }

  onMouseOutDowntownHandler(e) {
    e.preventDefault();
    this.setState({ DowntownHover: false });
  }

  onMouseOutHowardHandler(e) {
    e.preventDefault();
    this.setState({ HowardHover: false });
  }

  onMouseOutJacobsHandler(e) {
    e.preventDefault();
    this.setState({ JacobsHover: false });
  }

  onMouseOutMosesHandler(e) {
    e.preventDefault();
    this.setState({ MosesHover: false });
  }

  onClickHandler = (e) => {
    e.preventDefault();
    let districtId = "Corbusville";
    districtId = e.target.id;
    if (districtId === "City") {
      // console.log("It's a city!");
      this.props.history.push(`/game/city/`);
      this.setState({ districtName: districtId });
    }
    if (
      sessionStorage.getItem("policyheading") !== "Overview" &&
      districtId !== "City"
    ) {
      this.props.history.push(
        `/game/district/` +
          districtId +
          `/${sessionStorage.getItem("policyheading")}/`
      );
    } else if (districtId !== "City") {
      this.props.history.push(`/game/district/` + districtId + `/overview/`);
    }

    this.setState({ districtName: districtId });
    this.setState({
      zoneSelections: zoneVarJSON.filter((item) => item.sector === districtId),
    });
  };

  onPlotChange1 = (e) => {
    let metricsPlot;
    let testPlot;
    this.setState({
      combinedPlotData1: [],
      selectedPlotData1: [],
      selectedForecastPlotData1: [],
    });
    const { name, value } = e.target;

    if (e.target.value) {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
    // console.log(this.state.forecastJSON);

    for (let item in this.state.metricsJSON) {
      if (item === e.target.value) {
        // console.log(item);
        // console.log(
        //   "After plot selection in onChange Function:  ",
        //   this.state.metricsJSON[item]
        // );
        // console.log(
        //   "Searching for type:  ",
        //   this.state.metricsJSON[item][0].type
        // );
        let newFormattedMetric;

        if (this.state.metricsJSON[item]) {
          switch (this.state.metricsJSON[item][0].type) {
            case "city":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted City"];
                }
              });

              this.setState({
                plotType1: "city",
              });
              break;
            case "district":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted Corbusville"];
                  delete item["Forecasted Downtown"];
                  delete item["Forecasted HowardGardens"];
                  delete item["Forecasted JacobsHill"];
                  delete item["Forecasted MosesGulch"];
                }
              });

              this.setState({
                plotType1: "district",
              });
              break;
            case "transportation":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Car": item.Car,
                  "Forecasted Rail": item.Rail,
                  "Forecasted Bus": item.Bus,
                  "Forecasted Bike": item.Bike,
                  "Forecasted Walk": item.Walk,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted Car"];
                  delete item["Forecasted Rail"];
                  delete item["Forecasted Bus"];
                  delete item["Forecasted Bike"];
                  delete item["Forecasted Walk"];
                }
              });

              this.setState({
                plotType1: "transportation",
              });
              break;
            case "districtcost":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted Corbusville"];
                  delete item["Forecasted Downtown"];
                  delete item["Forecasted HowardGardens"];
                  delete item["Forecasted JacobsHill"];
                  delete item["Forecasted MosesGulch"];
                }
              });

              this.setState({
                plotType1: "districtcost",
              });
              break;
            case "citycost":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted City"];
                }
              });

              this.setState({
                plotType1: "citycost",
              });
              break;
            case "districtrevenue":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted Corbusville"];
                  delete item["Forecasted Downtown"];
                  delete item["Forecasted HowardGardens"];
                  delete item["Forecasted JacobsHill"];
                  delete item["Forecasted MosesGulch"];
                }
              });

              this.setState({
                plotType1: "districtrevenue",
              });
              break;
            case "cityrevenue":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted City"];
                }
              });

              this.setState({
                plotType1: "cityrevenue",
              });
              break;
            default:
              break;
          }
          // console.log(newFormattedMetric);
        }
        this.setState({
          selectedPlotData1: newFormattedMetric,
        });
        metricsPlot = newFormattedMetric;
        testPlot = newFormattedMetric;
        sessionStorage.setItem("selectedPlot1", e.target.value);
      }
    }

    for (let item in this.state.forecastJSON) {
      // console.log(e.target.value);
      // console.log(item);
      if (item === e.target.value) {
        // console.log(item);
        // console.log(
        //   "After plot selection in onChange Function:  ",
        //   this.state.forecastJSON[item]
        // );
        // console.log(
        //   "Searching for type:  ",
        //   this.state.forecastJSON[item][0].type
        // );

        let newFormattedMetric;

        if (this.state.forecastJSON[item]) {
          switch (this.state.forecastJSON[item][0].type) {
            case "city":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => delete item.City);
              this.setState({
                plotType1: "city",
              });
              break;
            case "district":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => delete item.Corbusville);
              newFormattedMetric.forEach((item) => delete item.Downtown);

              newFormattedMetric.forEach((item) => delete item.HowardGardens);

              newFormattedMetric.forEach((item) => delete item.JacobsHill);

              newFormattedMetric.forEach((item) => delete item.MosesGulch);

              this.setState({
                plotType1: "district",
              });

              break;
            case "transportation":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Walk": item.Walk,
                  "Forecasted Car": item.Car,
                  "Forecasted Rail": item.Rail,
                  "Forecasted Bus": item.Bus,
                  "Forecasted Bike": item.Bike,
                })
              );
              newFormattedMetric.forEach((item) => delete item.Car);
              newFormattedMetric.forEach((item) => delete item.Rail);

              newFormattedMetric.forEach((item) => delete item.Bus);

              newFormattedMetric.forEach((item) => delete item.Bike);

              newFormattedMetric.forEach((item) => delete item.Walk);

              this.setState({
                plotType1: "transportation",
              });

              break;
            case "districtcost":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => delete item.Corbusville);
              newFormattedMetric.forEach((item) => delete item.Downtown);

              newFormattedMetric.forEach((item) => delete item.HowardGardens);

              newFormattedMetric.forEach((item) => delete item.JacobsHill);

              newFormattedMetric.forEach((item) => delete item.MosesGulch);

              this.setState({
                plotType1: "districtcost",
              });
              break;
            case "citycost":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => delete item.City);
              this.setState({
                plotType1: "citycost",
              });
              break;
            case "districtrevenue":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => delete item.Corbusville);
              newFormattedMetric.forEach((item) => delete item.Downtown);

              newFormattedMetric.forEach((item) => delete item.HowardGardens);

              newFormattedMetric.forEach((item) => delete item.JacobsHill);

              newFormattedMetric.forEach((item) => delete item.MosesGulch);

              this.setState({
                plotType1: "districtrevenue",
              });
              break;
            case "cityrevenue":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => delete item.City);
              this.setState({
                plotType1: "cityrevenue",
              });
              break;
          }
          // console.log(newFormattedMetric);
        }

        // console.log(metricsPlot);
        this.setState({
          selectedForecastPlotData1: newFormattedMetric,
          combinedPlotData1: metricsPlot.concat(newFormattedMetric),
        });
        sessionStorage.setItem("selectedForecastPlotData1", e.target.value);
        sessionStorage.setItem("selectedPlot1", e.target.value);
        // console.log(testPlot.concat(newFormattedMetric));
      }
    }
  };

  onPlotChange2 = (e) => {
    let metricsPlot;
    this.setState({
      combinedPlotData2: [],
      selectedPlotData2: [],
      selectedForecastPlotData2: [],
    });

    const { name, value } = e.target;

    if (e.target.value) {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }

    let newFormattedMetric;
    // console.log(this.state.metricsJSON);
    for (let item in this.state.metricsJSON) {
      if (item === e.target.value) {
        // console.log(item);
        // console.log(this.state.metricsJSON[item]);
        if (this.state.metricsJSON[item]) {
          switch (this.state.metricsJSON[item][0].type) {
            case "city":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted City"];
                }
              });

              this.setState({
                plotType2: "city",
              });
              break;
            case "district":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted Corbusville"];
                  delete item["Forecasted Downtown"];
                  delete item["Forecasted HowardGardens"];
                  delete item["Forecasted JacobsHill"];
                  delete item["Forecasted MosesGulch"];
                }
              });

              this.setState({
                plotType2: "district",
              });
              break;
            case "transportation":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Car": item.Car,
                  "Forecasted Rail": item.Rail,
                  "Forecasted Bus": item.Bus,
                  "Forecasted Bike": item.Bike,
                  "Forecasted Walk": item.Walk,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted Car"];
                  delete item["Forecasted Rail"];
                  delete item["Forecasted Bus"];
                  delete item["Forecasted Bike"];
                  delete item["Forecasted Walk"];
                }
              });

              this.setState({
                plotType2: "transportation",
              });
              break;
            case "districtcost":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted Corbusville"];
                  delete item["Forecasted Downtown"];
                  delete item["Forecasted HowardGardens"];
                  delete item["Forecasted JacobsHill"];
                  delete item["Forecasted MosesGulch"];
                }
              });

              this.setState({
                plotType2: "districtcost",
              });
              break;
            case "citycost":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted City"];
                }
              });

              this.setState({
                plotType2: "citycost",
              });
              break;
            case "districtrevenue":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted Corbusville"];
                  delete item["Forecasted Downtown"];
                  delete item["Forecasted HowardGardens"];
                  delete item["Forecasted JacobsHill"];
                  delete item["Forecasted MosesGulch"];
                }
              });

              this.setState({
                plotType2: "districtrevenue",
              });
              break;
            case "cityrevenue":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted City"];
                }
              });

              this.setState({
                plotType2: "cityrevenue",
              });
              break;
            default:
              break;
          }
          // console.log(newFormattedMetric);
        }
        this.setState({
          selectedPlotData2: newFormattedMetric,
        });
        metricsPlot = newFormattedMetric;
        sessionStorage.setItem("selectedPlot2", e.target.value);
      }
    }
    for (let item in this.state.forecastJSON) {
      // console.log(e.target.value);
      // console.log(item);
      if (item === e.target.value) {
        // console.log(item);
        // console.log(
        //   "After plot selection in onChange Function:  ",
        //   this.state.forecastJSON[item]
        // );
        // console.log(
        //   "Searching for type:  ",
        //   this.state.forecastJSON[item][0].type
        // );

        let newFormattedMetric;
        if (this.state.forecastJSON[item]) {
          switch (this.state.forecastJSON[item][0].type) {
            case "city":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => delete item.City);
              this.setState({
                plotType2: "city",
              });
              break;
            case "district":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => delete item.Corbusville);
              newFormattedMetric.forEach((item) => delete item.Downtown);

              newFormattedMetric.forEach((item) => delete item.HowardGardens);

              newFormattedMetric.forEach((item) => delete item.JacobsHill);

              newFormattedMetric.forEach((item) => delete item.MosesGulch);

              this.setState({
                plotType2: "district",
              });

              break;
            case "transportation":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Walk": item.Walk,
                  "Forecasted Car": item.Car,
                  "Forecasted Rail": item.Rail,
                  "Forecasted Bus": item.Bus,
                  "Forecasted Bike": item.Bike,
                })
              );
              newFormattedMetric.forEach((item) => delete item.Car);
              newFormattedMetric.forEach((item) => delete item.Rail);

              newFormattedMetric.forEach((item) => delete item.Bus);

              newFormattedMetric.forEach((item) => delete item.Bike);

              newFormattedMetric.forEach((item) => delete item.Walk);

              this.setState({
                plotType2: "transportation",
              });

              break;
            case "districtcost":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => delete item.Corbusville);
              newFormattedMetric.forEach((item) => delete item.Downtown);

              newFormattedMetric.forEach((item) => delete item.HowardGardens);

              newFormattedMetric.forEach((item) => delete item.JacobsHill);

              newFormattedMetric.forEach((item) => delete item.MosesGulch);

              this.setState({
                plotType2: "districtcost",
              });
              break;
            case "citycost":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => delete item.City);
              this.setState({
                plotType2: "citycost",
              });
              break;
            case "districtrevenue":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => delete item.Corbusville);
              newFormattedMetric.forEach((item) => delete item.Downtown);

              newFormattedMetric.forEach((item) => delete item.HowardGardens);

              newFormattedMetric.forEach((item) => delete item.JacobsHill);

              newFormattedMetric.forEach((item) => delete item.MosesGulch);

              this.setState({
                plotType2: "districtrevenue",
              });
              break;
            case "cityrevenue":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => delete item.City);
              this.setState({
                plotType2: "cityrevenue",
              });
              break;
            default:
              break;
          }
          // console.log(newFormattedMetric);
        }

        // console.log(metricsPlot);
        this.setState({
          selectedForecastPlotData2: newFormattedMetric,
          combinedPlotData2: metricsPlot.concat(newFormattedMetric),
        });
        sessionStorage.setItem("selectedForecastPlotData2", e.target.value);
        sessionStorage.setItem("selectedPlot2", e.target.value);
      }
    }
  };

  onNavSelect = (id) => {
    // console.log("Inside District Dashboard, id:  ", id);
    this.setState({ policyNavSelection: id, districtSubPolicy: "" });
    sessionStorage.setItem("policyheading", id.toLowerCase());
  };

  onDistrictPlotChange = (e) => {
    let metricsPlot;
    let testPlot;
    this.setState({
      combinedDistrictPlotData: [],
      selectedDistrictPlotData: [],
      selectedForecastDistrictPlotData: [],
    });

    const { name, value } = e.target;

    if (e.target.value) {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }

    for (let item in this.state.metricsJSON) {
      if (item === e.target.value) {
        // console.log(item);
        // console.log(
        //   "After plot selection in onChange Function:  ",
        //   this.state.metricsJSON[item]
        // );
        // console.log(
        //   "Searching for type:  ",
        //   this.state.metricsJSON[item][0].type
        // );
        let newFormattedMetric;

        if (this.state.metricsJSON[item]) {
          switch (this.state.metricsJSON[item][0].type) {
            case "city":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted City"];
                }
              });

              this.setState({
                districtPlotType: "city",
              });
              break;
            case "district":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted Corbusville"];
                  delete item["Forecasted Downtown"];
                  delete item["Forecasted HowardGardens"];
                  delete item["Forecasted JacobsHill"];
                  delete item["Forecasted MosesGulch"];
                }
              });

              this.setState({
                districtPlotType: "district",
              });
              break;
            case "transportation":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Car": item.Car,
                  "Forecasted Rail": item.Rail,
                  "Forecasted Bus": item.Bus,
                  "Forecasted Bike": item.Bike,
                  "Forecasted Walk": item.walk,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted Car"];
                  delete item["Forecasted Rail"];
                  delete item["Forecasted Bus"];
                  delete item["Forecasted Bike"];
                  delete item["Forecasted Walk"];
                }
              });

              this.setState({
                districtPlotType: "transportation",
              });
              break;
            case "districtcost":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted Corbusville"];
                  delete item["Forecasted Downtown"];
                  delete item["Forecasted HowardGardens"];
                  delete item["Forecasted JacobsHill"];
                  delete item["Forecasted MosesGulch"];
                }
              });

              this.setState({
                districtPlotType: "districtcost",
              });
              break;
            case "citycost":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted City"];
                }
              });

              this.setState({
                districtPlotType: "citycost",
              });
              break;
            case "districtrevenue":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted Corbusville"];
                  delete item["Forecasted Downtown"];
                  delete item["Forecasted HowardGardens"];
                  delete item["Forecasted JacobsHill"];
                  delete item["Forecasted MosesGulch"];
                }
              });

              this.setState({
                districtPlotType: "districtrevenue",
              });
              break;
            case "cityrevenue":
              newFormattedMetric = this.state.metricsJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => {
                // console.log(typeof item.year);
                // console.log(typeof sessionStorage.getItem("previous_year"));
                if (
                  item.year !==
                  parseInt(sessionStorage.getItem("previous_year"))
                ) {
                  // console.log(item.year);
                  delete item["Forecasted City"];
                }
              });

              this.setState({
                districtPlotType: "cityrevenue",
              });
              break;
            default:
              break;
          }
        }
        this.setState({
          selectedDistrictPlotData: newFormattedMetric,
        });
        metricsPlot = newFormattedMetric;
        testPlot = newFormattedMetric;
        sessionStorage.setItem(`selectedDistrictPlot`, e.target.value);
      }
    }

    for (let item in this.state.forecastJSON) {
      // console.log(e.target.value);
      // console.log(item);
      if (item === e.target.value) {
        // console.log(item);
        // console.log(
        //   "After plot selection in onChange Function:  ",
        //   this.state.forecastJSON[item]
        // );
        // console.log(
        //   "Searching for type:  ",
        //   this.state.forecastJSON[item][0].type
        // );

        let newFormattedMetric;

        if (this.state.forecastJSON[item]) {
          switch (this.state.forecastJSON[item][0].type) {
            case "city":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => delete item.City);
              this.setState({
                districtPlotType: "city",
              });
              break;
            case "district":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => delete item.Corbusville);
              newFormattedMetric.forEach((item) => delete item.Downtown);

              newFormattedMetric.forEach((item) => delete item.HowardGardens);

              newFormattedMetric.forEach((item) => delete item.JacobsHill);

              newFormattedMetric.forEach((item) => delete item.MosesGulch);

              this.setState({
                districtPlotType: "district",
              });

              break;
            case "transportation":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Walk": item.Walk,
                  "Forecasted Car": item.Car,
                  "Forecasted Rail": item.Rail,
                  "Forecasted Bus": item.Bus,
                  "Forecasted Bike": item.Bike,
                })
              );
              newFormattedMetric.forEach((item) => delete item.Car);
              newFormattedMetric.forEach((item) => delete item.Rail);

              newFormattedMetric.forEach((item) => delete item.Bus);

              newFormattedMetric.forEach((item) => delete item.Bike);

              newFormattedMetric.forEach((item) => delete item.Walk);

              this.setState({
                districtPlotType: "transportation",
              });

              break;
            case "districtcost":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => delete item.Corbusville);
              newFormattedMetric.forEach((item) => delete item.Downtown);

              newFormattedMetric.forEach((item) => delete item.HowardGardens);

              newFormattedMetric.forEach((item) => delete item.JacobsHill);

              newFormattedMetric.forEach((item) => delete item.MosesGulch);

              this.setState({
                districtPlotType: "districtcost",
              });
              break;
            case "citycost":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => delete item.City);
              this.setState({
                districtPlotType: "citycost",
              });
              break;
            case "districtrevenue":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item, index) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted Corbusville": item.Corbusville,
                  "Forecasted Downtown": item.Downtown,
                  "Forecasted HowardGardens": item.HowardGardens,
                  "Forecasted JacobsHill": item.JacobsHill,
                  "Forecasted MosesGulch": item.MosesGulch,
                })
              );
              newFormattedMetric.forEach((item) => delete item.Corbusville);
              newFormattedMetric.forEach((item) => delete item.Downtown);

              newFormattedMetric.forEach((item) => delete item.HowardGardens);

              newFormattedMetric.forEach((item) => delete item.JacobsHill);

              newFormattedMetric.forEach((item) => delete item.MosesGulch);

              this.setState({
                districtPlotType: "districtrevenue",
              });
              break;
            case "cityrevenue":
              newFormattedMetric = this.state.forecastJSON[item].map(
                (item) => ({
                  ...item,
                  year: parseInt(item.year),
                  "Forecasted City": item.City,
                })
              );
              newFormattedMetric.forEach((item) => delete item.City);
              this.setState({
                districtPlotType: "cityrevenue",
              });
              break;
            default:
              break;
          }
          // console.log(newFormattedMetric);
        }

        // console.log(metricsPlot);
        this.setState({
          selectedForecastDistrictPlotData: newFormattedMetric,
          combinedDistrictPlotData: metricsPlot.concat(newFormattedMetric),
        });
        sessionStorage.setItem(`selectedForecastDistrictPlot`, e.target.value);
        // console.log(testPlot.concat(newFormattedMetric));
      }
    }
  };

  onSortUp = (event, sortKey) => {
    event.preventDefault();
    // console.log("SortKey: " + sortKey);
    // console.log(
    //   "This is the table: " + JSON.stringify(this.state.everythingTable)
    // );
    let mappedDescription = this.state.everythingTable.map((item, i) => {
      // console.log(Object.keys(item)[0], i);
      return { name: Object.keys(item)[0], data: Object.values(item)[0] };
    });
    // console.log(mappedDescription);

    let mappedDistrict = this.state.everythingTable.map((item, i) => {
      // console.log(Object.keys(item)[0], i);

      if (Object.values(item)[0][0].City) {
        return {
          name: Object.keys(item)[0],
          year: Object.values(item)[0].map((item) => {
            return item.year;
          }),
          City: Object.values(item)[0].map((item) => {
            return item.City;
          }),
        };
      } else {
        return {
          name: Object.keys(item)[0],
          Corbusville: Object.values(item)[0].map((item) => {
            return item.Corbusville;
          }),
          name: Object.keys(item)[0],
          Downtown: Object.values(item)[0].map((item) => {
            return item.Downtown;
          }),
          name: Object.keys(item)[0],
          HowardGardens: Object.values(item)[0].map((item) => {
            return item.HowardGardens;
          }),
          name: Object.keys(item)[0],
          JacobsHill: Object.values(item)[0].map((item) => {
            return item.JacobsHill;
          }),
          name: Object.keys(item)[0],
          MosesGulch: Object.values(item)[0].map((item) => {
            return item.MosesGulch;
          }),
        };
      }
    });
    // console.log(mappedDistrict);

    if (sortKey === "description") {
      mappedDescription.sort((a, b) => (a.name > b.name ? 1 : -1));
      // console.log(mappedDescription);

      let newMap = mappedDescription.map((item) => {
        let mapObj = {};
        mapObj[item.name] = item.data;
        // console.log(mapObj);
        return mapObj;
      });
      // console.log(newMap);
      this.setState({
        everythingTable: newMap,
      });
    }

    if (sortKey === "district") {
      mappedDistrict.sort((a, b) => (a > b ? 1 : -1));
      // console.log(mappedDistrict);

      let newMap = mappedDistrict.map((item) => {
        // console.log(item);
        let mapObj = {};
        mapObj[item.name] = item.data;
        // console.log(mapObj);
        return mapObj;
      });
      // console.log(newMap);
      this.setState({
        everythingTable: newMap,
      });
    }
  };

  onSortDown = (event, sortKey) => {
    event.preventDefault();
    // console.log("SortKey: " + sortKey);
    // console.log(
    //   "This is the table: " +
    //     JSON.stringify(Object.keys(this.state.everythingTable))
    // );
    let mapped = this.state.everythingTable.map((item, i) => {
      // console.log(Object.keys(item)[0], i);
      return { name: Object.keys(item)[0], data: Object.values(item)[0] };
    });
    // console.log(mapped);
    if (sortKey === "description") {
      mapped.sort((a, b) => (b.name > a.name ? 1 : -1));
      // console.log(mapped);

      let newMap = mapped.map((item) => {
        let mapObj = {};
        mapObj[item.name] = item.data;
        // console.log(mapObj);
        return mapObj;
      });
      // console.log(newMap);
      this.setState({
        everythingTable: newMap,
      });
    }
  };

  openNav = (e) => {
    e.preventDefault();
    // console.log("opened")
    this.setState({
      navWidth: 0,
    });
  };

  closeNav = (e) => {
    // console.log("closed")
    e.preventDefault();
    this.setState({
      navWidth: -400,
    });
  };

  closeMessage = (e) => {
    e.preventDefault();
    this.messageTemporary(500);
  };

  render() {
    // console.log(this.state.Commercial)
    // console.log(this.state.engagementSuspended);
    // console.log(this.state.suspendButton);
    const navLinks = [
      {
        name: "city",
        displayName: "City View",
        href: "/city",
        content: City,
      },
      // {
      //   name: "district",
      //   displayName: "District",
      //   href: "/district",
      //   content: District
      // }
      // {
      //     name: 'Frank Batten School',
      //     href: 'https://batten.virginia.edu',
      //     icon: 'iconBatten',
      //     content: LINKS,
      // },
      // {
      //     name: 'CLSG',
      //     href: 'https://www.clsgbatten.org',
      //     icon: 'iconClsg',
      //     content: LINKS,
      // },
    ];

    return (
      <div>
        <Messages
          messageDivVisibility={this.state.messageDivVisibility}
          messageMessage={this.state.messageMessage}
          messageType={this.state.messageType}
          messageFunction={this.state.messageFunction}
          closeMessage={this.closeMessage}
          logoutYes={this.logoutYes}
          onDistrictSubmitHandler={this.onDistrictSubmitHandler}
          onCitySubmitHandler={this.onCitySubmitHandler}
          onEngagementSubmitHandler={this.onEngagementSubmitHandler}
        />
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={this.state.snackOpen}
          ContentProps={{
            "aria-describedby": "message-id",
          }}
          className={this.state.snackType}
          autoHideDuration={this.state.snackAutoHideDuration}
          onClose={this.handleClose}
          message={<span id="message-id">{this.state.snackMsg}</span>}
          action={
            this.state.snackType === "snack-start"
              ? [
                  <Button
                    key="yes"
                    color="inherit"
                    onClick={this.startScenarioYes}
                  >
                    Yes
                  </Button>,
                  <Button key="no" color="inherit" onClick={this.handleClose}>
                    No
                  </Button>,
                ]
              : this.state.snackType === "snack-logout"
                ? [
                    <Button key="yes" color="inherit" onClick={this.logoutYes}>
                      Yes
                    </Button>,
                    <Button key="no" color="inherit" onClick={this.handleClose}>
                      No
                    </Button>,
                  ]
                : this.state.snackType === "city-snack-submit"
                  ? [
                      <Button
                        key="yes"
                        color="inherit"
                        onClick={this.onCitySubmitHandler}
                      >
                        Yes
                      </Button>,
                      <Button
                        key="no"
                        color="inherit"
                        onClick={this.handleClose}
                      >
                        No
                      </Button>,
                    ]
                  : this.state.snackType === "district-snack-submit"
                    ? [
                        <Button
                          key="yes"
                          color="inherit"
                          onClick={this.onDistrictSubmitHandler}
                        >
                          Yes
                        </Button>,
                        <Button
                          key="no"
                          color="inherit"
                          onClick={this.handleClose}
                        >
                          No
                        </Button>,
                      ]
                    : this.state.snackType === "engagement-snack-submit"
                      ? [
                          <Button
                            key="yes"
                            color="inherit"
                            onClick={this.onEngagementSubmitHandler}
                          >
                            Yes
                          </Button>,
                          <Button
                            key="no"
                            color="inherit"
                            onClick={this.handleClose}
                          >
                            No
                          </Button>,
                        ]
                      : []
          }
        />
        <div
          id="mySidenav"
          className="sidenav"
          style={{ right: `${this.state.navWidth}px` }}
        >
          <a
            href="javascript:void(0)"
            className="closebtn"
            onClick={(e) => this.closeNav(e)}
          >
            &times;
          </a>
          <div className="logoutDiv">
            <button className="logout" onClick={(e) => this.logoutPrevent(e)}>
              {this.origin === "CLSG" ? "Return to Account" : "Logout"}
            </button>
          </div>
          <p>Resources</p>
          <hr />
          <a
            href="https://res.cloudinary.com/uvasims/raw/upload/v1581527162/policy_dictionary.pdf"
            target="_blank"
          >
            Policy Dictionary
          </a>
          {/* <a href="#">References</a> */}
          <p>Links</p>
          <hr />
          {this.state.navLinks.map((item, index) => (
            <a key={index} href={item.href} target={item.target}>
              <span className={item.icon} />
              {"  "}
              {item.name}
            </a>
          ))}
        </div>
        {this.student_is_manager === "true" ? (
          <div className="nav flex flex-auto">
            <div className="sudoLogo" />
            <div className="metroLogo" />
            {this.student_is_manager === "true" ? (
              <h3 className="manager">{this.student_role}</h3>
            ) : (
              <h3 className="notManager">{this.student_role}</h3>
            )}
            {/* <div className="engagement">
              <p>Projected/Current City Engagement Credits:</p>{" "}
              <span>
                {this.state.currentEngagement}/{this.state.totalEngagement}
              </span>
            </div> */}
            <div className="engagement">
              <p>
                Current Engagement: <span>{this.state.totalEngagement}</span>
              </p>
              <p>
                Projected Engagement:{" "}
                <span>{this.state.currentEngagement}</span>
              </p>
            </div>

            {window.location.href.split("/")[5] ? (
              <h1 className="logo">
                {window.location.href
                  .split("/")[5]
                  .replace("_", " ")
                  .toUpperCase()}{" "}
                {this.state.currentYear
                  ? ` - ${this.state.currentYear - 1}`
                  : null}
              </h1>
            ) : (
              <h1 className="logo">
                CITY DASHBOARD
                {this.state.currentYear
                  ? ` - ${this.state.currentYear - 1}`
                  : null}{" "}
              </h1>
            )}
            <ul className="dashboardLink">
              {navLinks.map((nav, index) => (
                <li key={index}>
                  <Link
                    to={"/game/" + nav.name}
                    onClick={(e) => this.setContent(e, nav)}
                    name={nav.name}
                  >
                    {nav.displayName}
                  </Link>
                </li>
              ))}
              <li className="headerDivider" />
              <li onClick={(e) => this.openAccountBook(e)}>Account Book</li>
              <li onClick={(e) => this.openPolicyHistory(e)}>Policy History</li>
            </ul>
            <button
              className="logout"
              style={{ marginLeft: "auto" }}
              onClick={(e) => this.logoutPrevent(e)}
            >
              {this.origin === "CLSG" ? "Return to Account" : "Logout"}
            </button>
          </div>
        ) : (
          <div className="navNotManager flex flex-auto">
            <div className="sudoLogo" />
            <div className="metroLogo" />
            {this.student_is_manager === "true" ? (
              <h3 className="manager">{this.student_role}</h3>
            ) : (
              <h3 className="notManager">{this.student_role}</h3>
            )}
            {/* <div className="engagement">
              <p>Projected/Current City Engagement Credits:</p>{" "}
              <span>
                {this.state.currentEngagement}/{this.state.totalEngagement}
              </span>
            </div> */}
            <div className="engagement">
              <p>
                Current Engagement: <span>{this.state.totalEngagement}</span>
              </p>
              <p>
                Projected Engagement:{" "}
                <span>{this.state.currentEngagement}</span>
              </p>
            </div>

            {window.location.href.split("/")[5] ? (
              <h1 className="logo">
                METRO -{" "}
                {window.location.href
                  .split("/")[5]
                  .replace("_", " ")
                  .toUpperCase()}{" "}
                {this.state.currentYear
                  ? ` - ${this.state.currentYear - 1}`
                  : null}
              </h1>
            ) : (
              <h1 className="logo">
                METRO - CITY
                {this.state.currentYear
                  ? ` - ${this.state.currentYear - 1}`
                  : null}{" "}
              </h1>
            )}
            <ul className="dashboardLink">
              {navLinks.map((nav, index) => (
                <li key={index}>
                  <Link
                    to={"/game/" + nav.name}
                    onClick={(e) => this.setContent(e, nav)}
                    name={nav.name}
                  >
                    {nav.displayName}
                  </Link>
                </li>
              ))}
              <li class="headerDivider" />
              <li onClick={(e) => this.openAccountBook(e)}>Account Book</li>
              <li onClick={(e) => this.openPolicyHistory(e)}>Policy History</li>
            </ul>
            <button
              className="logout"
              style={{ marginLeft: "auto" }}
              onClick={(e) => this.logoutPrevent(e)}
            >
              {this.origin === "CLSG" ? "Return to Account" : "Logout"}
            </button>
          </div>
        )}
        <div className="backgroundPlay" />
        <CityDashboard
          display={this.state.selected === "city" ? "show" : ""}
          engagementFunc={this.engagementFunc}
          setTotalEngagement={this.setTotalEngagement}
          setEngagement={this.setEngagement}
          metricsJSON={this.state.metricsJSON}
          forecastJSON={this.state.forecastJSON}
          onPlotChange1={this.onPlotChange1}
          onPlotChange2={this.onPlotChange2}
          metricsSelections={this.state.metricsSelections}
          costSelections={this.state.costSelections}
          revenueSelections={this.state.revenueSelections}
          selectedMetric1={this.state.selectedMetric1}
          selectedMetric2={this.state.selectedMetric2}
          combinedPlotData1={this.state.combinedPlotData1}
          combinedPlotData2={this.state.combinedPlotData2}
          selectionAvailable={this.state.selectionAvailable}
          plotType1={this.state.plotType1}
          plotType2={this.state.plotType2}
          selectedPlotData1={this.state.selectedPlotData1}
          selectedPlotData2={this.state.selectedPlotData2}
          cityCurrent={this.state.cityCurrent}
          suspendButton={this.state.suspendButton}
          onCityPolicyClickHandler={this.onCityPolicyClickHandler}
          citySubPolicyDefaultValue={this.state.citySubPolicyDefaultValue}
          citySubPolicyPrevtValue={this.state.citySubPolicyPrevtValue}
          citySubPolicy={this.state.citySubPolicy}
          cityPolicies={this.state.cityPolicies}
          onCitySelectHandler={this.onCitySelectHandler}
          forecasting={this.state.forecasting}
          onForecastHandler={this.onForecastHandler}
          onCitySubmitHandler={this.onCitySubmitHandler}
          remainingForecastAttempts={this.state.remainingForecastAttempts}
          submitting={this.state.submitting}
          onForecastSubmit={this.onForecastSubmit}
          citySubmitPrevent={this.citySubmitPrevent}
          disabledButton={this.state.disabledButton}
          toolTipMessage={this.state.toolTipMessage}
          policySuspended={this.state.policySuspended}
          currentYear={this.state.currentYear}
        />
        <DistrictDashboard
          display={this.state.selected === "district" ? "show" : ""}
          districtName={this.state.districtName}
          student_is_manager={this.student_is_manager}
          engagementFunc={this.engagementFunc}
          setTotalEngagement={this.setTotalEngagement}
          setEngagement={this.setEngagement}
          InformObj={this.state.InformObj}
          ConsultObj={this.state.ConsultObj}
          InvolveObj={this.state.InvolveObj}
          CollaborateObj={this.state.CollaborateObj}
          Inform={this.state.Inform}
          Consult={this.state.Consult}
          Involve={this.state.Involve}
          Collaborate={this.state.Collaborate}
          InformSubmitted={this.state.InformSubmitted}
          ConsultSubmitted={this.state.ConsultSubmitted}
          InvolveSubmitted={this.state.InvolveSubmitted}
          CollaborateSubmitted={this.state.CollaborateSubmitted}
          engageObj={this.state.engageObj}
          metricsJSON={this.state.metricsJSON}
          forecastJSON={this.state.forecastJSON}
          onPlotChange1={this.onPlotChange1}
          onPlotChange2={this.onPlotChange2}
          metricsSelections={this.state.metricsSelections}
          costSelections={this.state.costSelections}
          revenueSelections={this.state.revenueSelections}
          selectedMetric1={this.state.selectedMetric1}
          selectedMetric2={this.state.selectedMetric2}
          combinedPlotData1={this.state.combinedPlotData1}
          combinedPlotData2={this.state.combinedPlotData2}
          selectionAvailable={this.state.selectionAvailable}
          plotType1={this.state.plotType1}
          plotType2={this.state.plotType2}
          selectedPlotData1={this.state.selectedPlotData1}
          selectedPlotData2={this.state.selectedPlotData2}
          cityCurrent={this.state.cityCurrent}
          suspendButton={this.state.suspendButton}
          combinedDistrictPlotData={this.state.combinedDistrictPlotData}
          selectedDistrictPlotData={this.state.selectedDistrictPlotData}
          selectedForecastDistrictPlotData={
            this.props.selectedForecastDistrictPlotData
          }
          onDistrictPlotChange={this.onDistrictPlotChange}
          districtPlotType={this.state.districtPlotType}
          remainingForecastAttempts={this.state.remainingForecastAttempts}
          onNavSelect={this.onNavSelect}
          policyNavSelection={this.state.policyNavSelection}
          setZones={this.setZones}
          onDistrictPolicyClickHandler={this.onDistrictPolicyClickHandler}
          districtSubPolicyDefaultValue={
            this.state.districtSubPolicyDefaultValue
          }
          districtSubPolicyPrevtValue={this.state.districtSubPolicyPrevtValue}
          onDistrictSubmitHandler={this.onDistrictSubmitHandler}
          onPageClick={this.onPageClick}
          start={this.state.start}
          stop={this.state.stop}
          onZoneChange={this.onZoneChange}
          districtPolicyData={this.state.districtPolicyData}
          Commercial={this.state.Commercial}
          Green={this.state.Green}
          Mixed={this.state.Mixed}
          Residential={this.state.Residential}
          Parking={this.state.Parking}
          corbusville={this.state.corbusville}
          downtown={this.state.downtown}
          howard_gardens={this.state.howard_gardens}
          jacobs_hill={this.state.jacobs_hill}
          moses_gulch={this.state.moses_gulch}
          onDistrictSelectHandler={this.onDistrictSelectHandler}
          currentYear={this.state.currentYear}
          previousYear={this.state.previousYear}
          districtSubPolicy={this.state.districtSubPolicy}
          onsubmitSyncToClients={this.onsubmitSyncToClients}
          setDistrictDefaults={this.setDistrictDefaults}
          Total={this.state.Total}
          disabledButton={this.state.disabledButton}
          engagementData={this.state.engagementData}
          districtCurrent={this.state.districtCurrent}
          parkingZone={this.state.parkingZone}
          submitting={this.state.submitting}
          engagementSubPolicy={this.state.engagementSubPolicy}
          districtEngagementData={this.state.districtEngagementData}
          onEngagementClickHandler={this.onEngagementClickHandler}
          ConsultDisabled={this.state.ConsultDisabled}
          InvolveDisabled={this.state.InvolveDisabled}
          CollaborateDisabled={this.state.CollaborateDisabled}
          // Inform={this.state.Inform}
          InformTarget={this.state.InformTarget}
          InformLock={this.state.InformLock}
          InformMax={this.state.InformMax}
          InformMaxReached={this.state.InformMaxReached}
          // InformObj={this.state.InformObj}
          // InformSubmitted={this.state.InformSubmitted}
          // Consult={this.state.Consult}
          ConsultTarget={this.state.ConsultTarget}
          ConsultLock={this.state.ConsultLock}
          ConsultMax={this.state.ConsultMax}
          ConsultMaxReached={this.state.ConsultMaxReached}
          // ConsultObj={this.state.ConsultObj}
          // ConsultSubmitted={this.state.ConsultSubmitted}
          // Involve={this.state.Involve}
          InvolveTarget={this.state.InvolveTarget}
          InvolveLock={this.state.InvolveLock}
          InvolveMax={this.state.InvolveMax}
          InvolveMaxReached={this.state.InvolveMaxReached}
          // InvolveObj={this.state.InvolveObj}
          // InvolveSubmitted={this.state.InvolveSubmitted}
          // Collaborate={this.state.Collaborate}
          CollaborateTarget={this.state.CollaborateTarget}
          CollaborateLock={this.state.CollaborateLock}
          CollaborateMax={this.state.CollaborateMax}
          // CollaborateObj={this.state.CollaborateObj}
          CollaborateMaxReached={this.state.CollaborateMaxReached}
          // CollaborateSubmitted={this.state.CollaborateSubmitted}
          onEngagementSubmitHandler={this.onEngagementSubmitHandler}
          onEngagementSelectHandler={this.onEngagementSelectHandler}
          fact_sheets={this.state.fact_sheets}
          website={this.state.website}
          newsletter={this.state.newsletter}
          open_house={this.state.open_house}
          surveys={this.state.surveys}
          focus_groups={this.state.focus_groups}
          public_meetings={this.state.public_meetings}
          public_forums={this.state.public_forums}
          utilizing_social_media={this.state.utilizing_social_media}
          deliberative_polling={this.state.deliberative_polling}
          workshops={this.state.workshops}
          charrettes={this.state.charrettes}
          consensus_building={this.state.consensus_building}
          citizens_juries={this.state.citizens_juries}
          advisory_board={this.state.advisory_board}
          onForecastSubmit={this.onForecastSubmit}
          forecasting={this.state.forecasting}
          districtSubmitPrevent={this.districtSubmitPrevent}
          engagementSubmitPrevent={this.engagementSubmitPrevent}
          engagementSuspended={this.state.engagementSuspended}
          toolTipMessage={this.state.toolTipMessage}
          policySuspended={this.state.policySuspended}
          selectedDistrictMetric={this.state.selectedDistrictMetric}
        />
        <AccountBook
          everythingTable={this.state.everythingTable}
          display={this.state.accountBook ? "show" : ""}
          closeModal={this.closeModal}
          onSortUp={this.onSortUp}
          onSortDown={this.onSortDown}
        />
        <PolicyHistory
          allPolicyData={this.state.allPolicyData}
          policyJSON={policyJSON}
          display={this.state.policyHistory ? "show" : ""}
          closeModal={this.closeModal}
        />
        <h1 className="svgNavTitle">District Views</h1>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1920 263"
          preserveAspectRatio="xMidYMid meet"
          id="svgNav"
        >
          <g id="Water">
            <rect
              y={-500}
              x={-1300}
              width="400vw"
              height="200vh"
              style={{ fill: "#d4e5f4" }}
            />
          </g>
          <g id="Earth">
            <g id="Moses_Gulch" data-name="Moses Gulch">
              <path
                id="corbusville"
                d="M136.23-774.72a14,14,0,0,1,17.06-10L958.83-576.68a14,14,0,0,1,10,17l-120.37,466a14,14,0,0,1-17.06,10.06l-255.11-65.9a14,14,0,0,0-17.05,10.05L505.73,67.9A14.05,14.05,0,0,0,515.79,85l255.1,65.89A14.05,14.05,0,0,1,781,167.91L692.41,510.63a14,14,0,0,1-17,10.06L-130.18,312.6a14,14,0,0,1-10.06-17.06Z"
                style={
                  this.state.CorbusvilleHover === false
                    ? { fill: "#f4f9f5" }
                    : { fill: "#ccc2A6" }
                }
                onMouseOver={(e) => this.onMouseOverCorbusvilleHandler(e)}
                onMouseOut={(e) => this.onMouseOutCorbusvilleHandler(e)}
                onClick={(e) => this.onClickHandler(e)}
              />
              <path
                d="M136.23-774.72a14,14,0,0,1,17.06-10L958.83-576.68a14,14,0,0,1,10,17l-120.37,466a14,14,0,0,1-17.06,10.06l-255.11-65.9a14,14,0,0,0-17.05,10.05L505.73,67.9A14.05,14.05,0,0,0,515.79,85l255.1,65.89A14.05,14.05,0,0,1,781,167.91L692.41,510.63a14,14,0,0,1-17,10.06L-130.18,312.6a14,14,0,0,1-10.06-17.06Z"
                style={{
                  fill: "none",
                  stroke: "#d8e9d7",
                  strokeMiterlimit: 10,
                  strokeWidth: "7px",
                }}
              />
            </g>
            <path
              id="jacobs_hill"
              d="M1013.93-562.45a14.05,14.05,0,0,0-17.06,10.05l-96.36,373a14,14,0,0,0,10,17.06l238.78,61.68a14,14,0,0,1,10.05,17.05L1117.32,79.29a14,14,0,0,0,10.06,17.06l460.35,118.92a14,14,0,0,0,17.06-10.06l145.43-563a14,14,0,0,0-10-17.06Z"
              style={
                this.state.JacobsHover === false
                  ? { fill: "#f4f9f5" }
                  : { fill: "#ccc2A6" }
              }
              onMouseOver={(e) => this.onMouseOverJacobsHandler(e)}
              onMouseOut={(e) => this.onMouseOutJacobsHandler(e)}
              onClick={(e) => this.onClickHandler(e)}
            />
            <path
              d="M1013.93-562.45a14.05,14.05,0,0,0-17.06,10.05l-96.36,373a14,14,0,0,0,10,17.06l238.78,61.68a14,14,0,0,1,10.05,17.05L1117.32,79.29a14,14,0,0,0,10.06,17.06l460.35,118.92a14,14,0,0,0,17.06-10.06l145.43-563a14,14,0,0,0-10-17.06Z"
              style={{
                fill: "none",
                stroke: "#d8e9d7",
                strokeMiterlimit: 10,
                strokeWidth: "6px",
              }}
            />
            <path
              id="downtown"
              d="M885.68-121.94A14,14,0,0,1,902.73-132l213.12,55.05a14.05,14.05,0,0,1,10.06,17.06l-64.52,249.76A14.08,14.08,0,0,1,1044.33,200L553.85,74.15a14,14,0,0,1-10.06-17l42.07-162.86A14.23,14.23,0,0,1,603-115.94L853.66-54a14.21,14.21,0,0,0,17.09-10.2Z"
              style={
                this.state.DowntownHover === false
                  ? { fill: "#f4f9f5" }
                  : { fill: "#ccc2A6" }
              }
              onMouseOver={(e) => this.onMouseOverDowntownHandler(e)}
              onMouseOut={(e) => this.onMouseOutDowntownHandler(e)}
              onClick={(e) => this.onClickHandler(e)}
            />
            <path
              d="M885.68-121.94A14,14,0,0,1,902.73-132l213.12,55.05a14.05,14.05,0,0,1,10.06,17.06l-64.52,249.76A14.08,14.08,0,0,1,1044.33,200L553.85,74.15a14,14,0,0,1-10.06-17l42.07-162.86A14.23,14.23,0,0,1,603-115.94L853.66-54a14.21,14.21,0,0,0,17.09-10.2Z"
              style={{
                fill: "none",
                stroke: "#d8e9d7",
                strokeMiterlimit: 10,
                strokeWidth: "6px",
              }}
            />
            <path
              id="howard_gardens"
              d="M807,175.26a13.79,13.79,0,0,1,16.9-10L1065.7,228.8a14.22,14.22,0,0,0,17.23-10l20.8-76.12a14.27,14.27,0,0,1,17.25-10l769.89,199.63a14,14,0,0,1,10.05,17.07l-66.08,255.82a14,14,0,0,1-17.06,10L779,347a14.21,14.21,0,0,1-10.2-17.09Z"
              style={
                this.state.HowardHover === false
                  ? { fill: "#f4f9f5" }
                  : { fill: "#ccc2A6" }
              }
              onMouseOver={(e) => this.onMouseOverHowardHandler(e)}
              onMouseOut={(e) => this.onMouseOutHowardHandler(e)}
              onClick={(e) => this.onClickHandler(e)}
            />
            <path
              d="M807,175.26a13.79,13.79,0,0,1,16.9-10L1065.7,228.8a14.22,14.22,0,0,0,17.23-10l20.8-76.12a14.27,14.27,0,0,1,17.25-10l769.89,199.63a14,14,0,0,1,10.05,17.07l-66.08,255.82a14,14,0,0,1-17.06,10L779,347a14.21,14.21,0,0,1-10.2-17.09Z"
              style={{
                fill: "none",
                stroke: "#d8e9d7",
                strokeMiterlimit: 10,
                strokeWidth: "6px",
              }}
            />
            <rect
              id="moses_gulch"
              x="1545.36"
              y="-176.24"
              width="609.48"
              height="289.07"
              rx="14"
              transform="translate(1418.06 1767.52) rotate(-75.52)"
              style={
                this.state.MosesHover === false
                  ? { fill: "#f4f9f5" }
                  : { fill: "#ccc2A6" }
              }
              onMouseOver={(e) => this.onMouseOverMosesHandler(e)}
              onMouseOut={(e) => this.onMouseOutMosesHandler(e)}
              onClick={(e) => this.onClickHandler(e)}
            />
            <rect
              x="1545.36"
              y="-176.24"
              width="609.48"
              height="289.07"
              rx="14"
              transform="translate(1418.06 1767.52) rotate(-75.52)"
              style={{
                fill: "none",
                stroke: "#d8e9d7",
                strokeMiterlimit: 10,
                strokeWidth: "6px",
              }}
            />
            <rect
              x="1356.92"
              y="-36.13"
              width="139.85"
              height="139.72"
              rx="10"
              transform="translate(1037.31 1406.78) rotate(-75.52)"
              style={{ fill: "#d8e9d7" }}
            />
            <rect
              x="177.24"
              y="-137.22"
              width="304.74"
              height="279.43"
              rx="10"
              transform="translate(244.75 321.01) rotate(-75.52)"
              style={{ fill: "#d8e9d7" }}
            />
            <rect
              x="791.77"
              y="-139.57"
              width="50.09"
              height="337.25"
              rx="10"
              transform="translate(584.39 812.64) rotate(-75.52)"
              style={{ fill: "#d8e9d7" }}
            />
            <rect
              x="1668.73"
              y="99.9"
              width="110.63"
              height="96.36"
              rx="10"
              transform="translate(1149.47 1780.29) rotate(-75.52)"
              style={{ fill: "#d8e9d7" }}
            />
            <rect
              x="1313.88"
              y="69.98"
              width="121.06"
              height="464.92"
              rx="10"
              transform="translate(737.82 1557.53) rotate(-75.52)"
              style={{ fill: "#d8e9d7" }}
            />
          </g>
          <g id="Text">
            <text
              id="corbusville"
              transform="translate(141 186)"
              style={{
                fontSize: "54px",
                fill: "#333",
                fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
                fontWeight: "normal",
              }}
              onMouseOver={(e) => this.onMouseOverCorbusvilleHandler(e)}
              onClick={(e) => this.onClickHandler(e)}
            >
              Corbusville
            </text>
            <text
              id="downtown"
              transform="translate(597 88)"
              style={{
                fontSize: "54px",
                fill: "#333",
                fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
                fontWeight: "normal",
              }}
              onMouseOver={this.onMouseOverHandler}
              onClick={(e) => this.onClickHandler(e)}
            >
              Downtown
            </text>
            <text
              id="jacobs_hill"
              transform="translate(1239 88)"
              style={{
                fontSize: "54px",
                fill: "#333",
                fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
                fontWeight: "normal",
              }}
              onMouseOver={this.onMouseOverHandler}
              onClick={(e) => this.onClickHandler(e)}
            >
              Jacobs Hill
            </text>
            <text
              id="moses_gulch"
              transform="translate(1705 160)"
              style={{
                fontSize: "54px",
                fill: "#333",
                fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
                fontWeight: "normal",
              }}
              onMouseOver={this.onMouseOverHandler}
              onClick={(e) => this.onClickHandler(e)}
            >
              Moses
              <tspan
                id="moses_gulch"
                onMouseOver={this.onMouseOverHandler}
                onClick={(e) => this.onClickHandler(e)}
                x="0"
                y="64.8"
              >
                Gulch
              </tspan>
            </text>
            <text
              id="howard_gardens"
              transform="translate(1070 160)"
              style={{
                fontSize: "54px",
                fill: "#333",
                fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
                fontWeight: "normal",
              }}
              onMouseOver={this.onMouseOverHandler}
              onClick={(e) => this.onClickHandler(e)}
            >
              Howard
              <tspan
                id="howard_gardens"
                onMouseOver={this.onMouseOverHandler}
                onClick={(e) => this.onClickHandler(e)}
                x="0"
                y="64.8"
              >
                Gardens
              </tspan>
            </text>
            {/* <text
              id="City"
              transform="translate(-300 80)"
              style={{
                fontSize: "63px",
                fill: "#333",
                fontFamily: "'Helvetica Neue', Helvetica, Arial, sans-serif",
                fontWeight: "bold"
              }}
              onClick={e => this.onClickHandler(e)}
            >
              City Level 🏙️
            </text> */}
          </g>
        </svg>
        <br />
        <br />
        <br />
        <Footer />
      </div>
    );
  }
}

export default withRouter(Navigation);
